(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EasyBroadcast"] = factory();
	else
		root["EasyBroadcast"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Proto = __webpack_require__(1);
	exports.Proto = Proto;
	var Fatal_1 = __webpack_require__(20);
	exports.Fatal = Fatal_1.Fatal;
	var IceCandidate_1 = __webpack_require__(25);
	exports.getIceCandidates = IceCandidate_1.getIceCandidates;
	var Manager_1 = __webpack_require__(67);
	exports.Manager = Manager_1.Manager;
	var Stats_1 = __webpack_require__(79);
	exports.StatsPlayerState = Stats_1.StatsPlayerState;
	var messages = {};
	exports.Messages = messages;
	var context = __webpack_require__(88);
	context.keys().forEach(function (file) {
	    var messageName = file.substr(2, file.length - 5);
	    var obj = context(file);
	    if ((typeof obj === 'object') && (typeof obj[messageName] === 'function')) {
	        messages[messageName] = obj[messageName];
	    }
	});
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins*/
	"use strict";
	
	var $protobuf = __webpack_require__(2);
	
	// Common aliases
	var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
	
	// Exported root namespace
	var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
	
	$root.manager = (function() {
	
	    /**
	     * Namespace manager.
	     * @exports manager
	     * @namespace
	     */
	    var manager = {};
	
	    manager.ArgumentsBye = (function() {
	
	        /**
	         * Properties of an ArgumentsBye.
	         * @memberof manager
	         * @interface IArgumentsBye
	         * @property {string|null} [Reason] ArgumentsBye Reason
	         */
	
	        /**
	         * Constructs a new ArgumentsBye.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsBye.
	         * @implements IArgumentsBye
	         * @constructor
	         * @param {manager.IArgumentsBye=} [properties] Properties to set
	         */
	        function ArgumentsBye(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsBye Reason.
	         * @member {string} Reason
	         * @memberof manager.ArgumentsBye
	         * @instance
	         */
	        ArgumentsBye.prototype.Reason = "";
	
	        /**
	         * Creates a new ArgumentsBye instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {manager.IArgumentsBye=} [properties] Properties to set
	         * @returns {manager.ArgumentsBye} ArgumentsBye instance
	         */
	        ArgumentsBye.create = function create(properties) {
	            return new ArgumentsBye(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsBye message. Does not implicitly {@link manager.ArgumentsBye.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {manager.IArgumentsBye} message ArgumentsBye message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsBye.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Reason);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsBye message, length delimited. Does not implicitly {@link manager.ArgumentsBye.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {manager.IArgumentsBye} message ArgumentsBye message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsBye.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsBye message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsBye} ArgumentsBye
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsBye.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsBye();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Reason = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsBye message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsBye} ArgumentsBye
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsBye.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsBye message.
	         * @function verify
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsBye.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                if (!$util.isString(message.Reason))
	                    return "Reason: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsBye message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsBye} ArgumentsBye
	         */
	        ArgumentsBye.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsBye)
	                return object;
	            var message = new $root.manager.ArgumentsBye();
	            if (object.Reason != null)
	                message.Reason = String(object.Reason);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsBye message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsBye
	         * @static
	         * @param {manager.ArgumentsBye} message ArgumentsBye
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsBye.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Reason = "";
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                object.Reason = message.Reason;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsBye to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsBye
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsBye.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsBye;
	    })();
	
	    manager.ArgumentsHereAreMyMatches = (function() {
	
	        /**
	         * Properties of an ArgumentsHereAreMyMatches.
	         * @memberof manager
	         * @interface IArgumentsHereAreMyMatches
	         * @property {Array.<string>|null} [Peers] ArgumentsHereAreMyMatches Peers
	         */
	
	        /**
	         * Constructs a new ArgumentsHereAreMyMatches.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsHereAreMyMatches.
	         * @implements IArgumentsHereAreMyMatches
	         * @constructor
	         * @param {manager.IArgumentsHereAreMyMatches=} [properties] Properties to set
	         */
	        function ArgumentsHereAreMyMatches(properties) {
	            this.Peers = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsHereAreMyMatches Peers.
	         * @member {Array.<string>} Peers
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @instance
	         */
	        ArgumentsHereAreMyMatches.prototype.Peers = $util.emptyArray;
	
	        /**
	         * Creates a new ArgumentsHereAreMyMatches instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {manager.IArgumentsHereAreMyMatches=} [properties] Properties to set
	         * @returns {manager.ArgumentsHereAreMyMatches} ArgumentsHereAreMyMatches instance
	         */
	        ArgumentsHereAreMyMatches.create = function create(properties) {
	            return new ArgumentsHereAreMyMatches(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsHereAreMyMatches message. Does not implicitly {@link manager.ArgumentsHereAreMyMatches.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {manager.IArgumentsHereAreMyMatches} message ArgumentsHereAreMyMatches message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHereAreMyMatches.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peers != null && message.Peers.length)
	                for (var i = 0; i < message.Peers.length; ++i)
	                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peers[i]);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsHereAreMyMatches message, length delimited. Does not implicitly {@link manager.ArgumentsHereAreMyMatches.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {manager.IArgumentsHereAreMyMatches} message ArgumentsHereAreMyMatches message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHereAreMyMatches.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsHereAreMyMatches message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsHereAreMyMatches} ArgumentsHereAreMyMatches
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHereAreMyMatches.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsHereAreMyMatches();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    if (!(message.Peers && message.Peers.length))
	                        message.Peers = [];
	                    message.Peers.push(reader.string());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsHereAreMyMatches message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsHereAreMyMatches} ArgumentsHereAreMyMatches
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHereAreMyMatches.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsHereAreMyMatches message.
	         * @function verify
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsHereAreMyMatches.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peers != null && message.hasOwnProperty("Peers")) {
	                if (!Array.isArray(message.Peers))
	                    return "Peers: array expected";
	                for (var i = 0; i < message.Peers.length; ++i)
	                    if (!$util.isString(message.Peers[i]))
	                        return "Peers: string[] expected";
	            }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsHereAreMyMatches message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsHereAreMyMatches} ArgumentsHereAreMyMatches
	         */
	        ArgumentsHereAreMyMatches.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsHereAreMyMatches)
	                return object;
	            var message = new $root.manager.ArgumentsHereAreMyMatches();
	            if (object.Peers) {
	                if (!Array.isArray(object.Peers))
	                    throw TypeError(".manager.ArgumentsHereAreMyMatches.Peers: array expected");
	                message.Peers = [];
	                for (var i = 0; i < object.Peers.length; ++i)
	                    message.Peers[i] = String(object.Peers[i]);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsHereAreMyMatches message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @static
	         * @param {manager.ArgumentsHereAreMyMatches} message ArgumentsHereAreMyMatches
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsHereAreMyMatches.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Peers = [];
	            if (message.Peers && message.Peers.length) {
	                object.Peers = [];
	                for (var j = 0; j < message.Peers.length; ++j)
	                    object.Peers[j] = message.Peers[j];
	            }
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsHereAreMyMatches to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsHereAreMyMatches
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsHereAreMyMatches.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsHereAreMyMatches;
	    })();
	
	    manager.ArgumentsHereAreSomePeers = (function() {
	
	        /**
	         * Properties of an ArgumentsHereAreSomePeers.
	         * @memberof manager
	         * @interface IArgumentsHereAreSomePeers
	         * @property {Array.<string>|null} [Peers] ArgumentsHereAreSomePeers Peers
	         */
	
	        /**
	         * Constructs a new ArgumentsHereAreSomePeers.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsHereAreSomePeers.
	         * @implements IArgumentsHereAreSomePeers
	         * @constructor
	         * @param {manager.IArgumentsHereAreSomePeers=} [properties] Properties to set
	         */
	        function ArgumentsHereAreSomePeers(properties) {
	            this.Peers = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsHereAreSomePeers Peers.
	         * @member {Array.<string>} Peers
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @instance
	         */
	        ArgumentsHereAreSomePeers.prototype.Peers = $util.emptyArray;
	
	        /**
	         * Creates a new ArgumentsHereAreSomePeers instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {manager.IArgumentsHereAreSomePeers=} [properties] Properties to set
	         * @returns {manager.ArgumentsHereAreSomePeers} ArgumentsHereAreSomePeers instance
	         */
	        ArgumentsHereAreSomePeers.create = function create(properties) {
	            return new ArgumentsHereAreSomePeers(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsHereAreSomePeers message. Does not implicitly {@link manager.ArgumentsHereAreSomePeers.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {manager.IArgumentsHereAreSomePeers} message ArgumentsHereAreSomePeers message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHereAreSomePeers.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peers != null && message.Peers.length)
	                for (var i = 0; i < message.Peers.length; ++i)
	                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peers[i]);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsHereAreSomePeers message, length delimited. Does not implicitly {@link manager.ArgumentsHereAreSomePeers.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {manager.IArgumentsHereAreSomePeers} message ArgumentsHereAreSomePeers message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHereAreSomePeers.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsHereAreSomePeers message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsHereAreSomePeers} ArgumentsHereAreSomePeers
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHereAreSomePeers.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsHereAreSomePeers();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    if (!(message.Peers && message.Peers.length))
	                        message.Peers = [];
	                    message.Peers.push(reader.string());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsHereAreSomePeers message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsHereAreSomePeers} ArgumentsHereAreSomePeers
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHereAreSomePeers.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsHereAreSomePeers message.
	         * @function verify
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsHereAreSomePeers.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peers != null && message.hasOwnProperty("Peers")) {
	                if (!Array.isArray(message.Peers))
	                    return "Peers: array expected";
	                for (var i = 0; i < message.Peers.length; ++i)
	                    if (!$util.isString(message.Peers[i]))
	                        return "Peers: string[] expected";
	            }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsHereAreSomePeers message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsHereAreSomePeers} ArgumentsHereAreSomePeers
	         */
	        ArgumentsHereAreSomePeers.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsHereAreSomePeers)
	                return object;
	            var message = new $root.manager.ArgumentsHereAreSomePeers();
	            if (object.Peers) {
	                if (!Array.isArray(object.Peers))
	                    throw TypeError(".manager.ArgumentsHereAreSomePeers.Peers: array expected");
	                message.Peers = [];
	                for (var i = 0; i < object.Peers.length; ++i)
	                    message.Peers[i] = String(object.Peers[i]);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsHereAreSomePeers message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @static
	         * @param {manager.ArgumentsHereAreSomePeers} message ArgumentsHereAreSomePeers
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsHereAreSomePeers.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Peers = [];
	            if (message.Peers && message.Peers.length) {
	                object.Peers = [];
	                for (var j = 0; j < message.Peers.length; ++j)
	                    object.Peers[j] = message.Peers[j];
	            }
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsHereAreSomePeers to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsHereAreSomePeers
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsHereAreSomePeers.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsHereAreSomePeers;
	    })();
	
	    manager.ArgumentsItsAMatch = (function() {
	
	        /**
	         * Properties of an ArgumentsItsAMatch.
	         * @memberof manager
	         * @interface IArgumentsItsAMatch
	         * @property {string|null} [Peer] ArgumentsItsAMatch Peer
	         * @property {string|null} [Offer] ArgumentsItsAMatch Offer
	         * @property {Array.<string>|null} [Candidates] ArgumentsItsAMatch Candidates
	         */
	
	        /**
	         * Constructs a new ArgumentsItsAMatch.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsItsAMatch.
	         * @implements IArgumentsItsAMatch
	         * @constructor
	         * @param {manager.IArgumentsItsAMatch=} [properties] Properties to set
	         */
	        function ArgumentsItsAMatch(properties) {
	            this.Candidates = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsItsAMatch Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsItsAMatch
	         * @instance
	         */
	        ArgumentsItsAMatch.prototype.Peer = "";
	
	        /**
	         * ArgumentsItsAMatch Offer.
	         * @member {string} Offer
	         * @memberof manager.ArgumentsItsAMatch
	         * @instance
	         */
	        ArgumentsItsAMatch.prototype.Offer = "";
	
	        /**
	         * ArgumentsItsAMatch Candidates.
	         * @member {Array.<string>} Candidates
	         * @memberof manager.ArgumentsItsAMatch
	         * @instance
	         */
	        ArgumentsItsAMatch.prototype.Candidates = $util.emptyArray;
	
	        /**
	         * Creates a new ArgumentsItsAMatch instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {manager.IArgumentsItsAMatch=} [properties] Properties to set
	         * @returns {manager.ArgumentsItsAMatch} ArgumentsItsAMatch instance
	         */
	        ArgumentsItsAMatch.create = function create(properties) {
	            return new ArgumentsItsAMatch(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsItsAMatch message. Does not implicitly {@link manager.ArgumentsItsAMatch.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {manager.IArgumentsItsAMatch} message ArgumentsItsAMatch message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsItsAMatch.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peer);
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Offer);
	            if (message.Candidates != null && message.Candidates.length)
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.Candidates[i]);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsItsAMatch message, length delimited. Does not implicitly {@link manager.ArgumentsItsAMatch.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {manager.IArgumentsItsAMatch} message ArgumentsItsAMatch message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsItsAMatch.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsItsAMatch message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsItsAMatch} ArgumentsItsAMatch
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsItsAMatch.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsItsAMatch();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Peer = reader.string();
	                    break;
	                case 2:
	                    message.Offer = reader.string();
	                    break;
	                case 3:
	                    if (!(message.Candidates && message.Candidates.length))
	                        message.Candidates = [];
	                    message.Candidates.push(reader.string());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsItsAMatch message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsItsAMatch} ArgumentsItsAMatch
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsItsAMatch.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsItsAMatch message.
	         * @function verify
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsItsAMatch.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                if (!$util.isString(message.Offer))
	                    return "Offer: string expected";
	            if (message.Candidates != null && message.hasOwnProperty("Candidates")) {
	                if (!Array.isArray(message.Candidates))
	                    return "Candidates: array expected";
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    if (!$util.isString(message.Candidates[i]))
	                        return "Candidates: string[] expected";
	            }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsItsAMatch message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsItsAMatch} ArgumentsItsAMatch
	         */
	        ArgumentsItsAMatch.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsItsAMatch)
	                return object;
	            var message = new $root.manager.ArgumentsItsAMatch();
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            if (object.Offer != null)
	                message.Offer = String(object.Offer);
	            if (object.Candidates) {
	                if (!Array.isArray(object.Candidates))
	                    throw TypeError(".manager.ArgumentsItsAMatch.Candidates: array expected");
	                message.Candidates = [];
	                for (var i = 0; i < object.Candidates.length; ++i)
	                    message.Candidates[i] = String(object.Candidates[i]);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsItsAMatch message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsItsAMatch
	         * @static
	         * @param {manager.ArgumentsItsAMatch} message ArgumentsItsAMatch
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsItsAMatch.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Candidates = [];
	            if (options.defaults) {
	                object.Peer = "";
	                object.Offer = "";
	            }
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                object.Offer = message.Offer;
	            if (message.Candidates && message.Candidates.length) {
	                object.Candidates = [];
	                for (var j = 0; j < message.Candidates.length; ++j)
	                    object.Candidates[j] = message.Candidates[j];
	            }
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsItsAMatch to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsItsAMatch
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsItsAMatch.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsItsAMatch;
	    })();
	
	    manager.ArgumentsPairingInProgress = (function() {
	
	        /**
	         * Properties of an ArgumentsPairingInProgress.
	         * @memberof manager
	         * @interface IArgumentsPairingInProgress
	         * @property {string|null} [Peer] ArgumentsPairingInProgress Peer
	         */
	
	        /**
	         * Constructs a new ArgumentsPairingInProgress.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsPairingInProgress.
	         * @implements IArgumentsPairingInProgress
	         * @constructor
	         * @param {manager.IArgumentsPairingInProgress=} [properties] Properties to set
	         */
	        function ArgumentsPairingInProgress(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsPairingInProgress Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsPairingInProgress
	         * @instance
	         */
	        ArgumentsPairingInProgress.prototype.Peer = "";
	
	        /**
	         * Creates a new ArgumentsPairingInProgress instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {manager.IArgumentsPairingInProgress=} [properties] Properties to set
	         * @returns {manager.ArgumentsPairingInProgress} ArgumentsPairingInProgress instance
	         */
	        ArgumentsPairingInProgress.create = function create(properties) {
	            return new ArgumentsPairingInProgress(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsPairingInProgress message. Does not implicitly {@link manager.ArgumentsPairingInProgress.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {manager.IArgumentsPairingInProgress} message ArgumentsPairingInProgress message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPairingInProgress.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peer);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsPairingInProgress message, length delimited. Does not implicitly {@link manager.ArgumentsPairingInProgress.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {manager.IArgumentsPairingInProgress} message ArgumentsPairingInProgress message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPairingInProgress.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsPairingInProgress message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsPairingInProgress} ArgumentsPairingInProgress
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPairingInProgress.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsPairingInProgress();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Peer = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsPairingInProgress message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsPairingInProgress} ArgumentsPairingInProgress
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPairingInProgress.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsPairingInProgress message.
	         * @function verify
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsPairingInProgress.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsPairingInProgress message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsPairingInProgress} ArgumentsPairingInProgress
	         */
	        ArgumentsPairingInProgress.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsPairingInProgress)
	                return object;
	            var message = new $root.manager.ArgumentsPairingInProgress();
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsPairingInProgress message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsPairingInProgress
	         * @static
	         * @param {manager.ArgumentsPairingInProgress} message ArgumentsPairingInProgress
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsPairingInProgress.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Peer = "";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsPairingInProgress to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsPairingInProgress
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsPairingInProgress.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsPairingInProgress;
	    })();
	
	    /**
	     * PairingRequestType enum.
	     * @name manager.PairingRequestType
	     * @enum {string}
	     * @property {number} PairingRequestType_offer=0 PairingRequestType_offer value
	     * @property {number} PairingRequestType_answer=1 PairingRequestType_answer value
	     */
	    manager.PairingRequestType = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "PairingRequestType_offer"] = 0;
	        values[valuesById[1] = "PairingRequestType_answer"] = 1;
	        return values;
	    })();
	
	    manager.ArgumentsPairingRequest = (function() {
	
	        /**
	         * Properties of an ArgumentsPairingRequest.
	         * @memberof manager
	         * @interface IArgumentsPairingRequest
	         * @property {manager.PairingRequestType|null} [Type] ArgumentsPairingRequest Type
	         * @property {string|null} [Peer] ArgumentsPairingRequest Peer
	         * @property {string|null} [Offer] ArgumentsPairingRequest Offer
	         * @property {Array.<string>|null} [Candidates] ArgumentsPairingRequest Candidates
	         */
	
	        /**
	         * Constructs a new ArgumentsPairingRequest.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsPairingRequest.
	         * @implements IArgumentsPairingRequest
	         * @constructor
	         * @param {manager.IArgumentsPairingRequest=} [properties] Properties to set
	         */
	        function ArgumentsPairingRequest(properties) {
	            this.Candidates = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsPairingRequest Type.
	         * @member {manager.PairingRequestType} Type
	         * @memberof manager.ArgumentsPairingRequest
	         * @instance
	         */
	        ArgumentsPairingRequest.prototype.Type = 0;
	
	        /**
	         * ArgumentsPairingRequest Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsPairingRequest
	         * @instance
	         */
	        ArgumentsPairingRequest.prototype.Peer = "";
	
	        /**
	         * ArgumentsPairingRequest Offer.
	         * @member {string} Offer
	         * @memberof manager.ArgumentsPairingRequest
	         * @instance
	         */
	        ArgumentsPairingRequest.prototype.Offer = "";
	
	        /**
	         * ArgumentsPairingRequest Candidates.
	         * @member {Array.<string>} Candidates
	         * @memberof manager.ArgumentsPairingRequest
	         * @instance
	         */
	        ArgumentsPairingRequest.prototype.Candidates = $util.emptyArray;
	
	        /**
	         * Creates a new ArgumentsPairingRequest instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {manager.IArgumentsPairingRequest=} [properties] Properties to set
	         * @returns {manager.ArgumentsPairingRequest} ArgumentsPairingRequest instance
	         */
	        ArgumentsPairingRequest.create = function create(properties) {
	            return new ArgumentsPairingRequest(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsPairingRequest message. Does not implicitly {@link manager.ArgumentsPairingRequest.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {manager.IArgumentsPairingRequest} message ArgumentsPairingRequest message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPairingRequest.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Peer);
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Offer);
	            if (message.Candidates != null && message.Candidates.length)
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.Candidates[i]);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsPairingRequest message, length delimited. Does not implicitly {@link manager.ArgumentsPairingRequest.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {manager.IArgumentsPairingRequest} message ArgumentsPairingRequest message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPairingRequest.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsPairingRequest message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsPairingRequest} ArgumentsPairingRequest
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPairingRequest.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsPairingRequest();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Type = reader.int32();
	                    break;
	                case 2:
	                    message.Peer = reader.string();
	                    break;
	                case 3:
	                    message.Offer = reader.string();
	                    break;
	                case 4:
	                    if (!(message.Candidates && message.Candidates.length))
	                        message.Candidates = [];
	                    message.Candidates.push(reader.string());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsPairingRequest message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsPairingRequest} ArgumentsPairingRequest
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPairingRequest.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsPairingRequest message.
	         * @function verify
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsPairingRequest.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                switch (message.Type) {
	                default:
	                    return "Type: enum value expected";
	                case 0:
	                case 1:
	                    break;
	                }
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                if (!$util.isString(message.Offer))
	                    return "Offer: string expected";
	            if (message.Candidates != null && message.hasOwnProperty("Candidates")) {
	                if (!Array.isArray(message.Candidates))
	                    return "Candidates: array expected";
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    if (!$util.isString(message.Candidates[i]))
	                        return "Candidates: string[] expected";
	            }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsPairingRequest message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsPairingRequest} ArgumentsPairingRequest
	         */
	        ArgumentsPairingRequest.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsPairingRequest)
	                return object;
	            var message = new $root.manager.ArgumentsPairingRequest();
	            switch (object.Type) {
	            case "PairingRequestType_offer":
	            case 0:
	                message.Type = 0;
	                break;
	            case "PairingRequestType_answer":
	            case 1:
	                message.Type = 1;
	                break;
	            }
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            if (object.Offer != null)
	                message.Offer = String(object.Offer);
	            if (object.Candidates) {
	                if (!Array.isArray(object.Candidates))
	                    throw TypeError(".manager.ArgumentsPairingRequest.Candidates: array expected");
	                message.Candidates = [];
	                for (var i = 0; i < object.Candidates.length; ++i)
	                    message.Candidates[i] = String(object.Candidates[i]);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsPairingRequest message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsPairingRequest
	         * @static
	         * @param {manager.ArgumentsPairingRequest} message ArgumentsPairingRequest
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsPairingRequest.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Candidates = [];
	            if (options.defaults) {
	                object.Type = options.enums === String ? "PairingRequestType_offer" : 0;
	                object.Peer = "";
	                object.Offer = "";
	            }
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                object.Type = options.enums === String ? $root.manager.PairingRequestType[message.Type] : message.Type;
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                object.Offer = message.Offer;
	            if (message.Candidates && message.Candidates.length) {
	                object.Candidates = [];
	                for (var j = 0; j < message.Candidates.length; ++j)
	                    object.Candidates[j] = message.Candidates[j];
	            }
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsPairingRequest to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsPairingRequest
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsPairingRequest.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsPairingRequest;
	    })();
	
	    manager.ArgumentsPeerLeft = (function() {
	
	        /**
	         * Properties of an ArgumentsPeerLeft.
	         * @memberof manager
	         * @interface IArgumentsPeerLeft
	         * @property {string|null} [Peer] ArgumentsPeerLeft Peer
	         */
	
	        /**
	         * Constructs a new ArgumentsPeerLeft.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsPeerLeft.
	         * @implements IArgumentsPeerLeft
	         * @constructor
	         * @param {manager.IArgumentsPeerLeft=} [properties] Properties to set
	         */
	        function ArgumentsPeerLeft(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsPeerLeft Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsPeerLeft
	         * @instance
	         */
	        ArgumentsPeerLeft.prototype.Peer = "";
	
	        /**
	         * Creates a new ArgumentsPeerLeft instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {manager.IArgumentsPeerLeft=} [properties] Properties to set
	         * @returns {manager.ArgumentsPeerLeft} ArgumentsPeerLeft instance
	         */
	        ArgumentsPeerLeft.create = function create(properties) {
	            return new ArgumentsPeerLeft(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsPeerLeft message. Does not implicitly {@link manager.ArgumentsPeerLeft.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {manager.IArgumentsPeerLeft} message ArgumentsPeerLeft message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPeerLeft.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peer);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsPeerLeft message, length delimited. Does not implicitly {@link manager.ArgumentsPeerLeft.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {manager.IArgumentsPeerLeft} message ArgumentsPeerLeft message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPeerLeft.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsPeerLeft message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsPeerLeft} ArgumentsPeerLeft
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPeerLeft.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsPeerLeft();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Peer = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsPeerLeft message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsPeerLeft} ArgumentsPeerLeft
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPeerLeft.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsPeerLeft message.
	         * @function verify
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsPeerLeft.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsPeerLeft message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsPeerLeft} ArgumentsPeerLeft
	         */
	        ArgumentsPeerLeft.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsPeerLeft)
	                return object;
	            var message = new $root.manager.ArgumentsPeerLeft();
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsPeerLeft message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsPeerLeft
	         * @static
	         * @param {manager.ArgumentsPeerLeft} message ArgumentsPeerLeft
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsPeerLeft.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Peer = "";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsPeerLeft to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsPeerLeft
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsPeerLeft.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsPeerLeft;
	    })();
	
	    manager.ArgumentsRegister = (function() {
	
	        /**
	         * Properties of an ArgumentsRegister.
	         * @memberof manager
	         * @interface IArgumentsRegister
	         * @property {string|null} [Url] ArgumentsRegister Url
	         * @property {Array.<manager.IIceCandidate>|null} [Candidates] ArgumentsRegister Candidates
	         * @property {number|Long|null} [Bandwidth] ArgumentsRegister Bandwidth
	         * @property {string|null} [Codec] ArgumentsRegister Codec
	         * @property {number|Long|null} [TimeShift] ArgumentsRegister TimeShift
	         * @property {string|null} [sessionID] ArgumentsRegister sessionID
	         */
	
	        /**
	         * Constructs a new ArgumentsRegister.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsRegister.
	         * @implements IArgumentsRegister
	         * @constructor
	         * @param {manager.IArgumentsRegister=} [properties] Properties to set
	         */
	        function ArgumentsRegister(properties) {
	            this.Candidates = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsRegister Url.
	         * @member {string} Url
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.Url = "";
	
	        /**
	         * ArgumentsRegister Candidates.
	         * @member {Array.<manager.IIceCandidate>} Candidates
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.Candidates = $util.emptyArray;
	
	        /**
	         * ArgumentsRegister Bandwidth.
	         * @member {number|Long} Bandwidth
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.Bandwidth = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
	
	        /**
	         * ArgumentsRegister Codec.
	         * @member {string} Codec
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.Codec = "";
	
	        /**
	         * ArgumentsRegister TimeShift.
	         * @member {number|Long} TimeShift
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.TimeShift = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
	
	        /**
	         * ArgumentsRegister sessionID.
	         * @member {string} sessionID
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         */
	        ArgumentsRegister.prototype.sessionID = "";
	
	        /**
	         * Creates a new ArgumentsRegister instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {manager.IArgumentsRegister=} [properties] Properties to set
	         * @returns {manager.ArgumentsRegister} ArgumentsRegister instance
	         */
	        ArgumentsRegister.create = function create(properties) {
	            return new ArgumentsRegister(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsRegister message. Does not implicitly {@link manager.ArgumentsRegister.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {manager.IArgumentsRegister} message ArgumentsRegister message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsRegister.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Url != null && message.hasOwnProperty("Url"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Url);
	            if (message.Candidates != null && message.Candidates.length)
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    $root.manager.IceCandidate.encode(message.Candidates[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.Bandwidth);
	            if (message.Codec != null && message.hasOwnProperty("Codec"))
	                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Codec);
	            if (message.TimeShift != null && message.hasOwnProperty("TimeShift"))
	                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.TimeShift);
	            if (message.sessionID != null && message.hasOwnProperty("sessionID"))
	                writer.uint32(/* id 7, wireType 2 =*/58).string(message.sessionID);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsRegister message, length delimited. Does not implicitly {@link manager.ArgumentsRegister.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {manager.IArgumentsRegister} message ArgumentsRegister message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsRegister.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsRegister message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsRegister} ArgumentsRegister
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsRegister.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsRegister();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 2:
	                    message.Url = reader.string();
	                    break;
	                case 3:
	                    if (!(message.Candidates && message.Candidates.length))
	                        message.Candidates = [];
	                    message.Candidates.push($root.manager.IceCandidate.decode(reader, reader.uint32()));
	                    break;
	                case 4:
	                    message.Bandwidth = reader.uint64();
	                    break;
	                case 5:
	                    message.Codec = reader.string();
	                    break;
	                case 6:
	                    message.TimeShift = reader.uint64();
	                    break;
	                case 7:
	                    message.sessionID = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsRegister message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsRegister} ArgumentsRegister
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsRegister.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsRegister message.
	         * @function verify
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsRegister.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Url != null && message.hasOwnProperty("Url"))
	                if (!$util.isString(message.Url))
	                    return "Url: string expected";
	            if (message.Candidates != null && message.hasOwnProperty("Candidates")) {
	                if (!Array.isArray(message.Candidates))
	                    return "Candidates: array expected";
	                for (var i = 0; i < message.Candidates.length; ++i) {
	                    var error = $root.manager.IceCandidate.verify(message.Candidates[i]);
	                    if (error)
	                        return "Candidates." + error;
	                }
	            }
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                if (!$util.isInteger(message.Bandwidth) && !(message.Bandwidth && $util.isInteger(message.Bandwidth.low) && $util.isInteger(message.Bandwidth.high)))
	                    return "Bandwidth: integer|Long expected";
	            if (message.Codec != null && message.hasOwnProperty("Codec"))
	                if (!$util.isString(message.Codec))
	                    return "Codec: string expected";
	            if (message.TimeShift != null && message.hasOwnProperty("TimeShift"))
	                if (!$util.isInteger(message.TimeShift) && !(message.TimeShift && $util.isInteger(message.TimeShift.low) && $util.isInteger(message.TimeShift.high)))
	                    return "TimeShift: integer|Long expected";
	            if (message.sessionID != null && message.hasOwnProperty("sessionID"))
	                if (!$util.isString(message.sessionID))
	                    return "sessionID: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsRegister message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsRegister} ArgumentsRegister
	         */
	        ArgumentsRegister.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsRegister)
	                return object;
	            var message = new $root.manager.ArgumentsRegister();
	            if (object.Url != null)
	                message.Url = String(object.Url);
	            if (object.Candidates) {
	                if (!Array.isArray(object.Candidates))
	                    throw TypeError(".manager.ArgumentsRegister.Candidates: array expected");
	                message.Candidates = [];
	                for (var i = 0; i < object.Candidates.length; ++i) {
	                    if (typeof object.Candidates[i] !== "object")
	                        throw TypeError(".manager.ArgumentsRegister.Candidates: object expected");
	                    message.Candidates[i] = $root.manager.IceCandidate.fromObject(object.Candidates[i]);
	                }
	            }
	            if (object.Bandwidth != null)
	                if ($util.Long)
	                    (message.Bandwidth = $util.Long.fromValue(object.Bandwidth)).unsigned = true;
	                else if (typeof object.Bandwidth === "string")
	                    message.Bandwidth = parseInt(object.Bandwidth, 10);
	                else if (typeof object.Bandwidth === "number")
	                    message.Bandwidth = object.Bandwidth;
	                else if (typeof object.Bandwidth === "object")
	                    message.Bandwidth = new $util.LongBits(object.Bandwidth.low >>> 0, object.Bandwidth.high >>> 0).toNumber(true);
	            if (object.Codec != null)
	                message.Codec = String(object.Codec);
	            if (object.TimeShift != null)
	                if ($util.Long)
	                    (message.TimeShift = $util.Long.fromValue(object.TimeShift)).unsigned = true;
	                else if (typeof object.TimeShift === "string")
	                    message.TimeShift = parseInt(object.TimeShift, 10);
	                else if (typeof object.TimeShift === "number")
	                    message.TimeShift = object.TimeShift;
	                else if (typeof object.TimeShift === "object")
	                    message.TimeShift = new $util.LongBits(object.TimeShift.low >>> 0, object.TimeShift.high >>> 0).toNumber(true);
	            if (object.sessionID != null)
	                message.sessionID = String(object.sessionID);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsRegister message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsRegister
	         * @static
	         * @param {manager.ArgumentsRegister} message ArgumentsRegister
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsRegister.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Candidates = [];
	            if (options.defaults) {
	                object.Url = "";
	                if ($util.Long) {
	                    var long = new $util.Long(0, 0, true);
	                    object.Bandwidth = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
	                } else
	                    object.Bandwidth = options.longs === String ? "0" : 0;
	                object.Codec = "";
	                if ($util.Long) {
	                    var long = new $util.Long(0, 0, true);
	                    object.TimeShift = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
	                } else
	                    object.TimeShift = options.longs === String ? "0" : 0;
	                object.sessionID = "";
	            }
	            if (message.Url != null && message.hasOwnProperty("Url"))
	                object.Url = message.Url;
	            if (message.Candidates && message.Candidates.length) {
	                object.Candidates = [];
	                for (var j = 0; j < message.Candidates.length; ++j)
	                    object.Candidates[j] = $root.manager.IceCandidate.toObject(message.Candidates[j], options);
	            }
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                if (typeof message.Bandwidth === "number")
	                    object.Bandwidth = options.longs === String ? String(message.Bandwidth) : message.Bandwidth;
	                else
	                    object.Bandwidth = options.longs === String ? $util.Long.prototype.toString.call(message.Bandwidth) : options.longs === Number ? new $util.LongBits(message.Bandwidth.low >>> 0, message.Bandwidth.high >>> 0).toNumber(true) : message.Bandwidth;
	            if (message.Codec != null && message.hasOwnProperty("Codec"))
	                object.Codec = message.Codec;
	            if (message.TimeShift != null && message.hasOwnProperty("TimeShift"))
	                if (typeof message.TimeShift === "number")
	                    object.TimeShift = options.longs === String ? String(message.TimeShift) : message.TimeShift;
	                else
	                    object.TimeShift = options.longs === String ? $util.Long.prototype.toString.call(message.TimeShift) : options.longs === Number ? new $util.LongBits(message.TimeShift.low >>> 0, message.TimeShift.high >>> 0).toNumber(true) : message.TimeShift;
	            if (message.sessionID != null && message.hasOwnProperty("sessionID"))
	                object.sessionID = message.sessionID;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsRegister to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsRegister
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsRegister.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsRegister;
	    })();
	
	    /**
	     * IceCandidateType enum.
	     * @name manager.IceCandidateType
	     * @enum {string}
	     * @property {number} CandidateTypeHost=0 CandidateTypeHost value
	     * @property {number} CandidateTypeServerReflexive=1 CandidateTypeServerReflexive value
	     * @property {number} CandidateTypePeerReflexive=2 CandidateTypePeerReflexive value
	     * @property {number} CandidateTypeRelay=3 CandidateTypeRelay value
	     */
	    manager.IceCandidateType = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "CandidateTypeHost"] = 0;
	        values[valuesById[1] = "CandidateTypeServerReflexive"] = 1;
	        values[valuesById[2] = "CandidateTypePeerReflexive"] = 2;
	        values[valuesById[3] = "CandidateTypeRelay"] = 3;
	        return values;
	    })();
	
	    manager.IceCandidate = (function() {
	
	        /**
	         * Properties of an IceCandidate.
	         * @memberof manager
	         * @interface IIceCandidate
	         * @property {manager.IceCandidateType|null} [Type] IceCandidate Type
	         * @property {string|null} [Address] IceCandidate Address
	         */
	
	        /**
	         * Constructs a new IceCandidate.
	         * @memberof manager
	         * @classdesc Represents an IceCandidate.
	         * @implements IIceCandidate
	         * @constructor
	         * @param {manager.IIceCandidate=} [properties] Properties to set
	         */
	        function IceCandidate(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * IceCandidate Type.
	         * @member {manager.IceCandidateType} Type
	         * @memberof manager.IceCandidate
	         * @instance
	         */
	        IceCandidate.prototype.Type = 0;
	
	        /**
	         * IceCandidate Address.
	         * @member {string} Address
	         * @memberof manager.IceCandidate
	         * @instance
	         */
	        IceCandidate.prototype.Address = "";
	
	        /**
	         * Creates a new IceCandidate instance using the specified properties.
	         * @function create
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {manager.IIceCandidate=} [properties] Properties to set
	         * @returns {manager.IceCandidate} IceCandidate instance
	         */
	        IceCandidate.create = function create(properties) {
	            return new IceCandidate(properties);
	        };
	
	        /**
	         * Encodes the specified IceCandidate message. Does not implicitly {@link manager.IceCandidate.verify|verify} messages.
	         * @function encode
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {manager.IIceCandidate} message IceCandidate message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        IceCandidate.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
	            if (message.Address != null && message.hasOwnProperty("Address"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Address);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified IceCandidate message, length delimited. Does not implicitly {@link manager.IceCandidate.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {manager.IIceCandidate} message IceCandidate message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        IceCandidate.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an IceCandidate message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.IceCandidate} IceCandidate
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        IceCandidate.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.IceCandidate();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Type = reader.int32();
	                    break;
	                case 2:
	                    message.Address = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an IceCandidate message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.IceCandidate} IceCandidate
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        IceCandidate.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an IceCandidate message.
	         * @function verify
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        IceCandidate.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                switch (message.Type) {
	                default:
	                    return "Type: enum value expected";
	                case 0:
	                case 1:
	                case 2:
	                case 3:
	                    break;
	                }
	            if (message.Address != null && message.hasOwnProperty("Address"))
	                if (!$util.isString(message.Address))
	                    return "Address: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an IceCandidate message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.IceCandidate} IceCandidate
	         */
	        IceCandidate.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.IceCandidate)
	                return object;
	            var message = new $root.manager.IceCandidate();
	            switch (object.Type) {
	            case "CandidateTypeHost":
	            case 0:
	                message.Type = 0;
	                break;
	            case "CandidateTypeServerReflexive":
	            case 1:
	                message.Type = 1;
	                break;
	            case "CandidateTypePeerReflexive":
	            case 2:
	                message.Type = 2;
	                break;
	            case "CandidateTypeRelay":
	            case 3:
	                message.Type = 3;
	                break;
	            }
	            if (object.Address != null)
	                message.Address = String(object.Address);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an IceCandidate message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.IceCandidate
	         * @static
	         * @param {manager.IceCandidate} message IceCandidate
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        IceCandidate.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults) {
	                object.Type = options.enums === String ? "CandidateTypeHost" : 0;
	                object.Address = "";
	            }
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                object.Type = options.enums === String ? $root.manager.IceCandidateType[message.Type] : message.Type;
	            if (message.Address != null && message.hasOwnProperty("Address"))
	                object.Address = message.Address;
	            return object;
	        };
	
	        /**
	         * Converts this IceCandidate to JSON.
	         * @function toJSON
	         * @memberof manager.IceCandidate
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        IceCandidate.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return IceCandidate;
	    })();
	
	    manager.ArgumentsRegistered = (function() {
	
	        /**
	         * Properties of an ArgumentsRegistered.
	         * @memberof manager
	         * @interface IArgumentsRegistered
	         * @property {string|null} [ID] ArgumentsRegistered ID
	         * @property {string|null} [ISP] ArgumentsRegistered ISP
	         */
	
	        /**
	         * Constructs a new ArgumentsRegistered.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsRegistered.
	         * @implements IArgumentsRegistered
	         * @constructor
	         * @param {manager.IArgumentsRegistered=} [properties] Properties to set
	         */
	        function ArgumentsRegistered(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsRegistered ID.
	         * @member {string} ID
	         * @memberof manager.ArgumentsRegistered
	         * @instance
	         */
	        ArgumentsRegistered.prototype.ID = "";
	
	        /**
	         * ArgumentsRegistered ISP.
	         * @member {string} ISP
	         * @memberof manager.ArgumentsRegistered
	         * @instance
	         */
	        ArgumentsRegistered.prototype.ISP = "";
	
	        /**
	         * Creates a new ArgumentsRegistered instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {manager.IArgumentsRegistered=} [properties] Properties to set
	         * @returns {manager.ArgumentsRegistered} ArgumentsRegistered instance
	         */
	        ArgumentsRegistered.create = function create(properties) {
	            return new ArgumentsRegistered(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsRegistered message. Does not implicitly {@link manager.ArgumentsRegistered.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {manager.IArgumentsRegistered} message ArgumentsRegistered message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsRegistered.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.ID != null && message.hasOwnProperty("ID"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
	            if (message.ISP != null && message.hasOwnProperty("ISP"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ISP);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsRegistered message, length delimited. Does not implicitly {@link manager.ArgumentsRegistered.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {manager.IArgumentsRegistered} message ArgumentsRegistered message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsRegistered.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsRegistered message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsRegistered} ArgumentsRegistered
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsRegistered.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsRegistered();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.ID = reader.string();
	                    break;
	                case 2:
	                    message.ISP = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsRegistered message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsRegistered} ArgumentsRegistered
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsRegistered.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsRegistered message.
	         * @function verify
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsRegistered.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.ID != null && message.hasOwnProperty("ID"))
	                if (!$util.isString(message.ID))
	                    return "ID: string expected";
	            if (message.ISP != null && message.hasOwnProperty("ISP"))
	                if (!$util.isString(message.ISP))
	                    return "ISP: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsRegistered message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsRegistered} ArgumentsRegistered
	         */
	        ArgumentsRegistered.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsRegistered)
	                return object;
	            var message = new $root.manager.ArgumentsRegistered();
	            if (object.ID != null)
	                message.ID = String(object.ID);
	            if (object.ISP != null)
	                message.ISP = String(object.ISP);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsRegistered message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsRegistered
	         * @static
	         * @param {manager.ArgumentsRegistered} message ArgumentsRegistered
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsRegistered.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults) {
	                object.ID = "";
	                object.ISP = "";
	            }
	            if (message.ID != null && message.hasOwnProperty("ID"))
	                object.ID = message.ID;
	            if (message.ISP != null && message.hasOwnProperty("ISP"))
	                object.ISP = message.ISP;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsRegistered to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsRegistered
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsRegistered.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsRegistered;
	    })();
	
	    manager.ArgumentsSetBandwidth = (function() {
	
	        /**
	         * Properties of an ArgumentsSetBandwidth.
	         * @memberof manager
	         * @interface IArgumentsSetBandwidth
	         * @property {number|Long|null} [Bandwidth] ArgumentsSetBandwidth Bandwidth
	         */
	
	        /**
	         * Constructs a new ArgumentsSetBandwidth.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsSetBandwidth.
	         * @implements IArgumentsSetBandwidth
	         * @constructor
	         * @param {manager.IArgumentsSetBandwidth=} [properties] Properties to set
	         */
	        function ArgumentsSetBandwidth(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsSetBandwidth Bandwidth.
	         * @member {number|Long} Bandwidth
	         * @memberof manager.ArgumentsSetBandwidth
	         * @instance
	         */
	        ArgumentsSetBandwidth.prototype.Bandwidth = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
	
	        /**
	         * Creates a new ArgumentsSetBandwidth instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {manager.IArgumentsSetBandwidth=} [properties] Properties to set
	         * @returns {manager.ArgumentsSetBandwidth} ArgumentsSetBandwidth instance
	         */
	        ArgumentsSetBandwidth.create = function create(properties) {
	            return new ArgumentsSetBandwidth(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsSetBandwidth message. Does not implicitly {@link manager.ArgumentsSetBandwidth.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {manager.IArgumentsSetBandwidth} message ArgumentsSetBandwidth message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSetBandwidth.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.Bandwidth);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsSetBandwidth message, length delimited. Does not implicitly {@link manager.ArgumentsSetBandwidth.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {manager.IArgumentsSetBandwidth} message ArgumentsSetBandwidth message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSetBandwidth.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsSetBandwidth message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsSetBandwidth} ArgumentsSetBandwidth
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSetBandwidth.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsSetBandwidth();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Bandwidth = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsSetBandwidth message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsSetBandwidth} ArgumentsSetBandwidth
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSetBandwidth.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsSetBandwidth message.
	         * @function verify
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsSetBandwidth.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                if (!$util.isInteger(message.Bandwidth) && !(message.Bandwidth && $util.isInteger(message.Bandwidth.low) && $util.isInteger(message.Bandwidth.high)))
	                    return "Bandwidth: integer|Long expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsSetBandwidth message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsSetBandwidth} ArgumentsSetBandwidth
	         */
	        ArgumentsSetBandwidth.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsSetBandwidth)
	                return object;
	            var message = new $root.manager.ArgumentsSetBandwidth();
	            if (object.Bandwidth != null)
	                if ($util.Long)
	                    (message.Bandwidth = $util.Long.fromValue(object.Bandwidth)).unsigned = true;
	                else if (typeof object.Bandwidth === "string")
	                    message.Bandwidth = parseInt(object.Bandwidth, 10);
	                else if (typeof object.Bandwidth === "number")
	                    message.Bandwidth = object.Bandwidth;
	                else if (typeof object.Bandwidth === "object")
	                    message.Bandwidth = new $util.LongBits(object.Bandwidth.low >>> 0, object.Bandwidth.high >>> 0).toNumber(true);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsSetBandwidth message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsSetBandwidth
	         * @static
	         * @param {manager.ArgumentsSetBandwidth} message ArgumentsSetBandwidth
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsSetBandwidth.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                if ($util.Long) {
	                    var long = new $util.Long(0, 0, true);
	                    object.Bandwidth = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
	                } else
	                    object.Bandwidth = options.longs === String ? "0" : 0;
	            if (message.Bandwidth != null && message.hasOwnProperty("Bandwidth"))
	                if (typeof message.Bandwidth === "number")
	                    object.Bandwidth = options.longs === String ? String(message.Bandwidth) : message.Bandwidth;
	                else
	                    object.Bandwidth = options.longs === String ? $util.Long.prototype.toString.call(message.Bandwidth) : options.longs === Number ? new $util.LongBits(message.Bandwidth.low >>> 0, message.Bandwidth.high >>> 0).toNumber(true) : message.Bandwidth;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsSetBandwidth to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsSetBandwidth
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsSetBandwidth.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsSetBandwidth;
	    })();
	
	    manager.ArgumentsSetTimeshift = (function() {
	
	        /**
	         * Properties of an ArgumentsSetTimeshift.
	         * @memberof manager
	         * @interface IArgumentsSetTimeshift
	         * @property {number|Long|null} [Timeshift] ArgumentsSetTimeshift Timeshift
	         */
	
	        /**
	         * Constructs a new ArgumentsSetTimeshift.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsSetTimeshift.
	         * @implements IArgumentsSetTimeshift
	         * @constructor
	         * @param {manager.IArgumentsSetTimeshift=} [properties] Properties to set
	         */
	        function ArgumentsSetTimeshift(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsSetTimeshift Timeshift.
	         * @member {number|Long} Timeshift
	         * @memberof manager.ArgumentsSetTimeshift
	         * @instance
	         */
	        ArgumentsSetTimeshift.prototype.Timeshift = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
	
	        /**
	         * Creates a new ArgumentsSetTimeshift instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {manager.IArgumentsSetTimeshift=} [properties] Properties to set
	         * @returns {manager.ArgumentsSetTimeshift} ArgumentsSetTimeshift instance
	         */
	        ArgumentsSetTimeshift.create = function create(properties) {
	            return new ArgumentsSetTimeshift(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsSetTimeshift message. Does not implicitly {@link manager.ArgumentsSetTimeshift.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {manager.IArgumentsSetTimeshift} message ArgumentsSetTimeshift message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSetTimeshift.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Timeshift != null && message.hasOwnProperty("Timeshift"))
	                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.Timeshift);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsSetTimeshift message, length delimited. Does not implicitly {@link manager.ArgumentsSetTimeshift.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {manager.IArgumentsSetTimeshift} message ArgumentsSetTimeshift message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSetTimeshift.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsSetTimeshift message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsSetTimeshift} ArgumentsSetTimeshift
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSetTimeshift.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsSetTimeshift();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Timeshift = reader.uint64();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsSetTimeshift message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsSetTimeshift} ArgumentsSetTimeshift
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSetTimeshift.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsSetTimeshift message.
	         * @function verify
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsSetTimeshift.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Timeshift != null && message.hasOwnProperty("Timeshift"))
	                if (!$util.isInteger(message.Timeshift) && !(message.Timeshift && $util.isInteger(message.Timeshift.low) && $util.isInteger(message.Timeshift.high)))
	                    return "Timeshift: integer|Long expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsSetTimeshift message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsSetTimeshift} ArgumentsSetTimeshift
	         */
	        ArgumentsSetTimeshift.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsSetTimeshift)
	                return object;
	            var message = new $root.manager.ArgumentsSetTimeshift();
	            if (object.Timeshift != null)
	                if ($util.Long)
	                    (message.Timeshift = $util.Long.fromValue(object.Timeshift)).unsigned = true;
	                else if (typeof object.Timeshift === "string")
	                    message.Timeshift = parseInt(object.Timeshift, 10);
	                else if (typeof object.Timeshift === "number")
	                    message.Timeshift = object.Timeshift;
	                else if (typeof object.Timeshift === "object")
	                    message.Timeshift = new $util.LongBits(object.Timeshift.low >>> 0, object.Timeshift.high >>> 0).toNumber(true);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsSetTimeshift message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsSetTimeshift
	         * @static
	         * @param {manager.ArgumentsSetTimeshift} message ArgumentsSetTimeshift
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsSetTimeshift.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                if ($util.Long) {
	                    var long = new $util.Long(0, 0, true);
	                    object.Timeshift = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
	                } else
	                    object.Timeshift = options.longs === String ? "0" : 0;
	            if (message.Timeshift != null && message.hasOwnProperty("Timeshift"))
	                if (typeof message.Timeshift === "number")
	                    object.Timeshift = options.longs === String ? String(message.Timeshift) : message.Timeshift;
	                else
	                    object.Timeshift = options.longs === String ? $util.Long.prototype.toString.call(message.Timeshift) : options.longs === Number ? new $util.LongBits(message.Timeshift.low >>> 0, message.Timeshift.high >>> 0).toNumber(true) : message.Timeshift;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsSetTimeshift to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsSetTimeshift
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsSetTimeshift.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsSetTimeshift;
	    })();
	
	    /**
	     * SwipeLeftReason enum.
	     * @name manager.SwipeLeftReason
	     * @enum {string}
	     * @property {number} UnknownSwipeLeftReason=0 UnknownSwipeLeftReason value
	     * @property {number} SwipeLeftNotReachable=1 SwipeLeftNotReachable value
	     * @property {number} SwipeLeftTimedOut=2 SwipeLeftTimedOut value
	     * @property {number} SwipeLeftNotInteresting=3 SwipeLeftNotInteresting value
	     */
	    manager.SwipeLeftReason = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "UnknownSwipeLeftReason"] = 0;
	        values[valuesById[1] = "SwipeLeftNotReachable"] = 1;
	        values[valuesById[2] = "SwipeLeftTimedOut"] = 2;
	        values[valuesById[3] = "SwipeLeftNotInteresting"] = 3;
	        return values;
	    })();
	
	    manager.ArgumentsSwipeLeft = (function() {
	
	        /**
	         * Properties of an ArgumentsSwipeLeft.
	         * @memberof manager
	         * @interface IArgumentsSwipeLeft
	         * @property {string|null} [Peer] ArgumentsSwipeLeft Peer
	         * @property {manager.SwipeLeftReason|null} [Reason] ArgumentsSwipeLeft Reason
	         */
	
	        /**
	         * Constructs a new ArgumentsSwipeLeft.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsSwipeLeft.
	         * @implements IArgumentsSwipeLeft
	         * @constructor
	         * @param {manager.IArgumentsSwipeLeft=} [properties] Properties to set
	         */
	        function ArgumentsSwipeLeft(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsSwipeLeft Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsSwipeLeft
	         * @instance
	         */
	        ArgumentsSwipeLeft.prototype.Peer = "";
	
	        /**
	         * ArgumentsSwipeLeft Reason.
	         * @member {manager.SwipeLeftReason} Reason
	         * @memberof manager.ArgumentsSwipeLeft
	         * @instance
	         */
	        ArgumentsSwipeLeft.prototype.Reason = 0;
	
	        /**
	         * Creates a new ArgumentsSwipeLeft instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {manager.IArgumentsSwipeLeft=} [properties] Properties to set
	         * @returns {manager.ArgumentsSwipeLeft} ArgumentsSwipeLeft instance
	         */
	        ArgumentsSwipeLeft.create = function create(properties) {
	            return new ArgumentsSwipeLeft(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsSwipeLeft message. Does not implicitly {@link manager.ArgumentsSwipeLeft.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {manager.IArgumentsSwipeLeft} message ArgumentsSwipeLeft message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSwipeLeft.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peer);
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Reason);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsSwipeLeft message, length delimited. Does not implicitly {@link manager.ArgumentsSwipeLeft.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {manager.IArgumentsSwipeLeft} message ArgumentsSwipeLeft message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSwipeLeft.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsSwipeLeft message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsSwipeLeft} ArgumentsSwipeLeft
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSwipeLeft.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsSwipeLeft();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Peer = reader.string();
	                    break;
	                case 2:
	                    message.Reason = reader.int32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsSwipeLeft message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsSwipeLeft} ArgumentsSwipeLeft
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSwipeLeft.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsSwipeLeft message.
	         * @function verify
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsSwipeLeft.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                switch (message.Reason) {
	                default:
	                    return "Reason: enum value expected";
	                case 0:
	                case 1:
	                case 2:
	                case 3:
	                    break;
	                }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsSwipeLeft message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsSwipeLeft} ArgumentsSwipeLeft
	         */
	        ArgumentsSwipeLeft.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsSwipeLeft)
	                return object;
	            var message = new $root.manager.ArgumentsSwipeLeft();
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            switch (object.Reason) {
	            case "UnknownSwipeLeftReason":
	            case 0:
	                message.Reason = 0;
	                break;
	            case "SwipeLeftNotReachable":
	            case 1:
	                message.Reason = 1;
	                break;
	            case "SwipeLeftTimedOut":
	            case 2:
	                message.Reason = 2;
	                break;
	            case "SwipeLeftNotInteresting":
	            case 3:
	                message.Reason = 3;
	                break;
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsSwipeLeft message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsSwipeLeft
	         * @static
	         * @param {manager.ArgumentsSwipeLeft} message ArgumentsSwipeLeft
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsSwipeLeft.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults) {
	                object.Peer = "";
	                object.Reason = options.enums === String ? "UnknownSwipeLeftReason" : 0;
	            }
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                object.Reason = options.enums === String ? $root.manager.SwipeLeftReason[message.Reason] : message.Reason;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsSwipeLeft to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsSwipeLeft
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsSwipeLeft.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsSwipeLeft;
	    })();
	
	    manager.ArgumentsSwipeRight = (function() {
	
	        /**
	         * Properties of an ArgumentsSwipeRight.
	         * @memberof manager
	         * @interface IArgumentsSwipeRight
	         * @property {string|null} [Peer] ArgumentsSwipeRight Peer
	         * @property {string|null} [Offer] ArgumentsSwipeRight Offer
	         * @property {Array.<string>|null} [Candidates] ArgumentsSwipeRight Candidates
	         */
	
	        /**
	         * Constructs a new ArgumentsSwipeRight.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsSwipeRight.
	         * @implements IArgumentsSwipeRight
	         * @constructor
	         * @param {manager.IArgumentsSwipeRight=} [properties] Properties to set
	         */
	        function ArgumentsSwipeRight(properties) {
	            this.Candidates = [];
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsSwipeRight Peer.
	         * @member {string} Peer
	         * @memberof manager.ArgumentsSwipeRight
	         * @instance
	         */
	        ArgumentsSwipeRight.prototype.Peer = "";
	
	        /**
	         * ArgumentsSwipeRight Offer.
	         * @member {string} Offer
	         * @memberof manager.ArgumentsSwipeRight
	         * @instance
	         */
	        ArgumentsSwipeRight.prototype.Offer = "";
	
	        /**
	         * ArgumentsSwipeRight Candidates.
	         * @member {Array.<string>} Candidates
	         * @memberof manager.ArgumentsSwipeRight
	         * @instance
	         */
	        ArgumentsSwipeRight.prototype.Candidates = $util.emptyArray;
	
	        /**
	         * Creates a new ArgumentsSwipeRight instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {manager.IArgumentsSwipeRight=} [properties] Properties to set
	         * @returns {manager.ArgumentsSwipeRight} ArgumentsSwipeRight instance
	         */
	        ArgumentsSwipeRight.create = function create(properties) {
	            return new ArgumentsSwipeRight(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsSwipeRight message. Does not implicitly {@link manager.ArgumentsSwipeRight.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {manager.IArgumentsSwipeRight} message ArgumentsSwipeRight message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSwipeRight.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Peer);
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Offer);
	            if (message.Candidates != null && message.Candidates.length)
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.Candidates[i]);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsSwipeRight message, length delimited. Does not implicitly {@link manager.ArgumentsSwipeRight.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {manager.IArgumentsSwipeRight} message ArgumentsSwipeRight message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSwipeRight.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsSwipeRight message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsSwipeRight} ArgumentsSwipeRight
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSwipeRight.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsSwipeRight();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Peer = reader.string();
	                    break;
	                case 2:
	                    message.Offer = reader.string();
	                    break;
	                case 3:
	                    if (!(message.Candidates && message.Candidates.length))
	                        message.Candidates = [];
	                    message.Candidates.push(reader.string());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsSwipeRight message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsSwipeRight} ArgumentsSwipeRight
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSwipeRight.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsSwipeRight message.
	         * @function verify
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsSwipeRight.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                if (!$util.isString(message.Peer))
	                    return "Peer: string expected";
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                if (!$util.isString(message.Offer))
	                    return "Offer: string expected";
	            if (message.Candidates != null && message.hasOwnProperty("Candidates")) {
	                if (!Array.isArray(message.Candidates))
	                    return "Candidates: array expected";
	                for (var i = 0; i < message.Candidates.length; ++i)
	                    if (!$util.isString(message.Candidates[i]))
	                        return "Candidates: string[] expected";
	            }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsSwipeRight message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsSwipeRight} ArgumentsSwipeRight
	         */
	        ArgumentsSwipeRight.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsSwipeRight)
	                return object;
	            var message = new $root.manager.ArgumentsSwipeRight();
	            if (object.Peer != null)
	                message.Peer = String(object.Peer);
	            if (object.Offer != null)
	                message.Offer = String(object.Offer);
	            if (object.Candidates) {
	                if (!Array.isArray(object.Candidates))
	                    throw TypeError(".manager.ArgumentsSwipeRight.Candidates: array expected");
	                message.Candidates = [];
	                for (var i = 0; i < object.Candidates.length; ++i)
	                    message.Candidates[i] = String(object.Candidates[i]);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsSwipeRight message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsSwipeRight
	         * @static
	         * @param {manager.ArgumentsSwipeRight} message ArgumentsSwipeRight
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsSwipeRight.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.arrays || options.defaults)
	                object.Candidates = [];
	            if (options.defaults) {
	                object.Peer = "";
	                object.Offer = "";
	            }
	            if (message.Peer != null && message.hasOwnProperty("Peer"))
	                object.Peer = message.Peer;
	            if (message.Offer != null && message.hasOwnProperty("Offer"))
	                object.Offer = message.Offer;
	            if (message.Candidates && message.Candidates.length) {
	                object.Candidates = [];
	                for (var j = 0; j < message.Candidates.length; ++j)
	                    object.Candidates[j] = message.Candidates[j];
	            }
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsSwipeRight to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsSwipeRight
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsSwipeRight.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsSwipeRight;
	    })();
	
	    /**
	     * UnregisterReason enum.
	     * @name manager.UnregisterReason
	     * @enum {string}
	     * @property {number} UnknownUnregisterReason=0 UnknownUnregisterReason value
	     * @property {number} UnregisterPlaybackPaused=1 UnregisterPlaybackPaused value
	     * @property {number} UnregisterFinished=2 UnregisterFinished value
	     * @property {number} UnregisterClosed=3 UnregisterClosed value
	     * @property {number} UnregisterSwitching=4 UnregisterSwitching value
	     */
	    manager.UnregisterReason = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "UnknownUnregisterReason"] = 0;
	        values[valuesById[1] = "UnregisterPlaybackPaused"] = 1;
	        values[valuesById[2] = "UnregisterFinished"] = 2;
	        values[valuesById[3] = "UnregisterClosed"] = 3;
	        values[valuesById[4] = "UnregisterSwitching"] = 4;
	        return values;
	    })();
	
	    manager.ArgumentsUnregister = (function() {
	
	        /**
	         * Properties of an ArgumentsUnregister.
	         * @memberof manager
	         * @interface IArgumentsUnregister
	         * @property {manager.UnregisterReason|null} [Reason] ArgumentsUnregister Reason
	         */
	
	        /**
	         * Constructs a new ArgumentsUnregister.
	         * @memberof manager
	         * @classdesc Represents an ArgumentsUnregister.
	         * @implements IArgumentsUnregister
	         * @constructor
	         * @param {manager.IArgumentsUnregister=} [properties] Properties to set
	         */
	        function ArgumentsUnregister(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsUnregister Reason.
	         * @member {manager.UnregisterReason} Reason
	         * @memberof manager.ArgumentsUnregister
	         * @instance
	         */
	        ArgumentsUnregister.prototype.Reason = 0;
	
	        /**
	         * Creates a new ArgumentsUnregister instance using the specified properties.
	         * @function create
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {manager.IArgumentsUnregister=} [properties] Properties to set
	         * @returns {manager.ArgumentsUnregister} ArgumentsUnregister instance
	         */
	        ArgumentsUnregister.create = function create(properties) {
	            return new ArgumentsUnregister(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsUnregister message. Does not implicitly {@link manager.ArgumentsUnregister.verify|verify} messages.
	         * @function encode
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {manager.IArgumentsUnregister} message ArgumentsUnregister message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsUnregister.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Reason);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsUnregister message, length delimited. Does not implicitly {@link manager.ArgumentsUnregister.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {manager.IArgumentsUnregister} message ArgumentsUnregister message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsUnregister.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsUnregister message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.ArgumentsUnregister} ArgumentsUnregister
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsUnregister.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.ArgumentsUnregister();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Reason = reader.int32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsUnregister message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.ArgumentsUnregister} ArgumentsUnregister
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsUnregister.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsUnregister message.
	         * @function verify
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsUnregister.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                switch (message.Reason) {
	                default:
	                    return "Reason: enum value expected";
	                case 0:
	                case 1:
	                case 2:
	                case 3:
	                case 4:
	                    break;
	                }
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsUnregister message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.ArgumentsUnregister} ArgumentsUnregister
	         */
	        ArgumentsUnregister.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.ArgumentsUnregister)
	                return object;
	            var message = new $root.manager.ArgumentsUnregister();
	            switch (object.Reason) {
	            case "UnknownUnregisterReason":
	            case 0:
	                message.Reason = 0;
	                break;
	            case "UnregisterPlaybackPaused":
	            case 1:
	                message.Reason = 1;
	                break;
	            case "UnregisterFinished":
	            case 2:
	                message.Reason = 2;
	                break;
	            case "UnregisterClosed":
	            case 3:
	                message.Reason = 3;
	                break;
	            case "UnregisterSwitching":
	            case 4:
	                message.Reason = 4;
	                break;
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsUnregister message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.ArgumentsUnregister
	         * @static
	         * @param {manager.ArgumentsUnregister} message ArgumentsUnregister
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsUnregister.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Reason = options.enums === String ? "UnknownUnregisterReason" : 0;
	            if (message.Reason != null && message.hasOwnProperty("Reason"))
	                object.Reason = options.enums === String ? $root.manager.UnregisterReason[message.Reason] : message.Reason;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsUnregister to JSON.
	         * @function toJSON
	         * @memberof manager.ArgumentsUnregister
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsUnregister.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsUnregister;
	    })();
	
	    /**
	     * MessageType enum.
	     * @name manager.MessageType
	     * @enum {string}
	     * @property {number} MessageTypeUnknown=0 MessageTypeUnknown value
	     * @property {number} MessageTypeRegister=256 MessageTypeRegister value
	     * @property {number} MessageTypeUnregister=257 MessageTypeUnregister value
	     * @property {number} MessageTypeSetBandwidth=258 MessageTypeSetBandwidth value
	     * @property {number} MessageTypeSetTimeshift=259 MessageTypeSetTimeshift value
	     * @property {number} MessageTypeImGood=260 MessageTypeImGood value
	     * @property {number} MessageTypeGiveMePeers=512 MessageTypeGiveMePeers value
	     * @property {number} MessageTypeHereAreSomePeers=513 MessageTypeHereAreSomePeers value
	     * @property {number} MessageTypeSwipeRight=514 MessageTypeSwipeRight value
	     * @property {number} MessageTypeItsAMatch=515 MessageTypeItsAMatch value
	     * @property {number} MessageTypeSwipeLeft=516 MessageTypeSwipeLeft value
	     * @property {number} MessageTypePeerLeft=517 MessageTypePeerLeft value
	     * @property {number} MessageTypePairingRequest=518 MessageTypePairingRequest value
	     * @property {number} MessageTypeHereAreMyMatches=519 MessageTypeHereAreMyMatches value
	     * @property {number} MessageTypeEnhanceYourCalm=768 MessageTypeEnhanceYourCalm value
	     * @property {number} MessageTypeBye=769 MessageTypeBye value
	     * @property {number} MessageTypeRegistered=771 MessageTypeRegistered value
	     * @property {number} MessageTypePairingInProgress=772 MessageTypePairingInProgress value
	     */
	    manager.MessageType = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "MessageTypeUnknown"] = 0;
	        values[valuesById[256] = "MessageTypeRegister"] = 256;
	        values[valuesById[257] = "MessageTypeUnregister"] = 257;
	        values[valuesById[258] = "MessageTypeSetBandwidth"] = 258;
	        values[valuesById[259] = "MessageTypeSetTimeshift"] = 259;
	        values[valuesById[260] = "MessageTypeImGood"] = 260;
	        values[valuesById[512] = "MessageTypeGiveMePeers"] = 512;
	        values[valuesById[513] = "MessageTypeHereAreSomePeers"] = 513;
	        values[valuesById[514] = "MessageTypeSwipeRight"] = 514;
	        values[valuesById[515] = "MessageTypeItsAMatch"] = 515;
	        values[valuesById[516] = "MessageTypeSwipeLeft"] = 516;
	        values[valuesById[517] = "MessageTypePeerLeft"] = 517;
	        values[valuesById[518] = "MessageTypePairingRequest"] = 518;
	        values[valuesById[519] = "MessageTypeHereAreMyMatches"] = 519;
	        values[valuesById[768] = "MessageTypeEnhanceYourCalm"] = 768;
	        values[valuesById[769] = "MessageTypeBye"] = 769;
	        values[valuesById[771] = "MessageTypeRegistered"] = 771;
	        values[valuesById[772] = "MessageTypePairingInProgress"] = 772;
	        return values;
	    })();
	
	    manager.Message = (function() {
	
	        /**
	         * Properties of a Message.
	         * @memberof manager
	         * @interface IMessage
	         * @property {manager.MessageType|null} [Type] Message Type
	         * @property {manager.IArgumentsRegister|null} [ArgumentsRegister] Message ArgumentsRegister
	         * @property {manager.IArgumentsUnregister|null} [ArgumentsUnregister] Message ArgumentsUnregister
	         * @property {manager.IArgumentsSetBandwidth|null} [ArgumentsSetBandwidth] Message ArgumentsSetBandwidth
	         * @property {manager.IArgumentsSetTimeshift|null} [ArgumentsSetTimeshift] Message ArgumentsSetTimeshift
	         * @property {manager.IArgumentsHereAreSomePeers|null} [ArgumentsHereAreSomePeers] Message ArgumentsHereAreSomePeers
	         * @property {manager.IArgumentsSwipeRight|null} [ArgumentsSwipeRight] Message ArgumentsSwipeRight
	         * @property {manager.IArgumentsItsAMatch|null} [ArgumentsItsAMatch] Message ArgumentsItsAMatch
	         * @property {manager.IArgumentsSwipeLeft|null} [ArgumentsSwipeLeft] Message ArgumentsSwipeLeft
	         * @property {manager.IArgumentsPeerLeft|null} [ArgumentsPeerLeft] Message ArgumentsPeerLeft
	         * @property {manager.IArgumentsBye|null} [ArgumentsBye] Message ArgumentsBye
	         * @property {manager.IArgumentsPairingRequest|null} [ArgumentsPairingRequest] Message ArgumentsPairingRequest
	         * @property {manager.IArgumentsRegistered|null} [ArgumentsRegistered] Message ArgumentsRegistered
	         * @property {manager.IArgumentsPairingInProgress|null} [ArgumentsPairingInProgress] Message ArgumentsPairingInProgress
	         * @property {manager.IArgumentsHereAreMyMatches|null} [ArgumentsHereAreMyMatches] Message ArgumentsHereAreMyMatches
	         */
	
	        /**
	         * Constructs a new Message.
	         * @memberof manager
	         * @classdesc Represents a Message.
	         * @implements IMessage
	         * @constructor
	         * @param {manager.IMessage=} [properties] Properties to set
	         */
	        function Message(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * Message Type.
	         * @member {manager.MessageType} Type
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.Type = 0;
	
	        /**
	         * Message ArgumentsRegister.
	         * @member {manager.IArgumentsRegister|null|undefined} ArgumentsRegister
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsRegister = null;
	
	        /**
	         * Message ArgumentsUnregister.
	         * @member {manager.IArgumentsUnregister|null|undefined} ArgumentsUnregister
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsUnregister = null;
	
	        /**
	         * Message ArgumentsSetBandwidth.
	         * @member {manager.IArgumentsSetBandwidth|null|undefined} ArgumentsSetBandwidth
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsSetBandwidth = null;
	
	        /**
	         * Message ArgumentsSetTimeshift.
	         * @member {manager.IArgumentsSetTimeshift|null|undefined} ArgumentsSetTimeshift
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsSetTimeshift = null;
	
	        /**
	         * Message ArgumentsHereAreSomePeers.
	         * @member {manager.IArgumentsHereAreSomePeers|null|undefined} ArgumentsHereAreSomePeers
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsHereAreSomePeers = null;
	
	        /**
	         * Message ArgumentsSwipeRight.
	         * @member {manager.IArgumentsSwipeRight|null|undefined} ArgumentsSwipeRight
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsSwipeRight = null;
	
	        /**
	         * Message ArgumentsItsAMatch.
	         * @member {manager.IArgumentsItsAMatch|null|undefined} ArgumentsItsAMatch
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsItsAMatch = null;
	
	        /**
	         * Message ArgumentsSwipeLeft.
	         * @member {manager.IArgumentsSwipeLeft|null|undefined} ArgumentsSwipeLeft
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsSwipeLeft = null;
	
	        /**
	         * Message ArgumentsPeerLeft.
	         * @member {manager.IArgumentsPeerLeft|null|undefined} ArgumentsPeerLeft
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsPeerLeft = null;
	
	        /**
	         * Message ArgumentsBye.
	         * @member {manager.IArgumentsBye|null|undefined} ArgumentsBye
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsBye = null;
	
	        /**
	         * Message ArgumentsPairingRequest.
	         * @member {manager.IArgumentsPairingRequest|null|undefined} ArgumentsPairingRequest
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsPairingRequest = null;
	
	        /**
	         * Message ArgumentsRegistered.
	         * @member {manager.IArgumentsRegistered|null|undefined} ArgumentsRegistered
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsRegistered = null;
	
	        /**
	         * Message ArgumentsPairingInProgress.
	         * @member {manager.IArgumentsPairingInProgress|null|undefined} ArgumentsPairingInProgress
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsPairingInProgress = null;
	
	        /**
	         * Message ArgumentsHereAreMyMatches.
	         * @member {manager.IArgumentsHereAreMyMatches|null|undefined} ArgumentsHereAreMyMatches
	         * @memberof manager.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsHereAreMyMatches = null;
	
	        // OneOf field names bound to virtual getters and setters
	        var $oneOfFields;
	
	        /**
	         * Message Arguments.
	         * @member {"ArgumentsRegister"|"ArgumentsUnregister"|"ArgumentsSetBandwidth"|"ArgumentsSetTimeshift"|"ArgumentsHereAreSomePeers"|"ArgumentsSwipeRight"|"ArgumentsItsAMatch"|"ArgumentsSwipeLeft"|"ArgumentsPeerLeft"|"ArgumentsBye"|"ArgumentsPairingRequest"|"ArgumentsRegistered"|"ArgumentsPairingInProgress"|"ArgumentsHereAreMyMatches"|undefined} Arguments
	         * @memberof manager.Message
	         * @instance
	         */
	        Object.defineProperty(Message.prototype, "Arguments", {
	            get: $util.oneOfGetter($oneOfFields = ["ArgumentsRegister", "ArgumentsUnregister", "ArgumentsSetBandwidth", "ArgumentsSetTimeshift", "ArgumentsHereAreSomePeers", "ArgumentsSwipeRight", "ArgumentsItsAMatch", "ArgumentsSwipeLeft", "ArgumentsPeerLeft", "ArgumentsBye", "ArgumentsPairingRequest", "ArgumentsRegistered", "ArgumentsPairingInProgress", "ArgumentsHereAreMyMatches"]),
	            set: $util.oneOfSetter($oneOfFields)
	        });
	
	        /**
	         * Creates a new Message instance using the specified properties.
	         * @function create
	         * @memberof manager.Message
	         * @static
	         * @param {manager.IMessage=} [properties] Properties to set
	         * @returns {manager.Message} Message instance
	         */
	        Message.create = function create(properties) {
	            return new Message(properties);
	        };
	
	        /**
	         * Encodes the specified Message message. Does not implicitly {@link manager.Message.verify|verify} messages.
	         * @function encode
	         * @memberof manager.Message
	         * @static
	         * @param {manager.IMessage} message Message message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        Message.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
	            if (message.ArgumentsRegister != null && message.hasOwnProperty("ArgumentsRegister"))
	                $root.manager.ArgumentsRegister.encode(message.ArgumentsRegister, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
	            if (message.ArgumentsUnregister != null && message.hasOwnProperty("ArgumentsUnregister"))
	                $root.manager.ArgumentsUnregister.encode(message.ArgumentsUnregister, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
	            if (message.ArgumentsSetBandwidth != null && message.hasOwnProperty("ArgumentsSetBandwidth"))
	                $root.manager.ArgumentsSetBandwidth.encode(message.ArgumentsSetBandwidth, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
	            if (message.ArgumentsSetTimeshift != null && message.hasOwnProperty("ArgumentsSetTimeshift"))
	                $root.manager.ArgumentsSetTimeshift.encode(message.ArgumentsSetTimeshift, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
	            if (message.ArgumentsHereAreSomePeers != null && message.hasOwnProperty("ArgumentsHereAreSomePeers"))
	                $root.manager.ArgumentsHereAreSomePeers.encode(message.ArgumentsHereAreSomePeers, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
	            if (message.ArgumentsSwipeRight != null && message.hasOwnProperty("ArgumentsSwipeRight"))
	                $root.manager.ArgumentsSwipeRight.encode(message.ArgumentsSwipeRight, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
	            if (message.ArgumentsItsAMatch != null && message.hasOwnProperty("ArgumentsItsAMatch"))
	                $root.manager.ArgumentsItsAMatch.encode(message.ArgumentsItsAMatch, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
	            if (message.ArgumentsSwipeLeft != null && message.hasOwnProperty("ArgumentsSwipeLeft"))
	                $root.manager.ArgumentsSwipeLeft.encode(message.ArgumentsSwipeLeft, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
	            if (message.ArgumentsPeerLeft != null && message.hasOwnProperty("ArgumentsPeerLeft"))
	                $root.manager.ArgumentsPeerLeft.encode(message.ArgumentsPeerLeft, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
	            if (message.ArgumentsBye != null && message.hasOwnProperty("ArgumentsBye"))
	                $root.manager.ArgumentsBye.encode(message.ArgumentsBye, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
	            if (message.ArgumentsPairingRequest != null && message.hasOwnProperty("ArgumentsPairingRequest"))
	                $root.manager.ArgumentsPairingRequest.encode(message.ArgumentsPairingRequest, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
	            if (message.ArgumentsRegistered != null && message.hasOwnProperty("ArgumentsRegistered"))
	                $root.manager.ArgumentsRegistered.encode(message.ArgumentsRegistered, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
	            if (message.ArgumentsPairingInProgress != null && message.hasOwnProperty("ArgumentsPairingInProgress"))
	                $root.manager.ArgumentsPairingInProgress.encode(message.ArgumentsPairingInProgress, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
	            if (message.ArgumentsHereAreMyMatches != null && message.hasOwnProperty("ArgumentsHereAreMyMatches"))
	                $root.manager.ArgumentsHereAreMyMatches.encode(message.ArgumentsHereAreMyMatches, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
	            return writer;
	        };
	
	        /**
	         * Encodes the specified Message message, length delimited. Does not implicitly {@link manager.Message.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof manager.Message
	         * @static
	         * @param {manager.IMessage} message Message message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        Message.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes a Message message from the specified reader or buffer.
	         * @function decode
	         * @memberof manager.Message
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {manager.Message} Message
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        Message.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.manager.Message();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Type = reader.int32();
	                    break;
	                case 10:
	                    message.ArgumentsRegister = $root.manager.ArgumentsRegister.decode(reader, reader.uint32());
	                    break;
	                case 11:
	                    message.ArgumentsUnregister = $root.manager.ArgumentsUnregister.decode(reader, reader.uint32());
	                    break;
	                case 12:
	                    message.ArgumentsSetBandwidth = $root.manager.ArgumentsSetBandwidth.decode(reader, reader.uint32());
	                    break;
	                case 13:
	                    message.ArgumentsSetTimeshift = $root.manager.ArgumentsSetTimeshift.decode(reader, reader.uint32());
	                    break;
	                case 14:
	                    message.ArgumentsHereAreSomePeers = $root.manager.ArgumentsHereAreSomePeers.decode(reader, reader.uint32());
	                    break;
	                case 15:
	                    message.ArgumentsSwipeRight = $root.manager.ArgumentsSwipeRight.decode(reader, reader.uint32());
	                    break;
	                case 16:
	                    message.ArgumentsItsAMatch = $root.manager.ArgumentsItsAMatch.decode(reader, reader.uint32());
	                    break;
	                case 17:
	                    message.ArgumentsSwipeLeft = $root.manager.ArgumentsSwipeLeft.decode(reader, reader.uint32());
	                    break;
	                case 18:
	                    message.ArgumentsPeerLeft = $root.manager.ArgumentsPeerLeft.decode(reader, reader.uint32());
	                    break;
	                case 20:
	                    message.ArgumentsBye = $root.manager.ArgumentsBye.decode(reader, reader.uint32());
	                    break;
	                case 21:
	                    message.ArgumentsPairingRequest = $root.manager.ArgumentsPairingRequest.decode(reader, reader.uint32());
	                    break;
	                case 22:
	                    message.ArgumentsRegistered = $root.manager.ArgumentsRegistered.decode(reader, reader.uint32());
	                    break;
	                case 23:
	                    message.ArgumentsPairingInProgress = $root.manager.ArgumentsPairingInProgress.decode(reader, reader.uint32());
	                    break;
	                case 24:
	                    message.ArgumentsHereAreMyMatches = $root.manager.ArgumentsHereAreMyMatches.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes a Message message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof manager.Message
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {manager.Message} Message
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        Message.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies a Message message.
	         * @function verify
	         * @memberof manager.Message
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        Message.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            var properties = {};
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                switch (message.Type) {
	                default:
	                    return "Type: enum value expected";
	                case 0:
	                case 256:
	                case 257:
	                case 258:
	                case 259:
	                case 260:
	                case 512:
	                case 513:
	                case 514:
	                case 515:
	                case 516:
	                case 517:
	                case 518:
	                case 519:
	                case 768:
	                case 769:
	                case 771:
	                case 772:
	                    break;
	                }
	            if (message.ArgumentsRegister != null && message.hasOwnProperty("ArgumentsRegister")) {
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsRegister.verify(message.ArgumentsRegister);
	                    if (error)
	                        return "ArgumentsRegister." + error;
	                }
	            }
	            if (message.ArgumentsUnregister != null && message.hasOwnProperty("ArgumentsUnregister")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsUnregister.verify(message.ArgumentsUnregister);
	                    if (error)
	                        return "ArgumentsUnregister." + error;
	                }
	            }
	            if (message.ArgumentsSetBandwidth != null && message.hasOwnProperty("ArgumentsSetBandwidth")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsSetBandwidth.verify(message.ArgumentsSetBandwidth);
	                    if (error)
	                        return "ArgumentsSetBandwidth." + error;
	                }
	            }
	            if (message.ArgumentsSetTimeshift != null && message.hasOwnProperty("ArgumentsSetTimeshift")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsSetTimeshift.verify(message.ArgumentsSetTimeshift);
	                    if (error)
	                        return "ArgumentsSetTimeshift." + error;
	                }
	            }
	            if (message.ArgumentsHereAreSomePeers != null && message.hasOwnProperty("ArgumentsHereAreSomePeers")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsHereAreSomePeers.verify(message.ArgumentsHereAreSomePeers);
	                    if (error)
	                        return "ArgumentsHereAreSomePeers." + error;
	                }
	            }
	            if (message.ArgumentsSwipeRight != null && message.hasOwnProperty("ArgumentsSwipeRight")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsSwipeRight.verify(message.ArgumentsSwipeRight);
	                    if (error)
	                        return "ArgumentsSwipeRight." + error;
	                }
	            }
	            if (message.ArgumentsItsAMatch != null && message.hasOwnProperty("ArgumentsItsAMatch")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsItsAMatch.verify(message.ArgumentsItsAMatch);
	                    if (error)
	                        return "ArgumentsItsAMatch." + error;
	                }
	            }
	            if (message.ArgumentsSwipeLeft != null && message.hasOwnProperty("ArgumentsSwipeLeft")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsSwipeLeft.verify(message.ArgumentsSwipeLeft);
	                    if (error)
	                        return "ArgumentsSwipeLeft." + error;
	                }
	            }
	            if (message.ArgumentsPeerLeft != null && message.hasOwnProperty("ArgumentsPeerLeft")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsPeerLeft.verify(message.ArgumentsPeerLeft);
	                    if (error)
	                        return "ArgumentsPeerLeft." + error;
	                }
	            }
	            if (message.ArgumentsBye != null && message.hasOwnProperty("ArgumentsBye")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsBye.verify(message.ArgumentsBye);
	                    if (error)
	                        return "ArgumentsBye." + error;
	                }
	            }
	            if (message.ArgumentsPairingRequest != null && message.hasOwnProperty("ArgumentsPairingRequest")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsPairingRequest.verify(message.ArgumentsPairingRequest);
	                    if (error)
	                        return "ArgumentsPairingRequest." + error;
	                }
	            }
	            if (message.ArgumentsRegistered != null && message.hasOwnProperty("ArgumentsRegistered")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsRegistered.verify(message.ArgumentsRegistered);
	                    if (error)
	                        return "ArgumentsRegistered." + error;
	                }
	            }
	            if (message.ArgumentsPairingInProgress != null && message.hasOwnProperty("ArgumentsPairingInProgress")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsPairingInProgress.verify(message.ArgumentsPairingInProgress);
	                    if (error)
	                        return "ArgumentsPairingInProgress." + error;
	                }
	            }
	            if (message.ArgumentsHereAreMyMatches != null && message.hasOwnProperty("ArgumentsHereAreMyMatches")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.manager.ArgumentsHereAreMyMatches.verify(message.ArgumentsHereAreMyMatches);
	                    if (error)
	                        return "ArgumentsHereAreMyMatches." + error;
	                }
	            }
	            return null;
	        };
	
	        /**
	         * Creates a Message message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof manager.Message
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {manager.Message} Message
	         */
	        Message.fromObject = function fromObject(object) {
	            if (object instanceof $root.manager.Message)
	                return object;
	            var message = new $root.manager.Message();
	            switch (object.Type) {
	            case "MessageTypeUnknown":
	            case 0:
	                message.Type = 0;
	                break;
	            case "MessageTypeRegister":
	            case 256:
	                message.Type = 256;
	                break;
	            case "MessageTypeUnregister":
	            case 257:
	                message.Type = 257;
	                break;
	            case "MessageTypeSetBandwidth":
	            case 258:
	                message.Type = 258;
	                break;
	            case "MessageTypeSetTimeshift":
	            case 259:
	                message.Type = 259;
	                break;
	            case "MessageTypeImGood":
	            case 260:
	                message.Type = 260;
	                break;
	            case "MessageTypeGiveMePeers":
	            case 512:
	                message.Type = 512;
	                break;
	            case "MessageTypeHereAreSomePeers":
	            case 513:
	                message.Type = 513;
	                break;
	            case "MessageTypeSwipeRight":
	            case 514:
	                message.Type = 514;
	                break;
	            case "MessageTypeItsAMatch":
	            case 515:
	                message.Type = 515;
	                break;
	            case "MessageTypeSwipeLeft":
	            case 516:
	                message.Type = 516;
	                break;
	            case "MessageTypePeerLeft":
	            case 517:
	                message.Type = 517;
	                break;
	            case "MessageTypePairingRequest":
	            case 518:
	                message.Type = 518;
	                break;
	            case "MessageTypeHereAreMyMatches":
	            case 519:
	                message.Type = 519;
	                break;
	            case "MessageTypeEnhanceYourCalm":
	            case 768:
	                message.Type = 768;
	                break;
	            case "MessageTypeBye":
	            case 769:
	                message.Type = 769;
	                break;
	            case "MessageTypeRegistered":
	            case 771:
	                message.Type = 771;
	                break;
	            case "MessageTypePairingInProgress":
	            case 772:
	                message.Type = 772;
	                break;
	            }
	            if (object.ArgumentsRegister != null) {
	                if (typeof object.ArgumentsRegister !== "object")
	                    throw TypeError(".manager.Message.ArgumentsRegister: object expected");
	                message.ArgumentsRegister = $root.manager.ArgumentsRegister.fromObject(object.ArgumentsRegister);
	            }
	            if (object.ArgumentsUnregister != null) {
	                if (typeof object.ArgumentsUnregister !== "object")
	                    throw TypeError(".manager.Message.ArgumentsUnregister: object expected");
	                message.ArgumentsUnregister = $root.manager.ArgumentsUnregister.fromObject(object.ArgumentsUnregister);
	            }
	            if (object.ArgumentsSetBandwidth != null) {
	                if (typeof object.ArgumentsSetBandwidth !== "object")
	                    throw TypeError(".manager.Message.ArgumentsSetBandwidth: object expected");
	                message.ArgumentsSetBandwidth = $root.manager.ArgumentsSetBandwidth.fromObject(object.ArgumentsSetBandwidth);
	            }
	            if (object.ArgumentsSetTimeshift != null) {
	                if (typeof object.ArgumentsSetTimeshift !== "object")
	                    throw TypeError(".manager.Message.ArgumentsSetTimeshift: object expected");
	                message.ArgumentsSetTimeshift = $root.manager.ArgumentsSetTimeshift.fromObject(object.ArgumentsSetTimeshift);
	            }
	            if (object.ArgumentsHereAreSomePeers != null) {
	                if (typeof object.ArgumentsHereAreSomePeers !== "object")
	                    throw TypeError(".manager.Message.ArgumentsHereAreSomePeers: object expected");
	                message.ArgumentsHereAreSomePeers = $root.manager.ArgumentsHereAreSomePeers.fromObject(object.ArgumentsHereAreSomePeers);
	            }
	            if (object.ArgumentsSwipeRight != null) {
	                if (typeof object.ArgumentsSwipeRight !== "object")
	                    throw TypeError(".manager.Message.ArgumentsSwipeRight: object expected");
	                message.ArgumentsSwipeRight = $root.manager.ArgumentsSwipeRight.fromObject(object.ArgumentsSwipeRight);
	            }
	            if (object.ArgumentsItsAMatch != null) {
	                if (typeof object.ArgumentsItsAMatch !== "object")
	                    throw TypeError(".manager.Message.ArgumentsItsAMatch: object expected");
	                message.ArgumentsItsAMatch = $root.manager.ArgumentsItsAMatch.fromObject(object.ArgumentsItsAMatch);
	            }
	            if (object.ArgumentsSwipeLeft != null) {
	                if (typeof object.ArgumentsSwipeLeft !== "object")
	                    throw TypeError(".manager.Message.ArgumentsSwipeLeft: object expected");
	                message.ArgumentsSwipeLeft = $root.manager.ArgumentsSwipeLeft.fromObject(object.ArgumentsSwipeLeft);
	            }
	            if (object.ArgumentsPeerLeft != null) {
	                if (typeof object.ArgumentsPeerLeft !== "object")
	                    throw TypeError(".manager.Message.ArgumentsPeerLeft: object expected");
	                message.ArgumentsPeerLeft = $root.manager.ArgumentsPeerLeft.fromObject(object.ArgumentsPeerLeft);
	            }
	            if (object.ArgumentsBye != null) {
	                if (typeof object.ArgumentsBye !== "object")
	                    throw TypeError(".manager.Message.ArgumentsBye: object expected");
	                message.ArgumentsBye = $root.manager.ArgumentsBye.fromObject(object.ArgumentsBye);
	            }
	            if (object.ArgumentsPairingRequest != null) {
	                if (typeof object.ArgumentsPairingRequest !== "object")
	                    throw TypeError(".manager.Message.ArgumentsPairingRequest: object expected");
	                message.ArgumentsPairingRequest = $root.manager.ArgumentsPairingRequest.fromObject(object.ArgumentsPairingRequest);
	            }
	            if (object.ArgumentsRegistered != null) {
	                if (typeof object.ArgumentsRegistered !== "object")
	                    throw TypeError(".manager.Message.ArgumentsRegistered: object expected");
	                message.ArgumentsRegistered = $root.manager.ArgumentsRegistered.fromObject(object.ArgumentsRegistered);
	            }
	            if (object.ArgumentsPairingInProgress != null) {
	                if (typeof object.ArgumentsPairingInProgress !== "object")
	                    throw TypeError(".manager.Message.ArgumentsPairingInProgress: object expected");
	                message.ArgumentsPairingInProgress = $root.manager.ArgumentsPairingInProgress.fromObject(object.ArgumentsPairingInProgress);
	            }
	            if (object.ArgumentsHereAreMyMatches != null) {
	                if (typeof object.ArgumentsHereAreMyMatches !== "object")
	                    throw TypeError(".manager.Message.ArgumentsHereAreMyMatches: object expected");
	                message.ArgumentsHereAreMyMatches = $root.manager.ArgumentsHereAreMyMatches.fromObject(object.ArgumentsHereAreMyMatches);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from a Message message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof manager.Message
	         * @static
	         * @param {manager.Message} message Message
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        Message.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Type = options.enums === String ? "MessageTypeUnknown" : 0;
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                object.Type = options.enums === String ? $root.manager.MessageType[message.Type] : message.Type;
	            if (message.ArgumentsRegister != null && message.hasOwnProperty("ArgumentsRegister")) {
	                object.ArgumentsRegister = $root.manager.ArgumentsRegister.toObject(message.ArgumentsRegister, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsRegister";
	            }
	            if (message.ArgumentsUnregister != null && message.hasOwnProperty("ArgumentsUnregister")) {
	                object.ArgumentsUnregister = $root.manager.ArgumentsUnregister.toObject(message.ArgumentsUnregister, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsUnregister";
	            }
	            if (message.ArgumentsSetBandwidth != null && message.hasOwnProperty("ArgumentsSetBandwidth")) {
	                object.ArgumentsSetBandwidth = $root.manager.ArgumentsSetBandwidth.toObject(message.ArgumentsSetBandwidth, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsSetBandwidth";
	            }
	            if (message.ArgumentsSetTimeshift != null && message.hasOwnProperty("ArgumentsSetTimeshift")) {
	                object.ArgumentsSetTimeshift = $root.manager.ArgumentsSetTimeshift.toObject(message.ArgumentsSetTimeshift, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsSetTimeshift";
	            }
	            if (message.ArgumentsHereAreSomePeers != null && message.hasOwnProperty("ArgumentsHereAreSomePeers")) {
	                object.ArgumentsHereAreSomePeers = $root.manager.ArgumentsHereAreSomePeers.toObject(message.ArgumentsHereAreSomePeers, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsHereAreSomePeers";
	            }
	            if (message.ArgumentsSwipeRight != null && message.hasOwnProperty("ArgumentsSwipeRight")) {
	                object.ArgumentsSwipeRight = $root.manager.ArgumentsSwipeRight.toObject(message.ArgumentsSwipeRight, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsSwipeRight";
	            }
	            if (message.ArgumentsItsAMatch != null && message.hasOwnProperty("ArgumentsItsAMatch")) {
	                object.ArgumentsItsAMatch = $root.manager.ArgumentsItsAMatch.toObject(message.ArgumentsItsAMatch, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsItsAMatch";
	            }
	            if (message.ArgumentsSwipeLeft != null && message.hasOwnProperty("ArgumentsSwipeLeft")) {
	                object.ArgumentsSwipeLeft = $root.manager.ArgumentsSwipeLeft.toObject(message.ArgumentsSwipeLeft, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsSwipeLeft";
	            }
	            if (message.ArgumentsPeerLeft != null && message.hasOwnProperty("ArgumentsPeerLeft")) {
	                object.ArgumentsPeerLeft = $root.manager.ArgumentsPeerLeft.toObject(message.ArgumentsPeerLeft, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsPeerLeft";
	            }
	            if (message.ArgumentsBye != null && message.hasOwnProperty("ArgumentsBye")) {
	                object.ArgumentsBye = $root.manager.ArgumentsBye.toObject(message.ArgumentsBye, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsBye";
	            }
	            if (message.ArgumentsPairingRequest != null && message.hasOwnProperty("ArgumentsPairingRequest")) {
	                object.ArgumentsPairingRequest = $root.manager.ArgumentsPairingRequest.toObject(message.ArgumentsPairingRequest, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsPairingRequest";
	            }
	            if (message.ArgumentsRegistered != null && message.hasOwnProperty("ArgumentsRegistered")) {
	                object.ArgumentsRegistered = $root.manager.ArgumentsRegistered.toObject(message.ArgumentsRegistered, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsRegistered";
	            }
	            if (message.ArgumentsPairingInProgress != null && message.hasOwnProperty("ArgumentsPairingInProgress")) {
	                object.ArgumentsPairingInProgress = $root.manager.ArgumentsPairingInProgress.toObject(message.ArgumentsPairingInProgress, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsPairingInProgress";
	            }
	            if (message.ArgumentsHereAreMyMatches != null && message.hasOwnProperty("ArgumentsHereAreMyMatches")) {
	                object.ArgumentsHereAreMyMatches = $root.manager.ArgumentsHereAreMyMatches.toObject(message.ArgumentsHereAreMyMatches, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsHereAreMyMatches";
	            }
	            return object;
	        };
	
	        /**
	         * Converts this Message to JSON.
	         * @function toJSON
	         * @memberof manager.Message
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        Message.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return Message;
	    })();
	
	    return manager;
	})();
	
	module.exports = $root;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	// minimal library entry point.
	
	"use strict";
	module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var protobuf = exports;
	
	/**
	 * Build type, one of `"full"`, `"light"` or `"minimal"`.
	 * @name build
	 * @type {string}
	 * @const
	 */
	protobuf.build = "minimal";
	
	// Serialization
	protobuf.Writer       = __webpack_require__(4);
	protobuf.BufferWriter = __webpack_require__(14);
	protobuf.Reader       = __webpack_require__(15);
	protobuf.BufferReader = __webpack_require__(16);
	
	// Utility
	protobuf.util         = __webpack_require__(5);
	protobuf.rpc          = __webpack_require__(17);
	protobuf.roots        = __webpack_require__(19);
	protobuf.configure    = configure;
	
	/* istanbul ignore next */
	/**
	 * Reconfigures the library according to the environment.
	 * @returns {undefined}
	 */
	function configure() {
	    protobuf.Reader._configure(protobuf.BufferReader);
	    protobuf.util._configure();
	}
	
	// Configure serialization
	protobuf.Writer._configure(protobuf.BufferWriter);
	configure();


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = Writer;
	
	var util      = __webpack_require__(5);
	
	var BufferWriter; // cyclic
	
	var LongBits  = util.LongBits,
	    base64    = util.base64,
	    utf8      = util.utf8;
	
	/**
	 * Constructs a new writer operation instance.
	 * @classdesc Scheduled writer operation.
	 * @constructor
	 * @param {function(*, Uint8Array, number)} fn Function to call
	 * @param {number} len Value byte length
	 * @param {*} val Value to write
	 * @ignore
	 */
	function Op(fn, len, val) {
	
	    /**
	     * Function to call.
	     * @type {function(Uint8Array, number, *)}
	     */
	    this.fn = fn;
	
	    /**
	     * Value byte length.
	     * @type {number}
	     */
	    this.len = len;
	
	    /**
	     * Next operation.
	     * @type {Writer.Op|undefined}
	     */
	    this.next = undefined;
	
	    /**
	     * Value to write.
	     * @type {*}
	     */
	    this.val = val; // type varies
	}
	
	/* istanbul ignore next */
	function noop() {} // eslint-disable-line no-empty-function
	
	/**
	 * Constructs a new writer state instance.
	 * @classdesc Copied writer state.
	 * @memberof Writer
	 * @constructor
	 * @param {Writer} writer Writer to copy state from
	 * @ignore
	 */
	function State(writer) {
	
	    /**
	     * Current head.
	     * @type {Writer.Op}
	     */
	    this.head = writer.head;
	
	    /**
	     * Current tail.
	     * @type {Writer.Op}
	     */
	    this.tail = writer.tail;
	
	    /**
	     * Current buffer length.
	     * @type {number}
	     */
	    this.len = writer.len;
	
	    /**
	     * Next state.
	     * @type {State|null}
	     */
	    this.next = writer.states;
	}
	
	/**
	 * Constructs a new writer instance.
	 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
	 * @constructor
	 */
	function Writer() {
	
	    /**
	     * Current length.
	     * @type {number}
	     */
	    this.len = 0;
	
	    /**
	     * Operations head.
	     * @type {Object}
	     */
	    this.head = new Op(noop, 0, 0);
	
	    /**
	     * Operations tail
	     * @type {Object}
	     */
	    this.tail = this.head;
	
	    /**
	     * Linked forked states.
	     * @type {Object|null}
	     */
	    this.states = null;
	
	    // When a value is written, the writer calculates its byte length and puts it into a linked
	    // list of operations to perform when finish() is called. This both allows us to allocate
	    // buffers of the exact required size and reduces the amount of work we have to do compared
	    // to first calculating over objects and then encoding over objects. In our case, the encoding
	    // part is just a linked list walk calling operations with already prepared values.
	}
	
	/**
	 * Creates a new writer.
	 * @function
	 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
	 */
	Writer.create = util.Buffer
	    ? function create_buffer_setup() {
	        return (Writer.create = function create_buffer() {
	            return new BufferWriter();
	        })();
	    }
	    /* istanbul ignore next */
	    : function create_array() {
	        return new Writer();
	    };
	
	/**
	 * Allocates a buffer of the specified size.
	 * @param {number} size Buffer size
	 * @returns {Uint8Array} Buffer
	 */
	Writer.alloc = function alloc(size) {
	    return new util.Array(size);
	};
	
	// Use Uint8Array buffer pool in the browser, just like node does with buffers
	/* istanbul ignore else */
	if (util.Array !== Array)
	    Writer.alloc = util.pool(Writer.alloc, util.Array.prototype.subarray);
	
	/**
	 * Pushes a new operation to the queue.
	 * @param {function(Uint8Array, number, *)} fn Function to call
	 * @param {number} len Value byte length
	 * @param {number} val Value to write
	 * @returns {Writer} `this`
	 * @private
	 */
	Writer.prototype._push = function push(fn, len, val) {
	    this.tail = this.tail.next = new Op(fn, len, val);
	    this.len += len;
	    return this;
	};
	
	function writeByte(val, buf, pos) {
	    buf[pos] = val & 255;
	}
	
	function writeVarint32(val, buf, pos) {
	    while (val > 127) {
	        buf[pos++] = val & 127 | 128;
	        val >>>= 7;
	    }
	    buf[pos] = val;
	}
	
	/**
	 * Constructs a new varint writer operation instance.
	 * @classdesc Scheduled varint writer operation.
	 * @extends Op
	 * @constructor
	 * @param {number} len Value byte length
	 * @param {number} val Value to write
	 * @ignore
	 */
	function VarintOp(len, val) {
	    this.len = len;
	    this.next = undefined;
	    this.val = val;
	}
	
	VarintOp.prototype = Object.create(Op.prototype);
	VarintOp.prototype.fn = writeVarint32;
	
	/**
	 * Writes an unsigned 32 bit value as a varint.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.uint32 = function write_uint32(value) {
	    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
	    // uint32 is by far the most frequently used operation and benefits significantly from this.
	    this.len += (this.tail = this.tail.next = new VarintOp(
	        (value = value >>> 0)
	                < 128       ? 1
	        : value < 16384     ? 2
	        : value < 2097152   ? 3
	        : value < 268435456 ? 4
	        :                     5,
	    value)).len;
	    return this;
	};
	
	/**
	 * Writes a signed 32 bit value as a varint.
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.int32 = function write_int32(value) {
	    return value < 0
	        ? this._push(writeVarint64, 10, LongBits.fromNumber(value)) // 10 bytes per spec
	        : this.uint32(value);
	};
	
	/**
	 * Writes a 32 bit value as a varint, zig-zag encoded.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.sint32 = function write_sint32(value) {
	    return this.uint32((value << 1 ^ value >> 31) >>> 0);
	};
	
	function writeVarint64(val, buf, pos) {
	    while (val.hi) {
	        buf[pos++] = val.lo & 127 | 128;
	        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
	        val.hi >>>= 7;
	    }
	    while (val.lo > 127) {
	        buf[pos++] = val.lo & 127 | 128;
	        val.lo = val.lo >>> 7;
	    }
	    buf[pos++] = val.lo;
	}
	
	/**
	 * Writes an unsigned 64 bit value as a varint.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer.prototype.uint64 = function write_uint64(value) {
	    var bits = LongBits.from(value);
	    return this._push(writeVarint64, bits.length(), bits);
	};
	
	/**
	 * Writes a signed 64 bit value as a varint.
	 * @function
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer.prototype.int64 = Writer.prototype.uint64;
	
	/**
	 * Writes a signed 64 bit value as a varint, zig-zag encoded.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer.prototype.sint64 = function write_sint64(value) {
	    var bits = LongBits.from(value).zzEncode();
	    return this._push(writeVarint64, bits.length(), bits);
	};
	
	/**
	 * Writes a boolish value as a varint.
	 * @param {boolean} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.bool = function write_bool(value) {
	    return this._push(writeByte, 1, value ? 1 : 0);
	};
	
	function writeFixed32(val, buf, pos) {
	    buf[pos    ] =  val         & 255;
	    buf[pos + 1] =  val >>> 8   & 255;
	    buf[pos + 2] =  val >>> 16  & 255;
	    buf[pos + 3] =  val >>> 24;
	}
	
	/**
	 * Writes an unsigned 32 bit value as fixed 32 bits.
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.fixed32 = function write_fixed32(value) {
	    return this._push(writeFixed32, 4, value >>> 0);
	};
	
	/**
	 * Writes a signed 32 bit value as fixed 32 bits.
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.sfixed32 = Writer.prototype.fixed32;
	
	/**
	 * Writes an unsigned 64 bit value as fixed 64 bits.
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer.prototype.fixed64 = function write_fixed64(value) {
	    var bits = LongBits.from(value);
	    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
	};
	
	/**
	 * Writes a signed 64 bit value as fixed 64 bits.
	 * @function
	 * @param {Long|number|string} value Value to write
	 * @returns {Writer} `this`
	 * @throws {TypeError} If `value` is a string and no long library is present.
	 */
	Writer.prototype.sfixed64 = Writer.prototype.fixed64;
	
	/**
	 * Writes a float (32 bit).
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.float = function write_float(value) {
	    return this._push(util.float.writeFloatLE, 4, value);
	};
	
	/**
	 * Writes a double (64 bit float).
	 * @function
	 * @param {number} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.double = function write_double(value) {
	    return this._push(util.float.writeDoubleLE, 8, value);
	};
	
	var writeBytes = util.Array.prototype.set
	    ? function writeBytes_set(val, buf, pos) {
	        buf.set(val, pos); // also works for plain array values
	    }
	    /* istanbul ignore next */
	    : function writeBytes_for(val, buf, pos) {
	        for (var i = 0; i < val.length; ++i)
	            buf[pos + i] = val[i];
	    };
	
	/**
	 * Writes a sequence of bytes.
	 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.bytes = function write_bytes(value) {
	    var len = value.length >>> 0;
	    if (!len)
	        return this._push(writeByte, 1, 0);
	    if (util.isString(value)) {
	        var buf = Writer.alloc(len = base64.length(value));
	        base64.decode(value, buf, 0);
	        value = buf;
	    }
	    return this.uint32(len)._push(writeBytes, len, value);
	};
	
	/**
	 * Writes a string.
	 * @param {string} value Value to write
	 * @returns {Writer} `this`
	 */
	Writer.prototype.string = function write_string(value) {
	    var len = utf8.length(value);
	    return len
	        ? this.uint32(len)._push(utf8.write, len, value)
	        : this._push(writeByte, 1, 0);
	};
	
	/**
	 * Forks this writer's state by pushing it to a stack.
	 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
	 * @returns {Writer} `this`
	 */
	Writer.prototype.fork = function fork() {
	    this.states = new State(this);
	    this.head = this.tail = new Op(noop, 0, 0);
	    this.len = 0;
	    return this;
	};
	
	/**
	 * Resets this instance to the last state.
	 * @returns {Writer} `this`
	 */
	Writer.prototype.reset = function reset() {
	    if (this.states) {
	        this.head   = this.states.head;
	        this.tail   = this.states.tail;
	        this.len    = this.states.len;
	        this.states = this.states.next;
	    } else {
	        this.head = this.tail = new Op(noop, 0, 0);
	        this.len  = 0;
	    }
	    return this;
	};
	
	/**
	 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
	 * @returns {Writer} `this`
	 */
	Writer.prototype.ldelim = function ldelim() {
	    var head = this.head,
	        tail = this.tail,
	        len  = this.len;
	    this.reset().uint32(len);
	    if (len) {
	        this.tail.next = head.next; // skip noop
	        this.tail = tail;
	        this.len += len;
	    }
	    return this;
	};
	
	/**
	 * Finishes the write operation.
	 * @returns {Uint8Array} Finished buffer
	 */
	Writer.prototype.finish = function finish() {
	    var head = this.head.next, // skip noop
	        buf  = this.constructor.alloc(this.len),
	        pos  = 0;
	    while (head) {
	        head.fn(head.val, buf, pos);
	        pos += head.len;
	        head = head.next;
	    }
	    // this.head = this.tail = null;
	    return buf;
	};
	
	Writer._configure = function(BufferWriter_) {
	    BufferWriter = BufferWriter_;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var util = exports;
	
	// used to return a Promise where callback is omitted
	util.asPromise = __webpack_require__(6);
	
	// converts to / from base64 encoded strings
	util.base64 = __webpack_require__(7);
	
	// base class of rpc.Service
	util.EventEmitter = __webpack_require__(8);
	
	// float handling accross browsers
	util.float = __webpack_require__(9);
	
	// requires modules optionally and hides the call from bundlers
	util.inquire = __webpack_require__(10);
	
	// converts to / from utf8 encoded strings
	util.utf8 = __webpack_require__(11);
	
	// provides a node-like buffer pool in the browser
	util.pool = __webpack_require__(12);
	
	// utility to work with the low and high bits of a 64 bit value
	util.LongBits = __webpack_require__(13);
	
	/**
	 * An immuable empty array.
	 * @memberof util
	 * @type {Array.<*>}
	 * @const
	 */
	util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
	
	/**
	 * An immutable empty object.
	 * @type {Object}
	 * @const
	 */
	util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
	
	/**
	 * Whether running within node or not.
	 * @memberof util
	 * @type {boolean}
	 * @const
	 */
	util.isNode = Boolean(global.process && global.process.versions && global.process.versions.node);
	
	/**
	 * Tests if the specified value is an integer.
	 * @function
	 * @param {*} value Value to test
	 * @returns {boolean} `true` if the value is an integer
	 */
	util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
	    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
	};
	
	/**
	 * Tests if the specified value is a string.
	 * @param {*} value Value to test
	 * @returns {boolean} `true` if the value is a string
	 */
	util.isString = function isString(value) {
	    return typeof value === "string" || value instanceof String;
	};
	
	/**
	 * Tests if the specified value is a non-null object.
	 * @param {*} value Value to test
	 * @returns {boolean} `true` if the value is a non-null object
	 */
	util.isObject = function isObject(value) {
	    return value && typeof value === "object";
	};
	
	/**
	 * Checks if a property on a message is considered to be present.
	 * This is an alias of {@link util.isSet}.
	 * @function
	 * @param {Object} obj Plain object or message instance
	 * @param {string} prop Property name
	 * @returns {boolean} `true` if considered to be present, otherwise `false`
	 */
	util.isset =
	
	/**
	 * Checks if a property on a message is considered to be present.
	 * @param {Object} obj Plain object or message instance
	 * @param {string} prop Property name
	 * @returns {boolean} `true` if considered to be present, otherwise `false`
	 */
	util.isSet = function isSet(obj, prop) {
	    var value = obj[prop];
	    if (value != null && obj.hasOwnProperty(prop)) // eslint-disable-line eqeqeq, no-prototype-builtins
	        return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
	    return false;
	};
	
	/**
	 * Any compatible Buffer instance.
	 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
	 * @interface Buffer
	 * @extends Uint8Array
	 */
	
	/**
	 * Node's Buffer class if available.
	 * @type {Constructor<Buffer>}
	 */
	util.Buffer = (function() {
	    try {
	        var Buffer = util.inquire("buffer").Buffer;
	        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
	        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
	    } catch (e) {
	        /* istanbul ignore next */
	        return null;
	    }
	})();
	
	// Internal alias of or polyfull for Buffer.from.
	util._Buffer_from = null;
	
	// Internal alias of or polyfill for Buffer.allocUnsafe.
	util._Buffer_allocUnsafe = null;
	
	/**
	 * Creates a new buffer of whatever type supported by the environment.
	 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
	 * @returns {Uint8Array|Buffer} Buffer
	 */
	util.newBuffer = function newBuffer(sizeOrArray) {
	    /* istanbul ignore next */
	    return typeof sizeOrArray === "number"
	        ? util.Buffer
	            ? util._Buffer_allocUnsafe(sizeOrArray)
	            : new util.Array(sizeOrArray)
	        : util.Buffer
	            ? util._Buffer_from(sizeOrArray)
	            : typeof Uint8Array === "undefined"
	                ? sizeOrArray
	                : new Uint8Array(sizeOrArray);
	};
	
	/**
	 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
	 * @type {Constructor<Uint8Array>}
	 */
	util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */ : Array;
	
	/**
	 * Any compatible Long instance.
	 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
	 * @interface Long
	 * @property {number} low Low bits
	 * @property {number} high High bits
	 * @property {boolean} unsigned Whether unsigned or not
	 */
	
	/**
	 * Long.js's Long class if available.
	 * @type {Constructor<Long>}
	 */
	util.Long = /* istanbul ignore next */ global.dcodeIO && /* istanbul ignore next */ global.dcodeIO.Long || util.inquire("long");
	
	/**
	 * Regular expression used to verify 2 bit (`bool`) map keys.
	 * @type {RegExp}
	 * @const
	 */
	util.key2Re = /^true|false|0|1$/;
	
	/**
	 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
	 * @type {RegExp}
	 * @const
	 */
	util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
	
	/**
	 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
	 * @type {RegExp}
	 * @const
	 */
	util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
	
	/**
	 * Converts a number or long to an 8 characters long hash string.
	 * @param {Long|number} value Value to convert
	 * @returns {string} Hash
	 */
	util.longToHash = function longToHash(value) {
	    return value
	        ? util.LongBits.from(value).toHash()
	        : util.LongBits.zeroHash;
	};
	
	/**
	 * Converts an 8 characters long hash string to a long or number.
	 * @param {string} hash Hash
	 * @param {boolean} [unsigned=false] Whether unsigned or not
	 * @returns {Long|number} Original value
	 */
	util.longFromHash = function longFromHash(hash, unsigned) {
	    var bits = util.LongBits.fromHash(hash);
	    if (util.Long)
	        return util.Long.fromBits(bits.lo, bits.hi, unsigned);
	    return bits.toNumber(Boolean(unsigned));
	};
	
	/**
	 * Merges the properties of the source object into the destination object.
	 * @memberof util
	 * @param {Object.<string,*>} dst Destination object
	 * @param {Object.<string,*>} src Source object
	 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
	 * @returns {Object.<string,*>} Destination object
	 */
	function merge(dst, src, ifNotSet) { // used by converters
	    for (var keys = Object.keys(src), i = 0; i < keys.length; ++i)
	        if (dst[keys[i]] === undefined || !ifNotSet)
	            dst[keys[i]] = src[keys[i]];
	    return dst;
	}
	
	util.merge = merge;
	
	/**
	 * Converts the first character of a string to lower case.
	 * @param {string} str String to convert
	 * @returns {string} Converted string
	 */
	util.lcFirst = function lcFirst(str) {
	    return str.charAt(0).toLowerCase() + str.substring(1);
	};
	
	/**
	 * Creates a custom error constructor.
	 * @memberof util
	 * @param {string} name Error name
	 * @returns {Constructor<Error>} Custom error constructor
	 */
	function newError(name) {
	
	    function CustomError(message, properties) {
	
	        if (!(this instanceof CustomError))
	            return new CustomError(message, properties);
	
	        // Error.call(this, message);
	        // ^ just returns a new error instance because the ctor can be called as a function
	
	        Object.defineProperty(this, "message", { get: function() { return message; } });
	
	        /* istanbul ignore next */
	        if (Error.captureStackTrace) // node
	            Error.captureStackTrace(this, CustomError);
	        else
	            Object.defineProperty(this, "stack", { value: (new Error()).stack || "" });
	
	        if (properties)
	            merge(this, properties);
	    }
	
	    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
	
	    Object.defineProperty(CustomError.prototype, "name", { get: function() { return name; } });
	
	    CustomError.prototype.toString = function toString() {
	        return this.name + ": " + this.message;
	    };
	
	    return CustomError;
	}
	
	util.newError = newError;
	
	/**
	 * Constructs a new protocol error.
	 * @classdesc Error subclass indicating a protocol specifc error.
	 * @memberof util
	 * @extends Error
	 * @template T extends Message<T>
	 * @constructor
	 * @param {string} message Error message
	 * @param {Object.<string,*>} [properties] Additional properties
	 * @example
	 * try {
	 *     MyMessage.decode(someBuffer); // throws if required fields are missing
	 * } catch (e) {
	 *     if (e instanceof ProtocolError && e.instance)
	 *         console.log("decoded so far: " + JSON.stringify(e.instance));
	 * }
	 */
	util.ProtocolError = newError("ProtocolError");
	
	/**
	 * So far decoded message instance.
	 * @name util.ProtocolError#instance
	 * @type {Message<T>}
	 */
	
	/**
	 * A OneOf getter as returned by {@link util.oneOfGetter}.
	 * @typedef OneOfGetter
	 * @type {function}
	 * @returns {string|undefined} Set field name, if any
	 */
	
	/**
	 * Builds a getter for a oneof's present field name.
	 * @param {string[]} fieldNames Field names
	 * @returns {OneOfGetter} Unbound getter
	 */
	util.oneOfGetter = function getOneOf(fieldNames) {
	    var fieldMap = {};
	    for (var i = 0; i < fieldNames.length; ++i)
	        fieldMap[fieldNames[i]] = 1;
	
	    /**
	     * @returns {string|undefined} Set field name, if any
	     * @this Object
	     * @ignore
	     */
	    return function() { // eslint-disable-line consistent-return
	        for (var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)
	            if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null)
	                return keys[i];
	    };
	};
	
	/**
	 * A OneOf setter as returned by {@link util.oneOfSetter}.
	 * @typedef OneOfSetter
	 * @type {function}
	 * @param {string|undefined} value Field name
	 * @returns {undefined}
	 */
	
	/**
	 * Builds a setter for a oneof's present field name.
	 * @param {string[]} fieldNames Field names
	 * @returns {OneOfSetter} Unbound setter
	 */
	util.oneOfSetter = function setOneOf(fieldNames) {
	
	    /**
	     * @param {string} name Field name
	     * @returns {undefined}
	     * @this Object
	     * @ignore
	     */
	    return function(name) {
	        for (var i = 0; i < fieldNames.length; ++i)
	            if (fieldNames[i] !== name)
	                delete this[fieldNames[i]];
	    };
	};
	
	/**
	 * Default conversion options used for {@link Message#toJSON} implementations.
	 *
	 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
	 *
	 * - Longs become strings
	 * - Enums become string keys
	 * - Bytes become base64 encoded strings
	 * - (Sub-)Messages become plain objects
	 * - Maps become plain objects with all string keys
	 * - Repeated fields become arrays
	 * - NaN and Infinity for float and double fields become strings
	 *
	 * @type {IConversionOptions}
	 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
	 */
	util.toJSONOptions = {
	    longs: String,
	    enums: String,
	    bytes: String,
	    json: true
	};
	
	util._configure = function() {
	    var Buffer = util.Buffer;
	    /* istanbul ignore if */
	    if (!Buffer) {
	        util._Buffer_from = util._Buffer_allocUnsafe = null;
	        return;
	    }
	    // because node 4.x buffers are incompatible & immutable
	    // see: https://github.com/dcodeIO/protobuf.js/pull/665
	    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from ||
	        /* istanbul ignore next */
	        function Buffer_from(value, encoding) {
	            return new Buffer(value, encoding);
	        };
	    util._Buffer_allocUnsafe = Buffer.allocUnsafe ||
	        /* istanbul ignore next */
	        function Buffer_allocUnsafe(size) {
	            return new Buffer(size);
	        };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = asPromise;
	
	/**
	 * Callback as used by {@link util.asPromise}.
	 * @typedef asPromiseCallback
	 * @type {function}
	 * @param {Error|null} error Error, if any
	 * @param {...*} params Additional arguments
	 * @returns {undefined}
	 */
	
	/**
	 * Returns a promise from a node-style callback function.
	 * @memberof util
	 * @param {asPromiseCallback} fn Function to call
	 * @param {*} ctx Function context
	 * @param {...*} params Function arguments
	 * @returns {Promise<*>} Promisified function
	 */
	function asPromise(fn, ctx/*, varargs */) {
	    var params  = new Array(arguments.length - 1),
	        offset  = 0,
	        index   = 2,
	        pending = true;
	    while (index < arguments.length)
	        params[offset++] = arguments[index++];
	    return new Promise(function executor(resolve, reject) {
	        params[offset] = function callback(err/*, varargs */) {
	            if (pending) {
	                pending = false;
	                if (err)
	                    reject(err);
	                else {
	                    var params = new Array(arguments.length - 1),
	                        offset = 0;
	                    while (offset < params.length)
	                        params[offset++] = arguments[offset];
	                    resolve.apply(null, params);
	                }
	            }
	        };
	        try {
	            fn.apply(ctx || null, params);
	        } catch (err) {
	            if (pending) {
	                pending = false;
	                reject(err);
	            }
	        }
	    });
	}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * A minimal base64 implementation for number arrays.
	 * @memberof util
	 * @namespace
	 */
	var base64 = exports;
	
	/**
	 * Calculates the byte length of a base64 encoded string.
	 * @param {string} string Base64 encoded string
	 * @returns {number} Byte length
	 */
	base64.length = function length(string) {
	    var p = string.length;
	    if (!p)
	        return 0;
	    var n = 0;
	    while (--p % 4 > 1 && string.charAt(p) === "=")
	        ++n;
	    return Math.ceil(string.length * 3) / 4 - n;
	};
	
	// Base64 encoding table
	var b64 = new Array(64);
	
	// Base64 decoding table
	var s64 = new Array(123);
	
	// 65..90, 97..122, 48..57, 43, 47
	for (var i = 0; i < 64;)
	    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
	
	/**
	 * Encodes a buffer to a base64 encoded string.
	 * @param {Uint8Array} buffer Source buffer
	 * @param {number} start Source start
	 * @param {number} end Source end
	 * @returns {string} Base64 encoded string
	 */
	base64.encode = function encode(buffer, start, end) {
	    var parts = null,
	        chunk = [];
	    var i = 0, // output index
	        j = 0, // goto index
	        t;     // temporary
	    while (start < end) {
	        var b = buffer[start++];
	        switch (j) {
	            case 0:
	                chunk[i++] = b64[b >> 2];
	                t = (b & 3) << 4;
	                j = 1;
	                break;
	            case 1:
	                chunk[i++] = b64[t | b >> 4];
	                t = (b & 15) << 2;
	                j = 2;
	                break;
	            case 2:
	                chunk[i++] = b64[t | b >> 6];
	                chunk[i++] = b64[b & 63];
	                j = 0;
	                break;
	        }
	        if (i > 8191) {
	            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
	            i = 0;
	        }
	    }
	    if (j) {
	        chunk[i++] = b64[t];
	        chunk[i++] = 61;
	        if (j === 1)
	            chunk[i++] = 61;
	    }
	    if (parts) {
	        if (i)
	            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
	        return parts.join("");
	    }
	    return String.fromCharCode.apply(String, chunk.slice(0, i));
	};
	
	var invalidEncoding = "invalid encoding";
	
	/**
	 * Decodes a base64 encoded string to a buffer.
	 * @param {string} string Source string
	 * @param {Uint8Array} buffer Destination buffer
	 * @param {number} offset Destination offset
	 * @returns {number} Number of bytes written
	 * @throws {Error} If encoding is invalid
	 */
	base64.decode = function decode(string, buffer, offset) {
	    var start = offset;
	    var j = 0, // goto index
	        t;     // temporary
	    for (var i = 0; i < string.length;) {
	        var c = string.charCodeAt(i++);
	        if (c === 61 && j > 1)
	            break;
	        if ((c = s64[c]) === undefined)
	            throw Error(invalidEncoding);
	        switch (j) {
	            case 0:
	                t = c;
	                j = 1;
	                break;
	            case 1:
	                buffer[offset++] = t << 2 | (c & 48) >> 4;
	                t = c;
	                j = 2;
	                break;
	            case 2:
	                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
	                t = c;
	                j = 3;
	                break;
	            case 3:
	                buffer[offset++] = (t & 3) << 6 | c;
	                j = 0;
	                break;
	        }
	    }
	    if (j === 1)
	        throw Error(invalidEncoding);
	    return offset - start;
	};
	
	/**
	 * Tests if the specified string appears to be base64 encoded.
	 * @param {string} string String to test
	 * @returns {boolean} `true` if probably base64 encoded, otherwise false
	 */
	base64.test = function test(string) {
	    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = EventEmitter;
	
	/**
	 * Constructs a new event emitter instance.
	 * @classdesc A minimal event emitter.
	 * @memberof util
	 * @constructor
	 */
	function EventEmitter() {
	
	    /**
	     * Registered listeners.
	     * @type {Object.<string,*>}
	     * @private
	     */
	    this._listeners = {};
	}
	
	/**
	 * Registers an event listener.
	 * @param {string} evt Event name
	 * @param {function} fn Listener
	 * @param {*} [ctx] Listener context
	 * @returns {util.EventEmitter} `this`
	 */
	EventEmitter.prototype.on = function on(evt, fn, ctx) {
	    (this._listeners[evt] || (this._listeners[evt] = [])).push({
	        fn  : fn,
	        ctx : ctx || this
	    });
	    return this;
	};
	
	/**
	 * Removes an event listener or any matching listeners if arguments are omitted.
	 * @param {string} [evt] Event name. Removes all listeners if omitted.
	 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
	 * @returns {util.EventEmitter} `this`
	 */
	EventEmitter.prototype.off = function off(evt, fn) {
	    if (evt === undefined)
	        this._listeners = {};
	    else {
	        if (fn === undefined)
	            this._listeners[evt] = [];
	        else {
	            var listeners = this._listeners[evt];
	            for (var i = 0; i < listeners.length;)
	                if (listeners[i].fn === fn)
	                    listeners.splice(i, 1);
	                else
	                    ++i;
	        }
	    }
	    return this;
	};
	
	/**
	 * Emits an event by calling its listeners with the specified arguments.
	 * @param {string} evt Event name
	 * @param {...*} args Arguments
	 * @returns {util.EventEmitter} `this`
	 */
	EventEmitter.prototype.emit = function emit(evt) {
	    var listeners = this._listeners[evt];
	    if (listeners) {
	        var args = [],
	            i = 1;
	        for (; i < arguments.length;)
	            args.push(arguments[i++]);
	        for (i = 0; i < listeners.length;)
	            listeners[i].fn.apply(listeners[i++].ctx, args);
	    }
	    return this;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = factory(factory);
	
	/**
	 * Reads / writes floats / doubles from / to buffers.
	 * @name util.float
	 * @namespace
	 */
	
	/**
	 * Writes a 32 bit float to a buffer using little endian byte order.
	 * @name util.float.writeFloatLE
	 * @function
	 * @param {number} val Value to write
	 * @param {Uint8Array} buf Target buffer
	 * @param {number} pos Target buffer offset
	 * @returns {undefined}
	 */
	
	/**
	 * Writes a 32 bit float to a buffer using big endian byte order.
	 * @name util.float.writeFloatBE
	 * @function
	 * @param {number} val Value to write
	 * @param {Uint8Array} buf Target buffer
	 * @param {number} pos Target buffer offset
	 * @returns {undefined}
	 */
	
	/**
	 * Reads a 32 bit float from a buffer using little endian byte order.
	 * @name util.float.readFloatLE
	 * @function
	 * @param {Uint8Array} buf Source buffer
	 * @param {number} pos Source buffer offset
	 * @returns {number} Value read
	 */
	
	/**
	 * Reads a 32 bit float from a buffer using big endian byte order.
	 * @name util.float.readFloatBE
	 * @function
	 * @param {Uint8Array} buf Source buffer
	 * @param {number} pos Source buffer offset
	 * @returns {number} Value read
	 */
	
	/**
	 * Writes a 64 bit double to a buffer using little endian byte order.
	 * @name util.float.writeDoubleLE
	 * @function
	 * @param {number} val Value to write
	 * @param {Uint8Array} buf Target buffer
	 * @param {number} pos Target buffer offset
	 * @returns {undefined}
	 */
	
	/**
	 * Writes a 64 bit double to a buffer using big endian byte order.
	 * @name util.float.writeDoubleBE
	 * @function
	 * @param {number} val Value to write
	 * @param {Uint8Array} buf Target buffer
	 * @param {number} pos Target buffer offset
	 * @returns {undefined}
	 */
	
	/**
	 * Reads a 64 bit double from a buffer using little endian byte order.
	 * @name util.float.readDoubleLE
	 * @function
	 * @param {Uint8Array} buf Source buffer
	 * @param {number} pos Source buffer offset
	 * @returns {number} Value read
	 */
	
	/**
	 * Reads a 64 bit double from a buffer using big endian byte order.
	 * @name util.float.readDoubleBE
	 * @function
	 * @param {Uint8Array} buf Source buffer
	 * @param {number} pos Source buffer offset
	 * @returns {number} Value read
	 */
	
	// Factory function for the purpose of node-based testing in modified global environments
	function factory(exports) {
	
	    // float: typed array
	    if (typeof Float32Array !== "undefined") (function() {
	
	        var f32 = new Float32Array([ -0 ]),
	            f8b = new Uint8Array(f32.buffer),
	            le  = f8b[3] === 128;
	
	        function writeFloat_f32_cpy(val, buf, pos) {
	            f32[0] = val;
	            buf[pos    ] = f8b[0];
	            buf[pos + 1] = f8b[1];
	            buf[pos + 2] = f8b[2];
	            buf[pos + 3] = f8b[3];
	        }
	
	        function writeFloat_f32_rev(val, buf, pos) {
	            f32[0] = val;
	            buf[pos    ] = f8b[3];
	            buf[pos + 1] = f8b[2];
	            buf[pos + 2] = f8b[1];
	            buf[pos + 3] = f8b[0];
	        }
	
	        /* istanbul ignore next */
	        exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
	        /* istanbul ignore next */
	        exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
	
	        function readFloat_f32_cpy(buf, pos) {
	            f8b[0] = buf[pos    ];
	            f8b[1] = buf[pos + 1];
	            f8b[2] = buf[pos + 2];
	            f8b[3] = buf[pos + 3];
	            return f32[0];
	        }
	
	        function readFloat_f32_rev(buf, pos) {
	            f8b[3] = buf[pos    ];
	            f8b[2] = buf[pos + 1];
	            f8b[1] = buf[pos + 2];
	            f8b[0] = buf[pos + 3];
	            return f32[0];
	        }
	
	        /* istanbul ignore next */
	        exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
	        /* istanbul ignore next */
	        exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
	
	    // float: ieee754
	    })(); else (function() {
	
	        function writeFloat_ieee754(writeUint, val, buf, pos) {
	            var sign = val < 0 ? 1 : 0;
	            if (sign)
	                val = -val;
	            if (val === 0)
	                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
	            else if (isNaN(val))
	                writeUint(2143289344, buf, pos);
	            else if (val > 3.4028234663852886e+38) // +-Infinity
	                writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
	            else if (val < 1.1754943508222875e-38) // denormal
	                writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
	            else {
	                var exponent = Math.floor(Math.log(val) / Math.LN2),
	                    mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
	                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
	            }
	        }
	
	        exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
	        exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
	
	        function readFloat_ieee754(readUint, buf, pos) {
	            var uint = readUint(buf, pos),
	                sign = (uint >> 31) * 2 + 1,
	                exponent = uint >>> 23 & 255,
	                mantissa = uint & 8388607;
	            return exponent === 255
	                ? mantissa
	                ? NaN
	                : sign * Infinity
	                : exponent === 0 // denormal
	                ? sign * 1.401298464324817e-45 * mantissa
	                : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
	        }
	
	        exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
	        exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
	
	    })();
	
	    // double: typed array
	    if (typeof Float64Array !== "undefined") (function() {
	
	        var f64 = new Float64Array([-0]),
	            f8b = new Uint8Array(f64.buffer),
	            le  = f8b[7] === 128;
	
	        function writeDouble_f64_cpy(val, buf, pos) {
	            f64[0] = val;
	            buf[pos    ] = f8b[0];
	            buf[pos + 1] = f8b[1];
	            buf[pos + 2] = f8b[2];
	            buf[pos + 3] = f8b[3];
	            buf[pos + 4] = f8b[4];
	            buf[pos + 5] = f8b[5];
	            buf[pos + 6] = f8b[6];
	            buf[pos + 7] = f8b[7];
	        }
	
	        function writeDouble_f64_rev(val, buf, pos) {
	            f64[0] = val;
	            buf[pos    ] = f8b[7];
	            buf[pos + 1] = f8b[6];
	            buf[pos + 2] = f8b[5];
	            buf[pos + 3] = f8b[4];
	            buf[pos + 4] = f8b[3];
	            buf[pos + 5] = f8b[2];
	            buf[pos + 6] = f8b[1];
	            buf[pos + 7] = f8b[0];
	        }
	
	        /* istanbul ignore next */
	        exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
	        /* istanbul ignore next */
	        exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
	
	        function readDouble_f64_cpy(buf, pos) {
	            f8b[0] = buf[pos    ];
	            f8b[1] = buf[pos + 1];
	            f8b[2] = buf[pos + 2];
	            f8b[3] = buf[pos + 3];
	            f8b[4] = buf[pos + 4];
	            f8b[5] = buf[pos + 5];
	            f8b[6] = buf[pos + 6];
	            f8b[7] = buf[pos + 7];
	            return f64[0];
	        }
	
	        function readDouble_f64_rev(buf, pos) {
	            f8b[7] = buf[pos    ];
	            f8b[6] = buf[pos + 1];
	            f8b[5] = buf[pos + 2];
	            f8b[4] = buf[pos + 3];
	            f8b[3] = buf[pos + 4];
	            f8b[2] = buf[pos + 5];
	            f8b[1] = buf[pos + 6];
	            f8b[0] = buf[pos + 7];
	            return f64[0];
	        }
	
	        /* istanbul ignore next */
	        exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
	        /* istanbul ignore next */
	        exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
	
	    // double: ieee754
	    })(); else (function() {
	
	        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
	            var sign = val < 0 ? 1 : 0;
	            if (sign)
	                val = -val;
	            if (val === 0) {
	                writeUint(0, buf, pos + off0);
	                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
	            } else if (isNaN(val)) {
	                writeUint(0, buf, pos + off0);
	                writeUint(2146959360, buf, pos + off1);
	            } else if (val > 1.7976931348623157e+308) { // +-Infinity
	                writeUint(0, buf, pos + off0);
	                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
	            } else {
	                var mantissa;
	                if (val < 2.2250738585072014e-308) { // denormal
	                    mantissa = val / 5e-324;
	                    writeUint(mantissa >>> 0, buf, pos + off0);
	                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
	                } else {
	                    var exponent = Math.floor(Math.log(val) / Math.LN2);
	                    if (exponent === 1024)
	                        exponent = 1023;
	                    mantissa = val * Math.pow(2, -exponent);
	                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
	                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
	                }
	            }
	        }
	
	        exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
	        exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
	
	        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
	            var lo = readUint(buf, pos + off0),
	                hi = readUint(buf, pos + off1);
	            var sign = (hi >> 31) * 2 + 1,
	                exponent = hi >>> 20 & 2047,
	                mantissa = 4294967296 * (hi & 1048575) + lo;
	            return exponent === 2047
	                ? mantissa
	                ? NaN
	                : sign * Infinity
	                : exponent === 0 // denormal
	                ? sign * 5e-324 * mantissa
	                : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
	        }
	
	        exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
	        exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
	
	    })();
	
	    return exports;
	}
	
	// uint helpers
	
	function writeUintLE(val, buf, pos) {
	    buf[pos    ] =  val        & 255;
	    buf[pos + 1] =  val >>> 8  & 255;
	    buf[pos + 2] =  val >>> 16 & 255;
	    buf[pos + 3] =  val >>> 24;
	}
	
	function writeUintBE(val, buf, pos) {
	    buf[pos    ] =  val >>> 24;
	    buf[pos + 1] =  val >>> 16 & 255;
	    buf[pos + 2] =  val >>> 8  & 255;
	    buf[pos + 3] =  val        & 255;
	}
	
	function readUintLE(buf, pos) {
	    return (buf[pos    ]
	          | buf[pos + 1] << 8
	          | buf[pos + 2] << 16
	          | buf[pos + 3] << 24) >>> 0;
	}
	
	function readUintBE(buf, pos) {
	    return (buf[pos    ] << 24
	          | buf[pos + 1] << 16
	          | buf[pos + 2] << 8
	          | buf[pos + 3]) >>> 0;
	}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = inquire;
	
	/**
	 * Requires a module only if available.
	 * @memberof util
	 * @param {string} moduleName Module to require
	 * @returns {?Object} Required module if available and not empty, otherwise `null`
	 */
	function inquire(moduleName) {
	    try {
	        var mod = eval("quire".replace(/^/,"re"))(moduleName); // eslint-disable-line no-eval
	        if (mod && (mod.length || Object.keys(mod).length))
	            return mod;
	    } catch (e) {} // eslint-disable-line no-empty
	    return null;
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * A minimal UTF8 implementation for number arrays.
	 * @memberof util
	 * @namespace
	 */
	var utf8 = exports;
	
	/**
	 * Calculates the UTF8 byte length of a string.
	 * @param {string} string String
	 * @returns {number} Byte length
	 */
	utf8.length = function utf8_length(string) {
	    var len = 0,
	        c = 0;
	    for (var i = 0; i < string.length; ++i) {
	        c = string.charCodeAt(i);
	        if (c < 128)
	            len += 1;
	        else if (c < 2048)
	            len += 2;
	        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
	            ++i;
	            len += 4;
	        } else
	            len += 3;
	    }
	    return len;
	};
	
	/**
	 * Reads UTF8 bytes as a string.
	 * @param {Uint8Array} buffer Source buffer
	 * @param {number} start Source start
	 * @param {number} end Source end
	 * @returns {string} String read
	 */
	utf8.read = function utf8_read(buffer, start, end) {
	    var len = end - start;
	    if (len < 1)
	        return "";
	    var parts = null,
	        chunk = [],
	        i = 0, // char offset
	        t;     // temporary
	    while (start < end) {
	        t = buffer[start++];
	        if (t < 128)
	            chunk[i++] = t;
	        else if (t > 191 && t < 224)
	            chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
	        else if (t > 239 && t < 365) {
	            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
	            chunk[i++] = 0xD800 + (t >> 10);
	            chunk[i++] = 0xDC00 + (t & 1023);
	        } else
	            chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
	        if (i > 8191) {
	            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
	            i = 0;
	        }
	    }
	    if (parts) {
	        if (i)
	            parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
	        return parts.join("");
	    }
	    return String.fromCharCode.apply(String, chunk.slice(0, i));
	};
	
	/**
	 * Writes a string as UTF8 bytes.
	 * @param {string} string Source string
	 * @param {Uint8Array} buffer Destination buffer
	 * @param {number} offset Destination offset
	 * @returns {number} Bytes written
	 */
	utf8.write = function utf8_write(string, buffer, offset) {
	    var start = offset,
	        c1, // character 1
	        c2; // character 2
	    for (var i = 0; i < string.length; ++i) {
	        c1 = string.charCodeAt(i);
	        if (c1 < 128) {
	            buffer[offset++] = c1;
	        } else if (c1 < 2048) {
	            buffer[offset++] = c1 >> 6       | 192;
	            buffer[offset++] = c1       & 63 | 128;
	        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
	            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
	            ++i;
	            buffer[offset++] = c1 >> 18      | 240;
	            buffer[offset++] = c1 >> 12 & 63 | 128;
	            buffer[offset++] = c1 >> 6  & 63 | 128;
	            buffer[offset++] = c1       & 63 | 128;
	        } else {
	            buffer[offset++] = c1 >> 12      | 224;
	            buffer[offset++] = c1 >> 6  & 63 | 128;
	            buffer[offset++] = c1       & 63 | 128;
	        }
	    }
	    return offset - start;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = pool;
	
	/**
	 * An allocator as used by {@link util.pool}.
	 * @typedef PoolAllocator
	 * @type {function}
	 * @param {number} size Buffer size
	 * @returns {Uint8Array} Buffer
	 */
	
	/**
	 * A slicer as used by {@link util.pool}.
	 * @typedef PoolSlicer
	 * @type {function}
	 * @param {number} start Start offset
	 * @param {number} end End offset
	 * @returns {Uint8Array} Buffer slice
	 * @this {Uint8Array}
	 */
	
	/**
	 * A general purpose buffer pool.
	 * @memberof util
	 * @function
	 * @param {PoolAllocator} alloc Allocator
	 * @param {PoolSlicer} slice Slicer
	 * @param {number} [size=8192] Slab size
	 * @returns {PoolAllocator} Pooled allocator
	 */
	function pool(alloc, slice, size) {
	    var SIZE   = size || 8192;
	    var MAX    = SIZE >>> 1;
	    var slab   = null;
	    var offset = SIZE;
	    return function pool_alloc(size) {
	        if (size < 1 || size > MAX)
	            return alloc(size);
	        if (offset + size > SIZE) {
	            slab = alloc(SIZE);
	            offset = 0;
	        }
	        var buf = slice.call(slab, offset, offset += size);
	        if (offset & 7) // align to 32 bit
	            offset = (offset | 7) + 1;
	        return buf;
	    };
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = LongBits;
	
	var util = __webpack_require__(5);
	
	/**
	 * Constructs new long bits.
	 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
	 * @memberof util
	 * @constructor
	 * @param {number} lo Low 32 bits, unsigned
	 * @param {number} hi High 32 bits, unsigned
	 */
	function LongBits(lo, hi) {
	
	    // note that the casts below are theoretically unnecessary as of today, but older statically
	    // generated converter code might still call the ctor with signed 32bits. kept for compat.
	
	    /**
	     * Low bits.
	     * @type {number}
	     */
	    this.lo = lo >>> 0;
	
	    /**
	     * High bits.
	     * @type {number}
	     */
	    this.hi = hi >>> 0;
	}
	
	/**
	 * Zero bits.
	 * @memberof util.LongBits
	 * @type {util.LongBits}
	 */
	var zero = LongBits.zero = new LongBits(0, 0);
	
	zero.toNumber = function() { return 0; };
	zero.zzEncode = zero.zzDecode = function() { return this; };
	zero.length = function() { return 1; };
	
	/**
	 * Zero hash.
	 * @memberof util.LongBits
	 * @type {string}
	 */
	var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
	
	/**
	 * Constructs new long bits from the specified number.
	 * @param {number} value Value
	 * @returns {util.LongBits} Instance
	 */
	LongBits.fromNumber = function fromNumber(value) {
	    if (value === 0)
	        return zero;
	    var sign = value < 0;
	    if (sign)
	        value = -value;
	    var lo = value >>> 0,
	        hi = (value - lo) / 4294967296 >>> 0;
	    if (sign) {
	        hi = ~hi >>> 0;
	        lo = ~lo >>> 0;
	        if (++lo > 4294967295) {
	            lo = 0;
	            if (++hi > 4294967295)
	                hi = 0;
	        }
	    }
	    return new LongBits(lo, hi);
	};
	
	/**
	 * Constructs new long bits from a number, long or string.
	 * @param {Long|number|string} value Value
	 * @returns {util.LongBits} Instance
	 */
	LongBits.from = function from(value) {
	    if (typeof value === "number")
	        return LongBits.fromNumber(value);
	    if (util.isString(value)) {
	        /* istanbul ignore else */
	        if (util.Long)
	            value = util.Long.fromString(value);
	        else
	            return LongBits.fromNumber(parseInt(value, 10));
	    }
	    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
	};
	
	/**
	 * Converts this long bits to a possibly unsafe JavaScript number.
	 * @param {boolean} [unsigned=false] Whether unsigned or not
	 * @returns {number} Possibly unsafe number
	 */
	LongBits.prototype.toNumber = function toNumber(unsigned) {
	    if (!unsigned && this.hi >>> 31) {
	        var lo = ~this.lo + 1 >>> 0,
	            hi = ~this.hi     >>> 0;
	        if (!lo)
	            hi = hi + 1 >>> 0;
	        return -(lo + hi * 4294967296);
	    }
	    return this.lo + this.hi * 4294967296;
	};
	
	/**
	 * Converts this long bits to a long.
	 * @param {boolean} [unsigned=false] Whether unsigned or not
	 * @returns {Long} Long
	 */
	LongBits.prototype.toLong = function toLong(unsigned) {
	    return util.Long
	        ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned))
	        /* istanbul ignore next */
	        : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(unsigned) };
	};
	
	var charCodeAt = String.prototype.charCodeAt;
	
	/**
	 * Constructs new long bits from the specified 8 characters long hash.
	 * @param {string} hash Hash
	 * @returns {util.LongBits} Bits
	 */
	LongBits.fromHash = function fromHash(hash) {
	    if (hash === zeroHash)
	        return zero;
	    return new LongBits(
	        ( charCodeAt.call(hash, 0)
	        | charCodeAt.call(hash, 1) << 8
	        | charCodeAt.call(hash, 2) << 16
	        | charCodeAt.call(hash, 3) << 24) >>> 0
	    ,
	        ( charCodeAt.call(hash, 4)
	        | charCodeAt.call(hash, 5) << 8
	        | charCodeAt.call(hash, 6) << 16
	        | charCodeAt.call(hash, 7) << 24) >>> 0
	    );
	};
	
	/**
	 * Converts this long bits to a 8 characters long hash.
	 * @returns {string} Hash
	 */
	LongBits.prototype.toHash = function toHash() {
	    return String.fromCharCode(
	        this.lo        & 255,
	        this.lo >>> 8  & 255,
	        this.lo >>> 16 & 255,
	        this.lo >>> 24      ,
	        this.hi        & 255,
	        this.hi >>> 8  & 255,
	        this.hi >>> 16 & 255,
	        this.hi >>> 24
	    );
	};
	
	/**
	 * Zig-zag encodes this long bits.
	 * @returns {util.LongBits} `this`
	 */
	LongBits.prototype.zzEncode = function zzEncode() {
	    var mask =   this.hi >> 31;
	    this.hi  = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
	    this.lo  = ( this.lo << 1                   ^ mask) >>> 0;
	    return this;
	};
	
	/**
	 * Zig-zag decodes this long bits.
	 * @returns {util.LongBits} `this`
	 */
	LongBits.prototype.zzDecode = function zzDecode() {
	    var mask = -(this.lo & 1);
	    this.lo  = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
	    this.hi  = ( this.hi >>> 1                  ^ mask) >>> 0;
	    return this;
	};
	
	/**
	 * Calculates the length of this longbits when encoded as a varint.
	 * @returns {number} Length
	 */
	LongBits.prototype.length = function length() {
	    var part0 =  this.lo,
	        part1 = (this.lo >>> 28 | this.hi << 4) >>> 0,
	        part2 =  this.hi >>> 24;
	    return part2 === 0
	         ? part1 === 0
	           ? part0 < 16384
	             ? part0 < 128 ? 1 : 2
	             : part0 < 2097152 ? 3 : 4
	           : part1 < 16384
	             ? part1 < 128 ? 5 : 6
	             : part1 < 2097152 ? 7 : 8
	         : part2 < 128 ? 9 : 10;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = BufferWriter;
	
	// extends Writer
	var Writer = __webpack_require__(4);
	(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
	
	var util = __webpack_require__(5);
	
	var Buffer = util.Buffer;
	
	/**
	 * Constructs a new buffer writer instance.
	 * @classdesc Wire format writer using node buffers.
	 * @extends Writer
	 * @constructor
	 */
	function BufferWriter() {
	    Writer.call(this);
	}
	
	/**
	 * Allocates a buffer of the specified size.
	 * @param {number} size Buffer size
	 * @returns {Buffer} Buffer
	 */
	BufferWriter.alloc = function alloc_buffer(size) {
	    return (BufferWriter.alloc = util._Buffer_allocUnsafe)(size);
	};
	
	var writeBytesBuffer = Buffer && Buffer.prototype instanceof Uint8Array && Buffer.prototype.set.name === "set"
	    ? function writeBytesBuffer_set(val, buf, pos) {
	        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
	                           // also works for plain array values
	    }
	    /* istanbul ignore next */
	    : function writeBytesBuffer_copy(val, buf, pos) {
	        if (val.copy) // Buffer values
	            val.copy(buf, pos, 0, val.length);
	        else for (var i = 0; i < val.length;) // plain array values
	            buf[pos++] = val[i++];
	    };
	
	/**
	 * @override
	 */
	BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
	    if (util.isString(value))
	        value = util._Buffer_from(value, "base64");
	    var len = value.length >>> 0;
	    this.uint32(len);
	    if (len)
	        this._push(writeBytesBuffer, len, value);
	    return this;
	};
	
	function writeStringBuffer(val, buf, pos) {
	    if (val.length < 40) // plain js is faster for short strings (probably due to redundant assertions)
	        util.utf8.write(val, buf, pos);
	    else
	        buf.utf8Write(val, pos);
	}
	
	/**
	 * @override
	 */
	BufferWriter.prototype.string = function write_string_buffer(value) {
	    var len = Buffer.byteLength(value);
	    this.uint32(len);
	    if (len)
	        this._push(writeStringBuffer, len, value);
	    return this;
	};
	
	
	/**
	 * Finishes the write operation.
	 * @name BufferWriter#finish
	 * @function
	 * @returns {Buffer} Finished buffer
	 */


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = Reader;
	
	var util      = __webpack_require__(5);
	
	var BufferReader; // cyclic
	
	var LongBits  = util.LongBits,
	    utf8      = util.utf8;
	
	/* istanbul ignore next */
	function indexOutOfRange(reader, writeLength) {
	    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
	}
	
	/**
	 * Constructs a new reader instance using the specified buffer.
	 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
	 * @constructor
	 * @param {Uint8Array} buffer Buffer to read from
	 */
	function Reader(buffer) {
	
	    /**
	     * Read buffer.
	     * @type {Uint8Array}
	     */
	    this.buf = buffer;
	
	    /**
	     * Read buffer position.
	     * @type {number}
	     */
	    this.pos = 0;
	
	    /**
	     * Read buffer length.
	     * @type {number}
	     */
	    this.len = buffer.length;
	}
	
	var create_array = typeof Uint8Array !== "undefined"
	    ? function create_typed_array(buffer) {
	        if (buffer instanceof Uint8Array || Array.isArray(buffer))
	            return new Reader(buffer);
	        throw Error("illegal buffer");
	    }
	    /* istanbul ignore next */
	    : function create_array(buffer) {
	        if (Array.isArray(buffer))
	            return new Reader(buffer);
	        throw Error("illegal buffer");
	    };
	
	/**
	 * Creates a new reader using the specified buffer.
	 * @function
	 * @param {Uint8Array|Buffer} buffer Buffer to read from
	 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
	 * @throws {Error} If `buffer` is not a valid buffer
	 */
	Reader.create = util.Buffer
	    ? function create_buffer_setup(buffer) {
	        return (Reader.create = function create_buffer(buffer) {
	            return util.Buffer.isBuffer(buffer)
	                ? new BufferReader(buffer)
	                /* istanbul ignore next */
	                : create_array(buffer);
	        })(buffer);
	    }
	    /* istanbul ignore next */
	    : create_array;
	
	Reader.prototype._slice = util.Array.prototype.subarray || /* istanbul ignore next */ util.Array.prototype.slice;
	
	/**
	 * Reads a varint as an unsigned 32 bit value.
	 * @function
	 * @returns {number} Value read
	 */
	Reader.prototype.uint32 = (function read_uint32_setup() {
	    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
	    return function read_uint32() {
	        value = (         this.buf[this.pos] & 127       ) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) <<  7) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0; if (this.buf[this.pos++] < 128) return value;
	        value = (value | (this.buf[this.pos] &  15) << 28) >>> 0; if (this.buf[this.pos++] < 128) return value;
	
	        /* istanbul ignore if */
	        if ((this.pos += 5) > this.len) {
	            this.pos = this.len;
	            throw indexOutOfRange(this, 10);
	        }
	        return value;
	    };
	})();
	
	/**
	 * Reads a varint as a signed 32 bit value.
	 * @returns {number} Value read
	 */
	Reader.prototype.int32 = function read_int32() {
	    return this.uint32() | 0;
	};
	
	/**
	 * Reads a zig-zag encoded varint as a signed 32 bit value.
	 * @returns {number} Value read
	 */
	Reader.prototype.sint32 = function read_sint32() {
	    var value = this.uint32();
	    return value >>> 1 ^ -(value & 1) | 0;
	};
	
	/* eslint-disable no-invalid-this */
	
	function readLongVarint() {
	    // tends to deopt with local vars for octet etc.
	    var bits = new LongBits(0, 0);
	    var i = 0;
	    if (this.len - this.pos > 4) { // fast route (lo)
	        for (; i < 4; ++i) {
	            // 1st..4th
	            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	        // 5th
	        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
	        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >>  4) >>> 0;
	        if (this.buf[this.pos++] < 128)
	            return bits;
	        i = 0;
	    } else {
	        for (; i < 3; ++i) {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	            // 1st..3th
	            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	        // 4th
	        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
	        return bits;
	    }
	    if (this.len - this.pos > 4) { // fast route (hi)
	        for (; i < 5; ++i) {
	            // 6th..10th
	            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	    } else {
	        for (; i < 5; ++i) {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	            // 6th..10th
	            bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
	            if (this.buf[this.pos++] < 128)
	                return bits;
	        }
	    }
	    /* istanbul ignore next */
	    throw Error("invalid varint encoding");
	}
	
	/* eslint-enable no-invalid-this */
	
	/**
	 * Reads a varint as a signed 64 bit value.
	 * @name Reader#int64
	 * @function
	 * @returns {Long} Value read
	 */
	
	/**
	 * Reads a varint as an unsigned 64 bit value.
	 * @name Reader#uint64
	 * @function
	 * @returns {Long} Value read
	 */
	
	/**
	 * Reads a zig-zag encoded varint as a signed 64 bit value.
	 * @name Reader#sint64
	 * @function
	 * @returns {Long} Value read
	 */
	
	/**
	 * Reads a varint as a boolean.
	 * @returns {boolean} Value read
	 */
	Reader.prototype.bool = function read_bool() {
	    return this.uint32() !== 0;
	};
	
	function readFixed32_end(buf, end) { // note that this uses `end`, not `pos`
	    return (buf[end - 4]
	          | buf[end - 3] << 8
	          | buf[end - 2] << 16
	          | buf[end - 1] << 24) >>> 0;
	}
	
	/**
	 * Reads fixed 32 bits as an unsigned 32 bit integer.
	 * @returns {number} Value read
	 */
	Reader.prototype.fixed32 = function read_fixed32() {
	
	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);
	
	    return readFixed32_end(this.buf, this.pos += 4);
	};
	
	/**
	 * Reads fixed 32 bits as a signed 32 bit integer.
	 * @returns {number} Value read
	 */
	Reader.prototype.sfixed32 = function read_sfixed32() {
	
	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);
	
	    return readFixed32_end(this.buf, this.pos += 4) | 0;
	};
	
	/* eslint-disable no-invalid-this */
	
	function readFixed64(/* this: Reader */) {
	
	    /* istanbul ignore if */
	    if (this.pos + 8 > this.len)
	        throw indexOutOfRange(this, 8);
	
	    return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
	}
	
	/* eslint-enable no-invalid-this */
	
	/**
	 * Reads fixed 64 bits.
	 * @name Reader#fixed64
	 * @function
	 * @returns {Long} Value read
	 */
	
	/**
	 * Reads zig-zag encoded fixed 64 bits.
	 * @name Reader#sfixed64
	 * @function
	 * @returns {Long} Value read
	 */
	
	/**
	 * Reads a float (32 bit) as a number.
	 * @function
	 * @returns {number} Value read
	 */
	Reader.prototype.float = function read_float() {
	
	    /* istanbul ignore if */
	    if (this.pos + 4 > this.len)
	        throw indexOutOfRange(this, 4);
	
	    var value = util.float.readFloatLE(this.buf, this.pos);
	    this.pos += 4;
	    return value;
	};
	
	/**
	 * Reads a double (64 bit float) as a number.
	 * @function
	 * @returns {number} Value read
	 */
	Reader.prototype.double = function read_double() {
	
	    /* istanbul ignore if */
	    if (this.pos + 8 > this.len)
	        throw indexOutOfRange(this, 4);
	
	    var value = util.float.readDoubleLE(this.buf, this.pos);
	    this.pos += 8;
	    return value;
	};
	
	/**
	 * Reads a sequence of bytes preceeded by its length as a varint.
	 * @returns {Uint8Array} Value read
	 */
	Reader.prototype.bytes = function read_bytes() {
	    var length = this.uint32(),
	        start  = this.pos,
	        end    = this.pos + length;
	
	    /* istanbul ignore if */
	    if (end > this.len)
	        throw indexOutOfRange(this, length);
	
	    this.pos += length;
	    if (Array.isArray(this.buf)) // plain array
	        return this.buf.slice(start, end);
	    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
	        ? new this.buf.constructor(0)
	        : this._slice.call(this.buf, start, end);
	};
	
	/**
	 * Reads a string preceeded by its byte length as a varint.
	 * @returns {string} Value read
	 */
	Reader.prototype.string = function read_string() {
	    var bytes = this.bytes();
	    return utf8.read(bytes, 0, bytes.length);
	};
	
	/**
	 * Skips the specified number of bytes if specified, otherwise skips a varint.
	 * @param {number} [length] Length if known, otherwise a varint is assumed
	 * @returns {Reader} `this`
	 */
	Reader.prototype.skip = function skip(length) {
	    if (typeof length === "number") {
	        /* istanbul ignore if */
	        if (this.pos + length > this.len)
	            throw indexOutOfRange(this, length);
	        this.pos += length;
	    } else {
	        do {
	            /* istanbul ignore if */
	            if (this.pos >= this.len)
	                throw indexOutOfRange(this);
	        } while (this.buf[this.pos++] & 128);
	    }
	    return this;
	};
	
	/**
	 * Skips the next element of the specified wire type.
	 * @param {number} wireType Wire type received
	 * @returns {Reader} `this`
	 */
	Reader.prototype.skipType = function(wireType) {
	    switch (wireType) {
	        case 0:
	            this.skip();
	            break;
	        case 1:
	            this.skip(8);
	            break;
	        case 2:
	            this.skip(this.uint32());
	            break;
	        case 3:
	            do { // eslint-disable-line no-constant-condition
	                if ((wireType = this.uint32() & 7) === 4)
	                    break;
	                this.skipType(wireType);
	            } while (true);
	            break;
	        case 5:
	            this.skip(4);
	            break;
	
	        /* istanbul ignore next */
	        default:
	            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
	    }
	    return this;
	};
	
	Reader._configure = function(BufferReader_) {
	    BufferReader = BufferReader_;
	
	    var fn = util.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
	    util.merge(Reader.prototype, {
	
	        int64: function read_int64() {
	            return readLongVarint.call(this)[fn](false);
	        },
	
	        uint64: function read_uint64() {
	            return readLongVarint.call(this)[fn](true);
	        },
	
	        sint64: function read_sint64() {
	            return readLongVarint.call(this).zzDecode()[fn](false);
	        },
	
	        fixed64: function read_fixed64() {
	            return readFixed64.call(this)[fn](true);
	        },
	
	        sfixed64: function read_sfixed64() {
	            return readFixed64.call(this)[fn](false);
	        }
	
	    });
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = BufferReader;
	
	// extends Reader
	var Reader = __webpack_require__(15);
	(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
	
	var util = __webpack_require__(5);
	
	/**
	 * Constructs a new buffer reader instance.
	 * @classdesc Wire format reader using node buffers.
	 * @extends Reader
	 * @constructor
	 * @param {Buffer} buffer Buffer to read from
	 */
	function BufferReader(buffer) {
	    Reader.call(this, buffer);
	
	    /**
	     * Read buffer.
	     * @name BufferReader#buf
	     * @type {Buffer}
	     */
	}
	
	/* istanbul ignore else */
	if (util.Buffer)
	    BufferReader.prototype._slice = util.Buffer.prototype.slice;
	
	/**
	 * @override
	 */
	BufferReader.prototype.string = function read_string_buffer() {
	    var len = this.uint32(); // modifies pos
	    return this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len));
	};
	
	/**
	 * Reads a sequence of bytes preceeded by its length as a varint.
	 * @name BufferReader#bytes
	 * @function
	 * @returns {Buffer} Value read
	 */


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Streaming RPC helpers.
	 * @namespace
	 */
	var rpc = exports;
	
	/**
	 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
	 * @typedef RPCImpl
	 * @type {function}
	 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
	 * @param {Uint8Array} requestData Request data
	 * @param {RPCImplCallback} callback Callback function
	 * @returns {undefined}
	 * @example
	 * function rpcImpl(method, requestData, callback) {
	 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
	 *         throw Error("no such method");
	 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
	 *         callback(err, responseData);
	 *     });
	 * }
	 */
	
	/**
	 * Node-style callback as used by {@link RPCImpl}.
	 * @typedef RPCImplCallback
	 * @type {function}
	 * @param {Error|null} error Error, if any, otherwise `null`
	 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
	 * @returns {undefined}
	 */
	
	rpc.Service = __webpack_require__(18);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = Service;
	
	var util = __webpack_require__(5);
	
	// Extends EventEmitter
	(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
	
	/**
	 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
	 *
	 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
	 * @typedef rpc.ServiceMethodCallback
	 * @template TRes extends Message<TRes>
	 * @type {function}
	 * @param {Error|null} error Error, if any
	 * @param {TRes} [response] Response message
	 * @returns {undefined}
	 */
	
	/**
	 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
	 * @typedef rpc.ServiceMethod
	 * @template TReq extends Message<TReq>
	 * @template TRes extends Message<TRes>
	 * @type {function}
	 * @param {TReq|Properties<TReq>} request Request message or plain object
	 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
	 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
	 */
	
	/**
	 * Constructs a new RPC service instance.
	 * @classdesc An RPC service as returned by {@link Service#create}.
	 * @exports rpc.Service
	 * @extends util.EventEmitter
	 * @constructor
	 * @param {RPCImpl} rpcImpl RPC implementation
	 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
	 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
	 */
	function Service(rpcImpl, requestDelimited, responseDelimited) {
	
	    if (typeof rpcImpl !== "function")
	        throw TypeError("rpcImpl must be a function");
	
	    util.EventEmitter.call(this);
	
	    /**
	     * RPC implementation. Becomes `null` once the service is ended.
	     * @type {RPCImpl|null}
	     */
	    this.rpcImpl = rpcImpl;
	
	    /**
	     * Whether requests are length-delimited.
	     * @type {boolean}
	     */
	    this.requestDelimited = Boolean(requestDelimited);
	
	    /**
	     * Whether responses are length-delimited.
	     * @type {boolean}
	     */
	    this.responseDelimited = Boolean(responseDelimited);
	}
	
	/**
	 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
	 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
	 * @param {Constructor<TReq>} requestCtor Request constructor
	 * @param {Constructor<TRes>} responseCtor Response constructor
	 * @param {TReq|Properties<TReq>} request Request message or plain object
	 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
	 * @returns {undefined}
	 * @template TReq extends Message<TReq>
	 * @template TRes extends Message<TRes>
	 */
	Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
	
	    if (!request)
	        throw TypeError("request must be specified");
	
	    var self = this;
	    if (!callback)
	        return util.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
	
	    if (!self.rpcImpl) {
	        setTimeout(function() { callback(Error("already ended")); }, 0);
	        return undefined;
	    }
	
	    try {
	        return self.rpcImpl(
	            method,
	            requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(),
	            function rpcCallback(err, response) {
	
	                if (err) {
	                    self.emit("error", err, method);
	                    return callback(err);
	                }
	
	                if (response === null) {
	                    self.end(/* endedByRPC */ true);
	                    return undefined;
	                }
	
	                if (!(response instanceof responseCtor)) {
	                    try {
	                        response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
	                    } catch (err) {
	                        self.emit("error", err, method);
	                        return callback(err);
	                    }
	                }
	
	                self.emit("data", response, method);
	                return callback(null, response);
	            }
	        );
	    } catch (err) {
	        self.emit("error", err, method);
	        setTimeout(function() { callback(err); }, 0);
	        return undefined;
	    }
	};
	
	/**
	 * Ends this service and emits the `end` event.
	 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
	 * @returns {rpc.Service} `this`
	 */
	Service.prototype.end = function end(endedByRPC) {
	    if (this.rpcImpl) {
	        if (!endedByRPC) // signal end to rpcImpl
	            this.rpcImpl(null, null, null);
	        this.rpcImpl = null;
	        this.emit("end").off();
	    }
	    return this;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = {};
	
	/**
	 * Named roots.
	 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
	 * Can also be used manually to make roots available accross modules.
	 * @name roots
	 * @type {Object.<string,Root>}
	 * @example
	 * // pbjs -r myroot -o compiled.js ...
	 *
	 * // in another module:
	 * require("./compiled.js");
	 *
	 * // in any subsequent module:
	 * var root = protobuf.roots["myroot"];
	 */


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var QueryString = __webpack_require__(21);
	var consts_1 = __webpack_require__(24);
	var Fatal = (function () {
	    function Fatal(broadcaster) {
	        this.broadcaster = broadcaster;
	    }
	    Fatal.prototype.send = function (errType, message) {
	        var xhr = new XMLHttpRequest();
	        var url = this.getUrl(errType, message);
	        xhr.open('GET', url, true);
	        xhr.send(null);
	    };
	    Fatal.prototype.getUrl = function (errType, message) {
	        var qs = QueryString.stringify({
	            broadcaster: this.broadcaster,
	            type: errType,
	            message: (typeof message === 'string' && message.length > 0) ? message : '',
	        });
	        return consts_1.FATAL_URL + "?" + qs;
	    };
	    return Fatal;
	}());
	exports.Fatal = Fatal;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(22);
	exports.encode = exports.stringify = __webpack_require__(23);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.STUN_SERVERS = [
	    'stun:stun.easybroadcast.fr:3478',
	];
	exports.ICE_TIMEOUT = 8000;
	exports.SWARM_SIZE = 10;
	exports.UPLOAD_SLOTS = 3;
	exports.SWARM_POPULATE_INTERVAL = 30000;
	exports.PEER_MAX_CONNECTION_TIME = 20000;
	exports.PING_INTERVAL = 5000;
	exports.STORAGE_SIZE = 10;
	exports.HAVE_STORAGE_SIZE = 10;
	exports.WS_RECONNECTION_INTERVAL = 5000;
	exports.STATS_URL = 'https://stats.easybroadcast.fr';
	exports.STATS_INTERVAL = 30000;
	exports.FATAL_URL = 'https://err.easybroadcast.fr/';
	exports.BUFFER_INTERVAL = 4000;
	exports.MAX_OFFER_REQUEST = 7;
	exports.MIN_OFFER_REQUEST = 3;
	exports.MAX_ANSWER_REQUEST = 7;
	exports.MIN_ANSWER_REQUEST = 3;
	exports.ANSWER_REQUEST = 3;
	exports.OFFER_REQUEST = 7;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Promise = __webpack_require__(26);
	var Constants = __webpack_require__(24);
	var log_1 = __webpack_require__(65);
	var IceCandidateType;
	(function (IceCandidateType) {
	    IceCandidateType[IceCandidateType["Host"] = 0] = "Host";
	    IceCandidateType[IceCandidateType["ServerReflexive"] = 1] = "ServerReflexive";
	    IceCandidateType[IceCandidateType["PeerReflexive"] = 2] = "PeerReflexive";
	    IceCandidateType[IceCandidateType["Relay"] = 3] = "Relay";
	})(IceCandidateType = exports.IceCandidateType || (exports.IceCandidateType = {}));
	function getIceCandidates() {
	    return new Promise(function (resolve, reject) {
	        var config = {
	            iceServers: [{
	                    urls: Constants.STUN_SERVERS,
	                }],
	            iceTransportPolicy: 'all',
	        };
	        var offerOptions = {
	            offerToReceiveAudio: 1,
	        };
	        var conn = new RTCPeerConnection(config);
	        var candidates = [];
	        conn.onicecandidate = function (ev) {
	            if ((typeof ev !== 'object') || (ev.candidate === undefined)) {
	                return;
	            }
	            if (ev.candidate === null) {
	                return resolve(candidates);
	            }
	            candidates.push(ev.candidate);
	        };
	        conn.onicegatheringstatechange = function (ev) {
	            if (conn.iceGatheringState === 'complete') {
	                conn.close();
	            }
	        };
	        log_1.logger().debug('Gathering ICE candidates');
	        setTimeout(function () {
	            if (candidates.length) {
	                return resolve(candidates);
	            }
	            reject(new Error('Timeout while gathering ICE candidates'));
	        }, Constants.ICE_TIMEOUT);
	        return Promise.resolve(conn.createOffer(offerOptions))
	            .then(function (res) { return Promise.resolve(conn.setLocalDescription(res)); })
	            .catch(function (err) {
	            log_1.logger().debug('Could not gather ICE candidates', err);
	            reject(err);
	        });
	    });
	}
	exports.getIceCandidates = getIceCandidates;
	function getManagerIceCandidates() {
	    return Promise
	        .map(getIceCandidates(), parseCandidate)
	        .filter(function (cand) { return cand !== null; });
	}
	exports.getManagerIceCandidates = getManagerIceCandidates;
	function parseCandidate(candidate) {
	    var pos = candidate.candidate.indexOf('candidate:') + 10;
	    var _a = candidate.candidate.trim().substr(pos).split(/\s+/), address = _a[4], type = _a[7];
	    if (address === '') {
	        return null;
	    }
	    var candidateType;
	    switch (type) {
	        case 'host':
	            candidateType = IceCandidateType.Host;
	            break;
	        case 'srflx':
	            candidateType = IceCandidateType.ServerReflexive;
	            break;
	        case 'prflx':
	            candidateType = IceCandidateType.PeerReflexive;
	            break;
	        case 'relay':
	            candidateType = IceCandidateType.Relay;
	            break;
	        default:
	            return null;
	    }
	    return {
	        Type: candidateType,
	        Address: address,
	    };
	}
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(27)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(29);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(30);
	var Async = __webpack_require__(31);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(36);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(37)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(38)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(39)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(40)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(41)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(42)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(43);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(44)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(45)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(46)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(47)(Promise);
	__webpack_require__(48)(Promise);
	__webpack_require__(49)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.1";
	__webpack_require__(50)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(51)(Promise);
	__webpack_require__(52)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(53)(Promise, INTERNAL, debug);
	__webpack_require__(54)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(55)(Promise);
	__webpack_require__(56)(Promise, INTERNAL);
	__webpack_require__(57)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(58)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(59)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(60)(Promise, PromiseArray, debug);
	__webpack_require__(61)(Promise, PromiseArray, apiRejection);
	__webpack_require__(62)(Promise, INTERNAL);
	__webpack_require__(63)(Promise, INTERNAL);
	__webpack_require__(64)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(30);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(32);
	var Queue = __webpack_require__(35);
	var util = __webpack_require__(29);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(29);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28), __webpack_require__(33).setImmediate))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(34);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(30);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(29);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(29);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(29);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(36).Warning;
	var util = __webpack_require__(29);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(29);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(42)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(29);
	var getKeys = __webpack_require__(30).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(29);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(36);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(30);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(29);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(29);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(29);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(29);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(29);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(29);
	    var TypeError = __webpack_require__(36).TypeError;
	    var inherits = __webpack_require__(29).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(29);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(36);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(29);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(29);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(29);
	var nodebackForPromise = __webpack_require__(43);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(36).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(29);
	var isObject = util.isObject;
	var es5 = __webpack_require__(30);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(29);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(29);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(29);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(29);
	var RangeError = __webpack_require__(36).RangeError;
	var AggregateError = __webpack_require__(36).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel = __webpack_require__(66);
	function logger() {
	    loglevel.setLevel(0);
	    return loglevel;
	}
	exports.logger = logger;
	function namedLogger(name) {
	    var instance = loglevel.getLogger(name);
	    instance.setLevel(0);
	    return instance;
	}
	exports.namedLogger = namedLogger;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9pc2hhbmkvdGhlc2lzL3NyYy9sb2cudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFJQSxtQ0FBcUM7QUFLckM7SUFDRSxRQUFRLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ3JCLE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUM7QUFZTyx3QkFBTTtBQVBkLHFCQUFxQixJQUFZO0lBQy9CLElBQU0sUUFBUSxHQUFHLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7SUFFMUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUNyQixPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDO0FBRWUsa0NBQVciLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBMb2cgaGFuZGxpbmcuXG4gKi9cblxuaW1wb3J0ICogYXMgbG9nbGV2ZWwgZnJvbSAnbG9nbGV2ZWwnO1xuXG4vKipcbiAqIEdldCBsb2dnZXIgb2JqZWN0LlxuICovXG5mdW5jdGlvbiBsb2dnZXIoKSB7XG4gIGxvZ2xldmVsLnNldExldmVsKDApO1xuICByZXR1cm4gbG9nbGV2ZWw7XG59XG5cbi8qKlxuICogR2V0IG5hbWVkIGxvZ2dlciBvYmplY3QuXG4gKi9cbmZ1bmN0aW9uIG5hbWVkTG9nZ2VyKG5hbWU6IHN0cmluZykge1xuICBjb25zdCBpbnN0YW5jZSA9IGxvZ2xldmVsLmdldExvZ2dlcihuYW1lKTtcblxuICBpbnN0YW5jZS5zZXRMZXZlbCgwKTtcbiAgcmV0dXJuIGluc3RhbmNlO1xufVxuXG5leHBvcnQge2xvZ2dlciwgbmFtZWRMb2dnZXJ9O1xuIl19


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      var storageKey = "loglevel";
	      if (name) {
	        storageKey += ":" + name;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if (typeof name !== "string" || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    return defaultLogger;
	}));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var Promise = __webpack_require__(26);
	var events_1 = __webpack_require__(68);
	var Proto = __webpack_require__(1);
	var compatibility_1 = __webpack_require__(69);
	var Constants = __webpack_require__(24);
	var log_1 = __webpack_require__(65);
	var Register_1 = __webpack_require__(70);
	var Peer_1 = __webpack_require__(72);
	var Stats_1 = __webpack_require__(79);
	var Storage_1 = __webpack_require__(82);
	var StorageDownloading_1 = __webpack_require__(83);
	var StorageHave_1 = __webpack_require__(84);
	var Swarm_1 = __webpack_require__(85);
	var DownloadWorker = __webpack_require__(86);
	var Manager = (function (_super) {
	    __extends(Manager, _super);
	    function Manager(broadcasterId, managerURL) {
	        var _this = _super.call(this) || this;
	        _this.offerPeers = 0;
	        _this.answerPeers = 0;
	        _this.connecting = false;
	        _this.connected = false;
	        _this.registered = false;
	        _this.registering = false;
	        _this.registrationInProcess = false;
	        _this.fluctuation = 0;
	        _this.userClosed = false;
	        var compatErrors = compatibility_1.compatibilityProblems();
	        if (managerURL !== undefined && managerURL.length > 0) {
	            _this.managerURL = managerURL;
	        }
	        else {
	            _this.managerURL = 'wss://manager.aws.easybroadcast.fr';
	        }
	        _this.managerURL = _this.managerURL.replace(/\/*$/, '');
	        _this.stats = new Stats_1.Stats(_this);
	        log_1.logger().debug("Hello test");
	        _this.stats.start();
	        if (!_this.managerURL.match(/^wss?:\/\/.+/)) {
	            throw new Error('Invalid EasyBroadcast manager URL');
	        }
	        if (broadcasterId === undefined || broadcasterId.length < 1) {
	            throw new Error('Missing broadcaster id');
	        }
	        if (compatErrors.length) {
	            var reason = "-" + compatErrors.join('\n-');
	            throw new Error("EasyBroadcast library cannot be used : \n" + reason);
	        }
	        _this.broadcasterId = broadcasterId;
	        _this.swarm = new Swarm_1.Swarm(_this);
	        _this.swarm.on('sizeChanged', function (count) {
	            _this.emit('swarmSize', count);
	            if (count >= Constants.SWARM_SIZE) {
	                _this.send(new Proto.manager.Message({
	                    Type: Proto.manager.MessageType.MessageTypeImGood,
	                }));
	                _this.swarm.stopPopulate();
	            }
	            else if (_this.registered === true) {
	                log_1.logger().debug("manager Id", _this.peerId);
	                _this.swarm.startPopulate();
	            }
	        });
	        _this.storage = new Storage_1.Storage();
	        _this.storage1 = new StorageHave_1.StorageHave();
	        _this.storageDownloading = new StorageDownloading_1.StorageDownloading();
	        return _this;
	    }
	    Manager.prototype.connect = function () {
	        var _this = this;
	        log_1.logger().debug('(re)Connecting to manager');
	        var wsUrl = this.managerURL + "/easybroadcast/" + this.broadcasterId;
	        if (this.peerId !== undefined) {
	            wsUrl = wsUrl + "/" + this.peerId;
	        }
	        this.connecting = true;
	        if (this.ws) {
	            if (this.connected) {
	                log_1.logger().debug('Closing old connection');
	                this.ws.close(1000, 'Restarting connection');
	            }
	        }
	        this.connected = false;
	        this.ws = new WebSocket(wsUrl, 'easybroadcast.fr_2.0');
	        this.ws.binaryType = 'arraybuffer';
	        this.ws.onopen = function () {
	            log_1.logger().debug('Connected to manager 2.5.1.6');
	            _this.connecting = false;
	            _this.connected = true;
	            _this.emit('connected');
	        };
	        this.ws.onclose = function () {
	            _this.onClose();
	        };
	        this.ws.onmessage = function (e) {
	            _this.onMessage(e);
	        };
	        this.ws.onerror = function (e) {
	            log_1.logger().debug('ErrorEvent', e);
	            _this.onError(e);
	        };
	    };
	    Manager.prototype.register = function (infos) {
	        var _this = this;
	        if (this.registered) {
	            if (JSON.stringify(this.lastPeerInfo) !== JSON.stringify(infos)) {
	                this.lastPeerInfo = __assign({}, this.peerInfos);
	                this.registered = false;
	                this.swarm.stopPopulate();
	                this.swarm.empty();
	                this.unregister(Proto.manager.UnregisterReason.UnregisterSwitching);
	            }
	            else {
	                log_1.logger().debug('Information is not changed');
	                this.hereAreMyMatches();
	            }
	        }
	        var message = new Register_1.Register(infos.url, infos.bandwidth, infos.codec, infos.timeShift);
	        this.peerInfos = infos;
	        this.emit('playingQuality', infos.bandwidth);
	        message.gatherCandidates()
	            .then(function () { return _this.send(message); })
	            .then(function () {
	            window.setTimeout(function () {
	                if (_this.registered === false) {
	                    _this.register(infos);
	                }
	            }, 10000);
	        })
	            .catch(function (err) {
	            log_1.logger().error('Could not register on manager', err);
	            _this.emit('error', err);
	        });
	    };
	    Manager.prototype.unregister = function (reason) {
	        var _this = this;
	        if (!this.registered) {
	            return;
	        }
	        var unreg = new Proto.manager.Message({
	            Type: Proto.manager.MessageType.MessageTypeUnregister,
	            ArgumentsUnregister: {
	                Reason: reason,
	            },
	        });
	        this.registered = false;
	        this.send(unreg)
	            .then(function () {
	            _this.emit('unregistered');
	        })
	            .catch(function (err) {
	            log_1.logger().warn('Could not send unregister message', err);
	            _this.emit('warn', "Could not send unregister message: " + err.message);
	            return;
	        });
	    };
	    Manager.prototype.setBandwidth = function (bandwidth) {
	        if (!this.registered || this.peerInfos === undefined) {
	            throw new Error('Not registered, cannot set bandwidth');
	        }
	        if (this.peerInfos.bandwidth === bandwidth) {
	            return;
	        }
	        this.emit('fluctuation', this.fluctuation);
	        this.peerInfos.bandwidth = bandwidth;
	        this.register(this.peerInfos);
	    };
	    Manager.prototype.getBufferLength = function () {
	        return this.stats.bufferLength;
	    };
	    Manager.prototype.setCodec = function (codec) {
	        if (!this.registered || this.peerInfos === undefined) {
	            throw new Error('Not registered, cannot set codec');
	        }
	        if (this.peerInfos.codec === codec) {
	            return;
	        }
	        this.peerInfos.codec = codec;
	        this.register(this.peerInfos);
	    };
	    Manager.prototype.setTimeshift = function (timeshift) {
	        if (!this.registered || this.peerInfos === undefined) {
	            throw new Error('Not registered, cannot set bandwidth');
	        }
	        if (this.peerInfos.timeShift === timeshift) {
	            return;
	        }
	        this.peerInfos.timeShift = timeshift;
	        this.register(this.peerInfos);
	    };
	    Manager.prototype.send = function (msg) {
	        var _this = this;
	        var error = Proto.manager.Message.verify(msg);
	        if (error !== null) {
	            log_1.logger().warn("Trying to send an invalid message: " + error);
	            return Promise.reject(new Error(error));
	        }
	        return Promise.try(function () { return Proto.manager.Message.encode(msg).finish(); })
	            .then(function (data) {
	            _this.ws.send(data);
	        });
	    };
	    Manager.prototype.askPeers = function () {
	        if (!this.connected) {
	            return;
	        }
	        this.send(new Proto.manager.Message({
	            Type: Proto.manager.MessageType.MessageTypeGiveMePeers,
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("Error while asking more peers: " + err);
	        });
	    };
	    Manager.prototype.hereAreMyMatches = function () {
	        if (!this.connected) {
	            return;
	        }
	        this.send(new Proto.manager.Message({
	            Type: Proto.manager.MessageType.MessageTypeHereAreMyMatches,
	            ArgumentsHereAreMyMatches: { Peers: this.swarm.getParticipatorsIds() },
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("Error while sending current matches: " + err);
	        });
	    };
	    Manager.prototype.getResource = function (url, timeout) {
	        var _this = this;
	        if (timeout === void 0) { timeout = 15000; }
	        var buffer = this.getBufferLength();
	        if (this.storage.hasResource(url)) {
	            return Promise.resolve(this.storage.getResource(url));
	        }
	        if (timeout <= 0) {
	            timeout = 15000;
	        }
	        if (!this.connected) {
	            return this.directDownload(url, timeout);
	        }
	        if (!this.registered) {
	            return this.directDownload(url, timeout);
	        }
	        var promises = [
	            this.getResourceRandomWait.bind(this),
	            this.getResourceProbePeers.bind(this),
	            this.getResourceLeech.bind(this),
	        ];
	        return Promise.reduce(promises, function (state, promise) { return promise(state); }, this.createLeechState(url, timeout))
	            .tap(function (state) {
	            if (state.usedV2V) {
	                log_1.logger().debug('V2V chunk');
	                _this.emit('v2vReceived', state.resource.length);
	            }
	            else {
	                log_1.logger().debug('CDN chunk');
	                _this.emit('cdnReceived', state.resource.length);
	                _this.emit('cdnReceivedd', _this.peerId, state.url, state.resource.length);
	            }
	            var buffer = new ArrayBuffer(state.resource.byteLength);
	            var copy = new Uint8Array(buffer);
	            copy.set(state.resource);
	            _this.storage.addResource(url, copy);
	        })
	            .then(function (state) {
	            return state.resource;
	        });
	    };
	    Manager.prototype.getStorage = function () {
	        return this.storage;
	    };
	    Manager.prototype.getstoragehave = function () {
	        return this.storage1;
	    };
	    Manager.prototype.getstorageDownlaoding = function () {
	        return this.storageDownloading;
	    };
	    Manager.prototype.getSwarm = function () {
	        return this.swarm;
	    };
	    Manager.prototype.getStats = function () {
	        return this.stats;
	    };
	    Manager.prototype.directDownload = function (url, timeout) {
	        var worker = new DownloadWorker();
	        return new Promise(function (resolve, reject) {
	            worker.postMessage({ url: url });
	            worker.onmessage = function (event) {
	                if (typeof event.data.success !== 'boolean') {
	                    reject(new Error('Invalid result from download worker'));
	                    return;
	                }
	                if (!event.data.success) {
	                    reject((typeof event.data.error === 'string') ? event.data.error : 'Unknown error');
	                    return;
	                }
	                if ((event.data.buffer === undefined) || !(event.data.buffer instanceof ArrayBuffer)) {
	                    reject(new Error('Invalid data from download worker'));
	                    return;
	                }
	                resolve(new Uint8Array(event.data.buffer));
	            };
	        })
	            .timeout(timeout, 'Timeout on direct download')
	            .finally(function () { worker.terminate(); });
	    };
	    Manager.prototype.timeoutcloseOnOffer = function (peer) {
	        if (peer.status === Peer_1.PeerStatus.CONNECTING && this.swarm.peers.has(peer.id)) {
	            this.offerPeers = this.offerPeers - 1;
	            this.swarm.peers.delete(peer.id);
	            peer.close(new Error('Timeout on connection'));
	            log_1.logger().debug('Size Changed timeout Offer');
	            this.emit('sizeChanged', this.swarm.peers.size);
	        }
	        else {
	            return null;
	        }
	    };
	    Manager.prototype.timeoutcloseOnAnswer = function (peer) {
	        if (peer.status === Peer_1.PeerStatus.CONNECTING && this.swarm.peers.has(peer.id)) {
	            this.answerPeers = this.answerPeers - 1;
	            this.swarm.peers.delete(peer.id);
	            peer.close(new Error('Timeout on connection'));
	        }
	        log_1.logger().debug('Timeout on Answer');
	        return null;
	    };
	    Manager.prototype.deletePeerOnPing = function (peer, peerstate) {
	        if (this.swarm.peers.has(peer.id)) {
	            this.swarm.peers.delete(peer.id);
	            if (peer.status === Peer_1.PeerStatus.CONNECTED) {
	                if (peerstate === false) {
	                    this.offerPeers = this.offerPeers - 1;
	                    this.emit('sizeChanged timeout on Ping', this.swarm.peers.size);
	                }
	                else {
	                    this.answerPeers = this.answerPeers - 1;
	                }
	            }
	            this.send(new Proto.manager.Message({
	                Type: Proto.manager.MessageType.MessageTypeSwipeLeft,
	                ArgumentsSwipeLeft: {
	                    Peer: peer.id,
	                    Reason: Proto.manager.SwipeLeftReason.SwipeLeftNotReachable,
	                },
	            }))
	                .catch(function (err) {
	                log_1.logger().warn('Could not send SwipeLeft message: ', err);
	            });
	            peer.close(new Error('Timeout on connection'));
	            log_1.logger().debug('Size Changed', this.offerPeers, this.answerPeers);
	            return null;
	        }
	        else {
	            log_1.logger().debug('No PeerID');
	            return;
	        }
	    };
	    Manager.prototype.onMessage = function (event) {
	        var incoming;
	        try {
	            incoming = Proto.manager.Message.decode(new Uint8Array(event.data));
	        }
	        catch (err) {
	            log_1.logger().warn("Invalid message: " + err);
	            return;
	        }
	        switch (incoming.Type) {
	            case Proto.manager.MessageType.MessageTypeHereAreSomePeers:
	                this.onNewPeers(incoming.ArgumentsHereAreSomePeers.Peers);
	                break;
	            case Proto.manager.MessageType.MessageTypePairingRequest:
	                this.onPairingRequest(incoming.ArgumentsPairingRequest);
	                break;
	            case Proto.manager.MessageType.MessageTypeBye:
	                this.onBye(incoming.ArgumentsBye.Reason);
	                break;
	            case Proto.manager.MessageType.MessageTypePairingInProgress:
	                this.onPairingInProgress(incoming.ArgumentsPairingInProgress);
	                break;
	            case Proto.manager.MessageType.MessageTypeRegistered:
	                this.onRegistered(incoming.ArgumentsRegistered);
	                break;
	            default:
	                log_1.logger().warn('Unknown message type from manager');
	        }
	    };
	    Manager.prototype.onClose = function () {
	        var _this = this;
	        delete this.ws;
	        this.connected = false;
	        this.emit('disconnected');
	        log_1.logger().warn('Manager disconnected, trying to reconnect');
	        if (!this.userClosed) {
	            log_1.logger().warn('Manager disconnected, trying to reconnect');
	            if (this.reconnectInterval) {
	                window.clearInterval(this.reconnectInterval);
	            }
	            this.reconnectInterval = window.setInterval(function () {
	                if (_this.connected) {
	                    window.clearInterval(_this.reconnectInterval);
	                    return;
	                }
	                if (!_this.connecting) {
	                    _this.connect();
	                }
	            }, Constants.WS_RECONNECTION_INTERVAL);
	        }
	    };
	    Manager.prototype.onError = function (event) {
	        var error = event.error;
	        this.emit('disconnected');
	        if (error === undefined) {
	            error = new Error('Unknown error from manager WS, see browser console');
	        }
	        log_1.logger().error(error);
	        this.emit('error', error);
	    };
	    Manager.prototype.onNewPeers = function (peers) {
	        log_1.logger().debug("New peers from manager: " + peers);
	        for (var _i = 0, peers_1 = peers; _i < peers_1.length; _i++) {
	            var newPeerId = peers_1[_i];
	            if (this.offerPeers >= Constants.OFFER_REQUEST) {
	                return;
	            }
	            else if (!this.swarm.hasPeer(newPeerId) &&
	                !this.swarm.isPairingInProgress(newPeerId)) {
	                this.swarm.add(new Peer_1.Peer(this, newPeerId), true);
	            }
	        }
	    };
	    Manager.prototype.onPairingRequest = function (args) {
	        var _this = this;
	        if (args.Type === Proto.manager.PairingRequestType.PairingRequestType_offer) {
	            if (this.answerPeers >= Constants.MAX_ANSWER_REQUEST || this.swarm.getSize() >= Constants.SWARM_SIZE) {
	                if (this.offerPeers > Constants.MIN_OFFER_REQUEST) {
	                    log_1.logger().debug('Pairing Request checking the swarm connection status');
	                    var result = this.swarm.checkPeerStatus();
	                    if (result === false) {
	                        log_1.logger().debug('Swarm fully connected');
	                        return;
	                    }
	                    else {
	                        log_1.logger().debug('Closing not connected peer, accepting pairing request');
	                    }
	                }
	                else {
	                    log_1.logger().debug('Cannot accept pairing request');
	                    return;
	                }
	            }
	            if (this.swarm.hasPeer(args.Peer)) {
	                log_1.logger().warn("Pairing request from " + args.Peer + " which is already in swarm");
	                return;
	            }
	            log_1.logger().debug("Pairing request from " + args.Peer);
	            this.answerPeers = this.answerPeers + 1;
	            log_1.logger().debug('RequestonAnswer', this.offerPeers, this.answerPeers);
	            var peer_1 = new Peer_1.Peer(this, args.Peer);
	            this.swarm.add(peer_1, false);
	            peer_1.acceptOffer(args)
	                .catch(function (err) {
	                peer_1.close(err);
	                _this.answerPeers = _this.answerPeers - 1;
	                log_1.logger().warn(err);
	            });
	        }
	        else if (args.Type === Proto.manager.PairingRequestType.PairingRequestType_answer) {
	            var peer = this.swarm.getPeer(args.Peer);
	            if (peer === null) {
	                log_1.logger().warn('Pairing answer from an unknown peer');
	                return;
	            }
	            peer.setAnswer(args)
	                .catch(function (err) {
	                log_1.logger().warn(err);
	            });
	        }
	        else {
	            log_1.logger().warn('Unknown pairing request type');
	        }
	    };
	    Manager.prototype.onBye = function (reason) {
	        log_1.logger().warn("Manager will close the connection: " + reason);
	    };
	    Manager.prototype.onRegistered = function (message) {
	        this.registered = true;
	        this.swarm.startPopulate();
	        this.peerId = message.ID;
	        this.emit('registered', this.peerId);
	        if (message.ISP.length > 0) {
	            this.stats.setISP(message.ISP);
	            this.peerInfos.isp = message.ISP;
	        }
	    };
	    Manager.prototype.onPairingInProgress = function (message) {
	        this.swarm.pairingInProgress(message.Peer);
	    };
	    Manager.prototype.userClose = function () {
	        this.userClosed = true;
	        this.ws.close();
	    };
	    Manager.prototype.getTimeoutSpecs = function (timeout) {
	        if (timeout < 2000) {
	            return {
	                random: 0,
	                timesAsk: 0,
	                peersProbe: 10,
	                fallback: 20,
	            };
	        }
	        if (timeout < 5000) {
	            return {
	                random: 5,
	                timesAsk: 1,
	                peersProbe: 10,
	                fallback: 20,
	            };
	        }
	        if (timeout < 15000) {
	            return {
	                random: 10,
	                timesAsk: 1,
	                peersProbe: 10,
	                fallback: 10,
	            };
	        }
	        return {
	            random: 11,
	            timesAsk: 1,
	            peersProbe: 10,
	            fallback: 10,
	        };
	    };
	    Manager.prototype.createLeechState = function (url, timeout) {
	        return {
	            url: url, timeout: timeout,
	            start: Date.now(),
	            specs: this.getTimeoutSpecs(timeout),
	            usedV2V: false,
	        };
	    };
	    Manager.prototype.check_InternalMemory = function (url, state) {
	        url = url.split('?')[0];
	        if ((typeof url !== 'string') || (url === '')) {
	            log_1.logger().warn('Checking for an empty/invalid resource request');
	            return null;
	        }
	        else if (this.storage1.hasHaveResource(url) === false) {
	            {
	                if (state.specs.timesAsk === 1) {
	                    state.specs.timesAsk += 1;
	                    return this.check_Downloading(url, state);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	        else {
	            this.result1 = this.storage1.getHaveResource(url);
	            if (this.result1.length === 0) {
	                return null;
	            }
	            return Promise.resolve(this.swarm.getPeer(this.result1));
	        }
	    };
	    Manager.prototype.check_Downloading = function (url, state) {
	        var _this = this;
	        url = url.split('?')[0];
	        var min = 2000;
	        var max = 4000;
	        if ((typeof url !== 'string') || (url === '')) {
	            log_1.logger().warn('Checking for an empty/invalid resource request');
	            return null;
	        }
	        else if (this.storageDownloading.hasDownloadingResource(url) === false) {
	            return null;
	        }
	        else {
	            var timeout_download = Math.round(Math.random() * (max - min) + min);
	            log_1.logger().debug("[Wait]: " + timeout_download + "ms");
	            return Promise.delay(timeout_download).then(function () { return _this.check_InternalMemory(url, state); });
	        }
	    };
	    Manager.prototype.getResourceRandomWait = function (state) {
	        if (state.specs.random === 0) {
	            log_1.logger().debug('[Random]: No random');
	            return Promise.resolve(state);
	        }
	        var timeout = Math.round(state.timeout * (Math.random() * (state.specs.random / 100)));
	        log_1.logger().debug("[Random]: " + timeout + "ms");
	        return Promise.delay(timeout).then(function () { return state; });
	    };
	    Manager.prototype.getResourceProbePeers = function (state) {
	        var _this = this;
	        if ((state.specs.peersProbe === 0) || (state.specs.peersProbe === 0)) {
	            log_1.logger().debug('[Peer probe]: Disabled');
	            return Promise.resolve(state);
	        }
	        return Promise.reduce(Array(state.specs.timesAsk).slice(), function (s) {
	            return _this.check_InternalMemory(state.url, state)
	                .then(function (result) {
	                if (result !== null) {
	                    s.peer = result;
	                }
	                return (s);
	            });
	        }, state)
	            .catch(function (err) {
	            return state;
	        });
	    };
	    Manager.prototype.getResourceLeech = function (state) {
	        var _this = this;
	        if (state.peer === undefined) {
	            var deadline = (state.start + state.timeout);
	            var timeout = (deadline - Date.now());
	            log_1.logger().debug('Leech direct');
	            this.swarm.startedDownloading(this.peerId, state.url);
	            return this.directDownload(state.url, timeout)
	                .then(function (content) {
	                state.resource = content;
	                return state;
	            })
	                .then(function () {
	                _this.swarm.swarmUpdate(_this.peerId, state.url);
	                return state;
	            });
	        }
	        var timeoutV2V = 5000;
	        var usedV2V = true;
	        log_1.logger().debug("[Leech v2v]: " + timeoutV2V + "ms");
	        return state.peer
	            .sendHaveRequest(state.url, this.result1, timeoutV2V)
	            .catch(function (err) {
	            log_1.logger().warn(err);
	            log_1.logger().debug("[Leech Direct, fallback]: " + timeoutV2V + "ms");
	            usedV2V = false;
	            return _this.directDownload(state.url, (state.start + state.timeout) - Date.now());
	        })
	            .then(function (content) {
	            state.resource = content;
	            state.usedV2V = usedV2V;
	            return state;
	        });
	    };
	    return Manager;
	}(events_1.EventEmitter));
	exports.Manager = Manager;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var log_1 = __webpack_require__(65);
	var checks = [
	    blob,
	    setAndMap,
	    typedArraySupported,
	    webRTC,
	    webSockets,
	    webWorkers,
	];
	function compatibilityProblems() {
	    var problems = [];
	    for (var _i = 0, checks_1 = checks; _i < checks_1.length; _i++) {
	        var test = checks_1[_i];
	        var result = null;
	        try {
	            result = test.apply(null);
	        }
	        catch (err) {
	            log_1.logger().warn('Error while checking compatibility', err);
	        }
	        if (typeof result === 'string') {
	            problems.push(result);
	        }
	    }
	    return problems;
	}
	exports.compatibilityProblems = compatibilityProblems;
	function webSockets() {
	    if (typeof WebSocket !== 'function') {
	        return 'WebSockets API is not available';
	    }
	    if (!WebSocket.prototype.hasOwnProperty('protocol')) {
	        return 'WebSockets sub-protocols are not available';
	    }
	    return null;
	}
	function webRTC() {
	    if (typeof window.RTCPeerConnection !== 'function') {
	        return 'WebRTC API is not available';
	    }
	    if (typeof window.RTCPeerConnection.prototype.createDataChannel !== 'function') {
	        return 'WebRTC API istoo old and does not support data channels';
	    }
	}
	function typedArraySupported() {
	    if (typeof Uint8Array !== 'function') {
	        return 'Typed array are not available';
	    }
	    if (typeof ArrayBuffer !== 'function') {
	        return 'ArrayBuffer is not available';
	    }
	}
	function setAndMap() {
	    if (typeof Set !== 'function') {
	        return 'ES6 Set are not supported';
	    }
	    if (typeof Map !== 'function') {
	        return 'ES6 Map are not supported';
	    }
	}
	function blob() {
	    if (typeof window.Blob !== 'function') {
	        return 'Blob API is not supported';
	    }
	}
	function webWorkers() {
	    if (typeof Worker !== 'function') {
	        return 'WebWorkers API is not supported';
	    }
	}
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Proto = __webpack_require__(1);
	var IceCandidate_1 = __webpack_require__(25);
	var Utils = __webpack_require__(71);
	var Register = (function (_super) {
	    __extends(Register, _super);
	    function Register(url, bandwidth, codec, timeShifting) {
	        var _this = _super.call(this) || this;
	        _this.Type = Proto.manager.MessageType.MessageTypeRegister;
	        if (!Utils.isValidUrl(url)) {
	            throw new Error('Invalid/Missing content url');
	        }
	        if ((typeof bandwidth !== 'number') || bandwidth < 0) {
	            throw new Error('Invalid/Missing bandwith value');
	        }
	        if ((typeof codec !== 'string') || codec.length <= 0) {
	            throw new Error('Invalid/Missing codec value');
	        }
	        if (Utils.isDefined(timeShifting)) {
	            if ((typeof timeShifting !== 'number') || timeShifting <= 0) {
	                throw new Error('Invalid timeshifting value');
	            }
	        }
	        else {
	            timeShifting = 0;
	        }
	        _this.ArgumentsRegister = {
	            Url: url,
	            Bandwidth: bandwidth,
	            Codec: codec,
	            TimeShift: timeShifting,
	        };
	        return _this;
	    }
	    Register.prototype.gatherCandidates = function () {
	        var _this = this;
	        return IceCandidate_1.getManagerIceCandidates()
	            .then(function (candidates) {
	            if (candidates.length === 0) {
	                throw new Error('Unable to gather ICE candidates');
	            }
	            _this.ArgumentsRegister.Candidates = [];
	            for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
	                var candidate = candidates_1[_i];
	                var candType = 0;
	                switch (candidate.Type) {
	                    case IceCandidate_1.IceCandidateType.Host:
	                        candType = Proto.manager.IceCandidateType.CandidateTypeHost;
	                        break;
	                    case IceCandidate_1.IceCandidateType.PeerReflexive:
	                        candType = Proto.manager.IceCandidateType.CandidateTypePeerReflexive;
	                        break;
	                    case IceCandidate_1.IceCandidateType.ServerReflexive:
	                        candType = Proto.manager.IceCandidateType.CandidateTypeServerReflexive;
	                        break;
	                    case IceCandidate_1.IceCandidateType.Relay:
	                        candType = Proto.manager.IceCandidateType.CandidateTypeRelay;
	                        break;
	                    default:
	                        continue;
	                }
	                _this.ArgumentsRegister.Candidates.push({
	                    Type: candType,
	                    Address: candidate.Address,
	                });
	            }
	        });
	    };
	    return Register;
	}(Proto.manager.Message));
	exports.Register = Register;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function isDefined(value) {
	    return (value !== undefined);
	}
	exports.isDefined = isDefined;
	function isValidUrl(value) {
	    if (typeof value !== 'string') {
	        return false;
	    }
	    return (value.match(/^https?:\/\//) !== null);
	}
	exports.isValidUrl = isValidUrl;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9pc2hhbmkvdGhlc2lzL3NyYy91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU9BLG1CQUEwQixLQUFVO0lBQ2xDLE9BQU8sQ0FBQyxLQUFLLEtBQUssU0FBUyxDQUFDLENBQUM7QUFDL0IsQ0FBQztBQUZELDhCQUVDO0FBS0Qsb0JBQTJCLEtBQVU7SUFDbkMsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLEVBQUU7UUFDN0IsT0FBTyxLQUFLLENBQUM7S0FDZDtJQUNELE9BQU8sQ0FBVSxLQUFNLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxLQUFLLElBQUksQ0FBQyxDQUFDO0FBQzFELENBQUM7QUFMRCxnQ0FLQyIsImZpbGUiOiJ1dGlscy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogVmFyaW91cyB1dGlsaXRpZXMuXG4gKi9cblxuLyoqXG4gKiBUZWxscyBpZiBnaXZlbiB2YWx1ZSBpcyBkZWZpbmVkLlxuICovXG5leHBvcnQgZnVuY3Rpb24gaXNEZWZpbmVkKHZhbHVlOiBhbnkpOiBib29sZWFuIHsgLy90c2xpbnQ6ZGlzYWJsZS1saW5lOiBuby1hbnlcbiAgcmV0dXJuICh2YWx1ZSAhPT0gdW5kZWZpbmVkKTtcbn1cblxuLyoqXG4gKiBUZWxscyBpZiBnaXZlbiB2YWx1ZSBpcyBhIHZhbGlkIHVybC5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGlzVmFsaWRVcmwodmFsdWU6IGFueSk6IGJvb2xlYW4geyAvL3RzbGludDpkaXNhYmxlLWxpbmU6IG5vLWFueVxuICBpZiAodHlwZW9mIHZhbHVlICE9PSAnc3RyaW5nJykge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuICByZXR1cm4gKCg8c3RyaW5nPnZhbHVlKS5tYXRjaCgvXmh0dHBzPzpcXC9cXC8vKSAhPT0gbnVsbCk7XG59XG4iXX0=


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Promise = __webpack_require__(26);
	var Proto = __webpack_require__(1);
	var Constants = __webpack_require__(24);
	var events_1 = __webpack_require__(68);
	var eb_peers_1 = __webpack_require__(73);
	var uuid_1 = __webpack_require__(74);
	var log_1 = __webpack_require__(65);
	var PeerStatus;
	(function (PeerStatus) {
	    PeerStatus[PeerStatus["NEW"] = 1] = "NEW";
	    PeerStatus[PeerStatus["CONNECTING"] = 2] = "CONNECTING";
	    PeerStatus[PeerStatus["CONNECTED"] = 3] = "CONNECTED";
	    PeerStatus[PeerStatus["ERROR"] = 4] = "ERROR";
	    PeerStatus[PeerStatus["CLOSED"] = 5] = "CLOSED";
	})(PeerStatus = exports.PeerStatus || (exports.PeerStatus = {}));
	var actionToPoints = new Map([
	    ['satisfyFull', 10],
	    ['satisfyError', -10],
	    ['satisfy', 1],
	    ['request', 1],
	    ['busy', -5],
	    ['strange', -30],
	]);
	var incomingMessagesOrder = [
	    [
	        eb_peers_1.peers.MessageType.MessageTypePing,
	        eb_peers_1.peers.MessageType.MessageTypePong,
	    ],
	    [
	        eb_peers_1.peers.MessageType.MessageTypeHave,
	        eb_peers_1.peers.MessageType.MessageTypeUpdate,
	        eb_peers_1.peers.MessageType.MessageTypeDownloading,
	        eb_peers_1.peers.MessageType.MessageTypeBusy,
	    ],
	    [
	        eb_peers_1.peers.MessageType.MessageTypeRequestonHave,
	        eb_peers_1.peers.MessageType.MessageTypeSatisfy,
	    ],
	];
	var Peer = (function (_super) {
	    __extends(Peer, _super);
	    function Peer(manager, id) {
	        var _this = _super.call(this) || this;
	        _this.status = PeerStatus.NEW;
	        _this.rttPingCount = 0;
	        _this.rttPingTotal = 0;
	        _this.score = 0;
	        var config = {
	            iceServers: [{
	                    urls: Constants.STUN_SERVERS,
	                }],
	            iceTransportPolicy: 'all',
	        };
	        _this.id = id;
	        _this.manager = manager;
	        _this.rtcConnection = (new RTCPeerConnection(config));
	        _this.rtcConnection.ondatachannel =
	            function (ev) { _this.onOfferingChannel(ev.channel); };
	        _this.pingList = new Map();
	        _this.incomingBuffer = new Set();
	        _this.startIncomingLoop();
	        return _this;
	    }
	    Peer.prototype.getstorage_have = function () {
	        return this.storage1;
	    };
	    Peer.prototype.close = function (error) {
	        if (this.connectionTimer) {
	            window.clearTimeout(this.connectionTimer);
	            this.connectionTimer = undefined;
	        }
	        this.emit('disconnected', error);
	        this.stopIncomingLoop();
	        this.stopPing();
	        try {
	            this.rtcConnection.close();
	            this.rtcConnection = null;
	        }
	        catch (e) {
	        }
	        if (error !== undefined) {
	            this.status = PeerStatus.ERROR;
	            return;
	        }
	        this.status = PeerStatus.CLOSED;
	    };
	    Peer.prototype.sendOffer = function () {
	        var _this = this;
	        if (this.status !== PeerStatus.NEW) {
	            log_1.logger().warn('Ignoring sendOffer() on a peer that is not new');
	            return Promise.resolve();
	        }
	        this.manager.offerPeers = this.manager.offerPeers + 1;
	        log_1.logger().debug('sendOffer', this.manager.offerPeers);
	        var message = new Proto.manager.Message({
	            Type: Proto.manager.MessageType.MessageTypeSwipeRight,
	            ArgumentsSwipeRight: { Peer: this.id },
	        });
	        this.syncChannel = this.rtcConnection.createDataChannel('sync');
	        this.syncChannel.binaryType = 'arraybuffer';
	        this.bindSyncEvents();
	        this.connectionTimer = window.setTimeout(function () { _this.timeoutPairingOnOffer(); }, Constants.PEER_MAX_CONNECTION_TIME);
	        return this.getSDPAndCandidates()
	            .then(function (_a) {
	            var offer = _a[0], candidates = _a[1];
	            message.ArgumentsSwipeRight.Offer = offer.sdp;
	            message.ArgumentsSwipeRight.Candidates = candidates.map(function (c) { return JSON.stringify(c); });
	            return _this.manager.send(message);
	        })
	            .then(function () { _this.status = PeerStatus.CONNECTING; });
	    };
	    Peer.prototype.setAnswer = function (offer) {
	        var _this = this;
	        if (this.status !== PeerStatus.CONNECTING) {
	            return Promise.reject(new Error('Not waiting for an answer'));
	        }
	        return Promise.resolve(this.rtcConnection.setRemoteDescription(new RTCSessionDescription({
	            type: 'answer',
	            sdp: offer.Offer,
	        })))
	            .then(function () { return Promise.each(offer.Candidates, function (candidate) {
	            try {
	                return _this.rtcConnection.addIceCandidate(new RTCIceCandidate(JSON.parse(candidate)));
	            }
	            catch (err) {
	                log_1.logger().debug("Could not parse incoming ICE candidate \"" + candidate + ": " + err);
	            }
	        }); }).return();
	    };
	    Peer.prototype.acceptOffer = function (req) {
	        var _this = this;
	        this.status = PeerStatus.CONNECTING;
	        return Promise.resolve()
	            .then(function () { return _this.rtcConnection.setRemoteDescription(new RTCSessionDescription({
	            type: 'offer',
	            sdp: req.Offer,
	        })); })
	            .then(function () { return Promise.each(req.Candidates, function (candidate) {
	            try {
	                return _this.rtcConnection.addIceCandidate(new RTCIceCandidate(JSON.parse(candidate)));
	            }
	            catch (err) {
	                log_1.logger().debug("Could not parse incoming ICE candidate \"" + candidate + ": " + err);
	            }
	        }); })
	            .then(function () { return _this.getSDPAndCandidates(true); })
	            .then(function (_a) {
	            var offer = _a[0], candidates = _a[1];
	            var message = new Proto.manager.Message({
	                Type: Proto.manager.MessageType.MessageTypeItsAMatch,
	                ArgumentsItsAMatch: {
	                    Peer: _this.id,
	                    Offer: offer.sdp,
	                    Candidates: candidates.map(function (c) { return JSON.stringify(c); }),
	                },
	            });
	            _this.connectionTimer = window.setTimeout(function () { _this.timeoutPairingOnAnswer(); }, Constants.PEER_MAX_CONNECTION_TIME);
	            return _this.manager.send(message);
	        });
	    };
	    Peer.prototype.getRTT = function () {
	        if ((this.rttPingCount > 0) && (this.rttPingTotal > 0)) {
	            return Math.round(this.rttPingTotal / this.rttPingCount);
	        }
	        return null;
	    };
	    Peer.prototype.setQuality = function () {
	        var buffer = this.manager.getBufferLength();
	        if (buffer >= 20.0) {
	            this.peerQuality = 2;
	            return (this.peerQuality);
	        }
	        else if ((buffer < 20.0) && (buffer >= 10.0)) {
	            this.peerQuality = 1;
	            return (this.peerQuality);
	        }
	        else {
	            this.peerQuality = 0;
	            return (this.peerQuality);
	        }
	    };
	    Peer.prototype.isInitiator = function () {
	        return this.initiator;
	    };
	    Peer.prototype.isParticipator = function () {
	        return !this.initiator;
	    };
	    Peer.prototype.setInitiator = function (value) {
	        this.initiator = value;
	    };
	    Peer.prototype.sendDownloading = function (id, url) {
	        var _this = this;
	        this.peerQuality = this.setQuality();
	        if (this.status !== PeerStatus.CONNECTED) {
	            return Promise.resolve(false);
	        }
	        this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypeDownloading,
	            ArgumentsHave: {
	                Id: id,
	                urlHave: url,
	                peerQuality: this.peerQuality,
	            },
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("Could not send downloading message to " + _this.id + ": " + err);
	        });
	    };
	    Peer.prototype.sendHave = function (id, url) {
	        var _this = this;
	        this.peerQuality = this.setQuality();
	        if (this.status !== PeerStatus.CONNECTED) {
	            return Promise.resolve(false);
	        }
	        this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypeHave,
	            ArgumentsHave: {
	                Id: id,
	                urlHave: url,
	                peerQuality: this.peerQuality,
	            },
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("Could not send have to " + _this.id + ": " + err);
	            return Promise.resolve(false);
	        });
	    };
	    Peer.prototype.sendupdate = function (id) {
	        var _this = this;
	        var result1 = this.manager.getStorage().getUpdatedResource();
	        return this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypeUpdate,
	            ArgumentsHave: {
	                Id: id,
	                urlHave: result1,
	            },
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("Could not send update message to " + _this.id + ": " + err);
	        });
	    };
	    Peer.prototype.getScore = function () {
	        return this.score;
	    };
	    Peer.prototype.sendHaveRequest = function (url, requestingPeer, timeout) {
	        var _this = this;
	        var callback;
	        this.receivingPeer = requestingPeer;
	        if (this.status !== PeerStatus.CONNECTED) {
	            return Promise.resolve(null);
	        }
	        this.emit('p2pRequestSend', url, this.id, this.manager.peerId, timeout);
	        log_1.logger().debug('sending V2V request to ', this.id);
	        this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypeRequestonHave,
	            ArgumentsHave: {
	                Id: this.id,
	                urlHave: url,
	            },
	        }))
	            .catch(function (err) {
	            log_1.logger().warn("could not send request to " + _this.id + ": " + err);
	        });
	        return new Promise(function (resolve) {
	            var parts;
	            var receivedParts = 0;
	            url = url.split('?')[0].replace(/(hdn).*\//g, '');
	            callback = function (resource, content, part, partCount) {
	                _this.setAction('satisfy');
	                url = url.split('?')[0].replace(/(hdn).*\//g, '');
	                if (resource !== url) {
	                    return;
	                }
	                if (partCount === 1) {
	                    resolve(content);
	                    return;
	                }
	                if (parts === undefined) {
	                    parts = new Array(partCount);
	                }
	                parts[part] = content;
	                receivedParts = receivedParts + 1;
	                if (receivedParts === partCount) {
	                    resolve(_this.assembleParts(parts));
	                    _this.setAction('satisfyFull');
	                    log_1.logger().debug('[V2V] Received chunk');
	                    return;
	                }
	            };
	            _this.on('satisfy', callback);
	        })
	            .timeout(timeout, "Timeout while leeching resource on " + this.id)
	            .catch(function (err) {
	            _this.setAction('satisfyError');
	            throw err;
	        })
	            .finally(function () {
	            _this.removeListener('satisfy', callback);
	        });
	    };
	    Peer.prototype.onBusy = function (resource) {
	        if ((typeof resource !== 'string') || (resource === '')) {
	            log_1.logger().warn('Received busy for an empty/invalid resource');
	            this.setAction('strange');
	            return;
	        }
	        this.setAction('busy');
	        this.emit('resourceAvailability', 'busy', resource);
	        this.emit('busy', resource, this.receivingPeer, this.manager.peerId);
	    };
	    Peer.prototype.getSDPAndCandidates = function (isAnswer) {
	        var _this = this;
	        if (isAnswer === void 0) { isAnswer = false; }
	        var session;
	        var candidates = [];
	        return Promise.resolve()
	            .then(function () { return new Promise(function (resolve, reject) {
	            var alreadyResolved = false;
	            _this.rtcConnection.onicecandidate = function (ev) {
	                if ((typeof ev !== 'object') || (ev.candidate === undefined)) {
	                    return;
	                }
	                if (ev.candidate === null) {
	                    if (!alreadyResolved) {
	                        alreadyResolved = true;
	                        return resolve();
	                    }
	                }
	                candidates.push(ev.candidate);
	            };
	            setTimeout(function () {
	                if (!alreadyResolved) {
	                    log_1.logger().debug("Found " + candidates.length + " ICE candidate(s) after timeout");
	                    alreadyResolved = true;
	                    return resolve();
	                }
	            }, Constants.ICE_TIMEOUT);
	            Promise.resolve(isAnswer ?
	                _this.rtcConnection.createAnswer() :
	                _this.rtcConnection.createOffer())
	                .tap(function (s) { return _this.rtcConnection.setLocalDescription(s); })
	                .then(function (s) { session = s; })
	                .catch(function (err) {
	                log_1.logger().warn("Could not create RTC session: " + err);
	                reject(err);
	                alreadyResolved = true;
	            });
	        }); })
	            .then(function () {
	            if (candidates.length < 1) {
	                throw new Error('No ICE candidate available');
	            }
	        })
	            .then(function () {
	            return ([session, candidates]);
	        });
	    };
	    Peer.prototype.bindSyncEvents = function () {
	        var _this = this;
	        if (this.syncChannel === undefined) {
	            throw new Error('Cannot bind sync channel event: undefined');
	        }
	        this.syncChannel.onopen = function () {
	            if (_this.status !== PeerStatus.CONNECTED) {
	                if (_this.connectionTimer) {
	                    window.clearTimeout(_this.connectionTimer);
	                    _this.connectionTimer = undefined;
	                }
	                _this.emit('connected');
	                _this.status = PeerStatus.CONNECTED;
	                _this.sendupdate(_this.manager.peerId);
	                _this.startPing();
	            }
	        };
	        this.syncChannel.onclose = function () {
	            _this.close();
	        };
	        this.syncChannel.onerror = function (event) {
	            _this.close();
	        };
	        this.syncChannel.onmessage = function (event) {
	            _this.onMessage(event.data);
	        };
	    };
	    Peer.prototype.onOfferingChannel = function (channel) {
	        var _this = this;
	        var setup = function () {
	            if (_this.status !== PeerStatus.CONNECTED) {
	                _this.syncChannel = channel;
	                _this.syncChannel.binaryType = 'arraybuffer';
	                _this.status = PeerStatus.CONNECTED;
	                _this.emit('connected');
	                if (_this.connectionTimer) {
	                    window.clearTimeout(_this.connectionTimer);
	                    _this.connectionTimer = undefined;
	                }
	                _this.bindSyncEvents();
	                _this.startPing();
	            }
	        };
	        if (channel.readyState === 'open') {
	            setup();
	        }
	        else {
	            channel.onopen = function () { setup(); };
	        }
	    };
	    Peer.prototype.send = function (message) {
	        var _this = this;
	        var error = eb_peers_1.peers.Message.verify(message);
	        if (error !== null) {
	            log_1.logger().warn("Trying to send an invalid message: " + error);
	            return Promise.reject(new Error(error));
	        }
	        return Promise.try(function () { return eb_peers_1.peers.Message.encode(message).finish(); })
	            .then(function (data) { _this.syncChannel.send(data); });
	    };
	    Peer.prototype.startPing = function () {
	        var _this = this;
	        this.stopPing();
	        this.pingTimer = window.setInterval(function () {
	            _this.checkPing();
	            _this.ping();
	        }, Constants.PING_INTERVAL);
	    };
	    Peer.prototype.stopPing = function () {
	        if (this.pingTimer) {
	            window.clearInterval(this.pingTimer);
	            this.pingTimer = undefined;
	        }
	    };
	    Peer.prototype.checkPing = function () {
	        var _this = this;
	        this.pingList.forEach(function (ts, id) {
	            if ((Date.now() - ts) > (Constants.PING_INTERVAL * 3)) {
	                log_1.logger().warn(_this.id + " timed out on ping, closing");
	                _this.pingList.delete(id);
	                if (_this.initiator === false) {
	                    _this.manager.deletePeerOnPing(_this, false);
	                }
	                else {
	                    _this.manager.deletePeerOnPing(_this, true);
	                }
	                _this.manager.getstoragehave().removeRecord(_this.id);
	                _this.manager.getstorageDownlaoding().removeRecord(_this.id);
	                _this.close(new Error('Ping Timeout'));
	            }
	        });
	    };
	    Peer.prototype.ping = function () {
	        var _this = this;
	        if (this.status === PeerStatus.CLOSED || this.status === PeerStatus.ERROR) {
	            return;
	        }
	        var id = uuid_1.v4();
	        this.pingList.set(id, Date.now());
	        this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypePing,
	            ArgumentsPingPong: { Id: id },
	        }))
	            .catch(function (err) {
	            _this.pingList.delete(_this.id);
	            _this.manager.getstoragehave().removeRecord(_this.id);
	            _this.manager.getstorageDownlaoding().removeRecord(_this.id);
	        });
	    };
	    Peer.prototype.onPing = function (id) {
	        var _this = this;
	        if (id === undefined) {
	            log_1.logger().warn('Received a ping without id');
	            return;
	        }
	        this.send(new eb_peers_1.peers.Message({
	            Type: eb_peers_1.peers.MessageType.MessageTypePong,
	            ArgumentsPingPong: { Id: id },
	        }))
	            .catch(function (err) {
	            _this.manager.getstoragehave().removeRecord(_this.id);
	            _this.manager.getstorageDownlaoding().removeRecord(_this.id);
	            _this.pingList.delete(id);
	        });
	    };
	    Peer.prototype.onPong = function (id) {
	        if (id === undefined) {
	            log_1.logger().warn('Received a pong without id');
	            return;
	        }
	        if (!this.pingList.has(id)) {
	            log_1.logger().warn('Received a pong with an unknown id');
	            return;
	        }
	        this.rttPingCount = this.rttPingCount + 1;
	        this.rttPingTotal = this.rttPingTotal + (Date.now() - this.pingList.get(id));
	        this.pingList.delete(id);
	    };
	    Peer.prototype.onHave = function (args) {
	        this.manager.getstoragehave().addHaveResources(args.Id, args.urlHave, args.peerQuality);
	    };
	    Peer.prototype.onDownloading = function (args) {
	        this.manager.getstorageDownlaoding().addDownloadingResources(args.Id, args.urlHave, args.peerQuality);
	    };
	    Peer.prototype.onRequest = function (args) {
	        var args_url = args.urlHave;
	        args_url = args_url.split('?')[0].replace(/(hdn).*\//g, '');
	        if (typeof args_url !== 'string' || args_url === '') {
	            log_1.logger().warn('Invalid or empty request');
	            this.setAction('strange');
	            return Promise.resolve(null);
	        }
	        if (!this.manager) {
	            return Promise.resolve(null);
	        }
	        if (this.manager.getStorage().hasResource(args_url)) {
	            if (!this.manager.getSwarm().hasFreeSlots()) {
	                this.send(new eb_peers_1.peers.Message({
	                    Type: eb_peers_1.peers.MessageType.MessageTypeBusy,
	                }))
	                    .catch(function (err) {
	                    log_1.logger().warn('Could not send busy');
	                });
	            }
	            else {
	                return Promise.resolve(this.sendResource(args_url, args.Id, this.manager.getStorage().getResource(args_url)));
	            }
	        }
	    };
	    Peer.prototype.onSatisfy = function (args) {
	        if ((typeof args.Resource !== 'string') || (args.Resource === '')) {
	            this.setAction('strange');
	            log_1.logger().warn('Received satisfy for an empty/invalid resource');
	            return;
	        }
	        if (!(args.Content instanceof Uint8Array) || (args.Content.length === 0)) {
	            this.setAction('strange');
	            log_1.logger().warn('Received satisfy with an empty/invalid content');
	            return;
	        }
	        this.emit('satisfy', args.Resource, args.Content, args.PartNumber, (args.PartTotal === 0) ? 0 : args.PartTotal);
	    };
	    Peer.prototype.setAction = function (action) {
	        if (actionToPoints.has(action)) {
	            this.score = this.score + actionToPoints.get(action);
	            return;
	        }
	        log_1.logger().warn("Unknown/Empty score action : " + action);
	    };
	    Peer.prototype.assembleParts = function (parts) {
	        var size = parts.reduce(function (t, p) { return t + p.byteLength; }, 0);
	        var result = new Uint8Array(size);
	        var position = 0;
	        parts.forEach(function (p) {
	            result.set(p, position);
	            position = position + p.byteLength;
	        });
	        return result;
	    };
	    Peer.prototype.sendResource = function (url, peerReceive, content) {
	        var _this = this;
	        this.emit('startSending');
	        var a = peerReceive;
	        if (content.byteLength < 15000) {
	            this.send(new eb_peers_1.peers.Message({
	                Type: eb_peers_1.peers.MessageType.MessageTypeSatisfy,
	                ArgumentsSatisfy: {
	                    Resource: url,
	                    PartTotal: 1,
	                    PartNumber: 0,
	                    Content: content,
	                },
	            }))
	                .tap(function () {
	                log_1.logger().debug('[V2V] Sent chunk');
	                _this.emit('sentSatisfy', content.byteLength);
	            })
	                .catch(function (err) {
	                log_1.logger().warn("Could not send single part satisfy to " + _this.id + ": " + err);
	            })
	                .finally(function () { _this.emit('finishedSending'); });
	            return;
	        }
	        var partNumber = 0;
	        var partTotal = Math.ceil(content.byteLength / 15000);
	        var startSend = Date.now();
	        for (var i = 0; i < content.byteLength; i += 15000) {
	            var part = content.buffer.slice(i, i + 15000);
	            this.emit('p2pPartSend', url, a, this.id, partTotal, partNumber, part.byteLength);
	            this.send(new eb_peers_1.peers.Message({
	                Type: eb_peers_1.peers.MessageType.MessageTypeSatisfy,
	                ArgumentsSatisfy: {
	                    Resource: url,
	                    PartTotal: partTotal,
	                    PartNumber: partNumber,
	                    Content: new Uint8Array(part),
	                },
	            }))
	                .catch(function (err) {
	                log_1.logger().warn("Could not send single part satisfy to " + _this.id + ": " + err);
	            });
	            partNumber = partNumber + 1;
	        }
	        var watchTimer = window.setInterval(function () {
	            if (_this.syncChannel.bufferedAmount === 0) {
	                _this.emit('finishedSending');
	                log_1.logger().debug("[V2V] Sent chunk (" + (Date.now() - startSend) + "ms)");
	                _this.emit('sentSatisfy');
	                window.clearTimeout(watchTimer);
	            }
	        }, 100);
	    };
	    Peer.prototype.onMessage = function (data) {
	        var incoming;
	        try {
	            incoming = eb_peers_1.peers.Message.decode(new Uint8Array(data));
	        }
	        catch (err) {
	            log_1.logger().warn("Invalid incoming message from " + this.id + ": " + err);
	            return;
	        }
	        this.incomingBuffer.add(incoming);
	    };
	    Peer.prototype.getNextMessage = function () {
	        if (this.incomingBuffer.size === 0) {
	            return null;
	        }
	        var messages = Array.from(this.incomingBuffer);
	        var nextMessage;
	        for (var _i = 0, incomingMessagesOrder_1 = incomingMessagesOrder; _i < incomingMessagesOrder_1.length; _i++) {
	            var types = incomingMessagesOrder_1[_i];
	            for (var _a = 0, messages_1 = messages; _a < messages_1.length; _a++) {
	                var message = messages_1[_a];
	                if (types.indexOf(message.Type) !== -1) {
	                    nextMessage = message;
	                    break;
	                }
	            }
	            if (nextMessage !== undefined) {
	                break;
	            }
	        }
	        if (nextMessage === undefined) {
	            nextMessage = messages[0];
	        }
	        this.incomingBuffer.delete(nextMessage);
	        return nextMessage;
	    };
	    Peer.prototype.startIncomingLoop = function () {
	        var _this = this;
	        var loop = function () {
	            var message = _this.getNextMessage();
	            if (message === null) {
	                return;
	            }
	            _this.handleMessage(message);
	        };
	        this.stopIncomingLoop();
	        this.incomingLoopTimer = window.setInterval(function () { loop(); }, 10);
	    };
	    Peer.prototype.stopIncomingLoop = function () {
	        if (this.incomingLoopTimer) {
	            window.clearInterval(this.incomingLoopTimer);
	        }
	    };
	    Peer.prototype.handleMessage = function (incoming) {
	        switch (incoming.Type) {
	            case eb_peers_1.peers.MessageType.MessageTypePing:
	                this.onPing(incoming.ArgumentsPingPong.Id);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypePong:
	                this.onPong(incoming.ArgumentsPingPong.Id);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeDownloading:
	                this.onDownloading(incoming.ArgumentsHave);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeHave:
	                this.onHave(incoming.ArgumentsHave);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeUpdate:
	                this.onHave(incoming.ArgumentsHave);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeBusy:
	                this.onBusy(incoming.ArgumentsResource.Resource);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeRequestonHave:
	                this.onRequest(incoming.ArgumentsHave);
	                break;
	            case eb_peers_1.peers.MessageType.MessageTypeSatisfy:
	                this.onSatisfy(incoming.ArgumentsSatisfy);
	                break;
	            default:
	                log_1.logger().warn("Unknown message type from " + this.id, incoming);
	        }
	    };
	    Peer.prototype.timeoutPairingOnOffer = function () {
	        return this.manager.timeoutcloseOnOffer(this);
	    };
	    Peer.prototype.timeoutPairingOnAnswer = function () {
	        return this.manager.timeoutcloseOnAnswer(this);
	    };
	    return Peer;
	}(events_1.EventEmitter));
	exports.Peer = Peer;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins*/
	"use strict";
	
	var $protobuf = __webpack_require__(2);
	
	// Common aliases
	var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
	
	// Exported root namespace
	var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
	
	$root.peers = (function() {
	
	    /**
	     * Namespace peers.
	     * @exports peers
	     * @namespace
	     */
	    var peers = {};
	
	    peers.ArgumentsHave = (function() {
	
	        /**
	         * Properties of an ArgumentsHave.
	         * @memberof peers
	         * @interface IArgumentsHave
	         * @property {string|null} [Id] ArgumentsHave Id
	         * @property {string|null} [urlHave] ArgumentsHave urlHave
	         * @property {number|null} [peerQuality] ArgumentsHave peerQuality
	         */
	
	        /**
	         * Constructs a new ArgumentsHave.
	         * @memberof peers
	         * @classdesc Represents an ArgumentsHave.
	         * @implements IArgumentsHave
	         * @constructor
	         * @param {peers.IArgumentsHave=} [properties] Properties to set
	         */
	        function ArgumentsHave(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsHave Id.
	         * @member {string} Id
	         * @memberof peers.ArgumentsHave
	         * @instance
	         */
	        ArgumentsHave.prototype.Id = "";
	
	        /**
	         * ArgumentsHave urlHave.
	         * @member {string} urlHave
	         * @memberof peers.ArgumentsHave
	         * @instance
	         */
	        ArgumentsHave.prototype.urlHave = "";
	
	        /**
	         * ArgumentsHave peerQuality.
	         * @member {number} peerQuality
	         * @memberof peers.ArgumentsHave
	         * @instance
	         */
	        ArgumentsHave.prototype.peerQuality = 0;
	
	        /**
	         * Creates a new ArgumentsHave instance using the specified properties.
	         * @function create
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {peers.IArgumentsHave=} [properties] Properties to set
	         * @returns {peers.ArgumentsHave} ArgumentsHave instance
	         */
	        ArgumentsHave.create = function create(properties) {
	            return new ArgumentsHave(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsHave message. Does not implicitly {@link peers.ArgumentsHave.verify|verify} messages.
	         * @function encode
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {peers.IArgumentsHave} message ArgumentsHave message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHave.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Id);
	            if (message.urlHave != null && message.hasOwnProperty("urlHave"))
	                writer.uint32(/* id 3, wireType 2 =*/26).string(message.urlHave);
	            if (message.peerQuality != null && message.hasOwnProperty("peerQuality"))
	                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.peerQuality);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsHave message, length delimited. Does not implicitly {@link peers.ArgumentsHave.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {peers.IArgumentsHave} message ArgumentsHave message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsHave.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsHave message from the specified reader or buffer.
	         * @function decode
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {peers.ArgumentsHave} ArgumentsHave
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHave.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.peers.ArgumentsHave();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 2:
	                    message.Id = reader.string();
	                    break;
	                case 3:
	                    message.urlHave = reader.string();
	                    break;
	                case 4:
	                    message.peerQuality = reader.int32();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsHave message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {peers.ArgumentsHave} ArgumentsHave
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsHave.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsHave message.
	         * @function verify
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsHave.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                if (!$util.isString(message.Id))
	                    return "Id: string expected";
	            if (message.urlHave != null && message.hasOwnProperty("urlHave"))
	                if (!$util.isString(message.urlHave))
	                    return "urlHave: string expected";
	            if (message.peerQuality != null && message.hasOwnProperty("peerQuality"))
	                if (!$util.isInteger(message.peerQuality))
	                    return "peerQuality: integer expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsHave message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {peers.ArgumentsHave} ArgumentsHave
	         */
	        ArgumentsHave.fromObject = function fromObject(object) {
	            if (object instanceof $root.peers.ArgumentsHave)
	                return object;
	            var message = new $root.peers.ArgumentsHave();
	            if (object.Id != null)
	                message.Id = String(object.Id);
	            if (object.urlHave != null)
	                message.urlHave = String(object.urlHave);
	            if (object.peerQuality != null)
	                message.peerQuality = object.peerQuality | 0;
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsHave message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof peers.ArgumentsHave
	         * @static
	         * @param {peers.ArgumentsHave} message ArgumentsHave
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsHave.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults) {
	                object.Id = "";
	                object.urlHave = "";
	                object.peerQuality = 0;
	            }
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                object.Id = message.Id;
	            if (message.urlHave != null && message.hasOwnProperty("urlHave"))
	                object.urlHave = message.urlHave;
	            if (message.peerQuality != null && message.hasOwnProperty("peerQuality"))
	                object.peerQuality = message.peerQuality;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsHave to JSON.
	         * @function toJSON
	         * @memberof peers.ArgumentsHave
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsHave.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsHave;
	    })();
	
	    peers.ArgumentsPingPong = (function() {
	
	        /**
	         * Properties of an ArgumentsPingPong.
	         * @memberof peers
	         * @interface IArgumentsPingPong
	         * @property {string|null} [Id] ArgumentsPingPong Id
	         */
	
	        /**
	         * Constructs a new ArgumentsPingPong.
	         * @memberof peers
	         * @classdesc Represents an ArgumentsPingPong.
	         * @implements IArgumentsPingPong
	         * @constructor
	         * @param {peers.IArgumentsPingPong=} [properties] Properties to set
	         */
	        function ArgumentsPingPong(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsPingPong Id.
	         * @member {string} Id
	         * @memberof peers.ArgumentsPingPong
	         * @instance
	         */
	        ArgumentsPingPong.prototype.Id = "";
	
	        /**
	         * Creates a new ArgumentsPingPong instance using the specified properties.
	         * @function create
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {peers.IArgumentsPingPong=} [properties] Properties to set
	         * @returns {peers.ArgumentsPingPong} ArgumentsPingPong instance
	         */
	        ArgumentsPingPong.create = function create(properties) {
	            return new ArgumentsPingPong(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsPingPong message. Does not implicitly {@link peers.ArgumentsPingPong.verify|verify} messages.
	         * @function encode
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {peers.IArgumentsPingPong} message ArgumentsPingPong message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPingPong.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsPingPong message, length delimited. Does not implicitly {@link peers.ArgumentsPingPong.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {peers.IArgumentsPingPong} message ArgumentsPingPong message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsPingPong.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsPingPong message from the specified reader or buffer.
	         * @function decode
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {peers.ArgumentsPingPong} ArgumentsPingPong
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPingPong.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.peers.ArgumentsPingPong();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Id = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsPingPong message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {peers.ArgumentsPingPong} ArgumentsPingPong
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsPingPong.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsPingPong message.
	         * @function verify
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsPingPong.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                if (!$util.isString(message.Id))
	                    return "Id: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsPingPong message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {peers.ArgumentsPingPong} ArgumentsPingPong
	         */
	        ArgumentsPingPong.fromObject = function fromObject(object) {
	            if (object instanceof $root.peers.ArgumentsPingPong)
	                return object;
	            var message = new $root.peers.ArgumentsPingPong();
	            if (object.Id != null)
	                message.Id = String(object.Id);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsPingPong message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof peers.ArgumentsPingPong
	         * @static
	         * @param {peers.ArgumentsPingPong} message ArgumentsPingPong
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsPingPong.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Id = "";
	            if (message.Id != null && message.hasOwnProperty("Id"))
	                object.Id = message.Id;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsPingPong to JSON.
	         * @function toJSON
	         * @memberof peers.ArgumentsPingPong
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsPingPong.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsPingPong;
	    })();
	
	    peers.ArgumentsResource = (function() {
	
	        /**
	         * Properties of an ArgumentsResource.
	         * @memberof peers
	         * @interface IArgumentsResource
	         * @property {string|null} [Resource] ArgumentsResource Resource
	         */
	
	        /**
	         * Constructs a new ArgumentsResource.
	         * @memberof peers
	         * @classdesc Represents an ArgumentsResource.
	         * @implements IArgumentsResource
	         * @constructor
	         * @param {peers.IArgumentsResource=} [properties] Properties to set
	         */
	        function ArgumentsResource(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsResource Resource.
	         * @member {string} Resource
	         * @memberof peers.ArgumentsResource
	         * @instance
	         */
	        ArgumentsResource.prototype.Resource = "";
	
	        /**
	         * Creates a new ArgumentsResource instance using the specified properties.
	         * @function create
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {peers.IArgumentsResource=} [properties] Properties to set
	         * @returns {peers.ArgumentsResource} ArgumentsResource instance
	         */
	        ArgumentsResource.create = function create(properties) {
	            return new ArgumentsResource(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsResource message. Does not implicitly {@link peers.ArgumentsResource.verify|verify} messages.
	         * @function encode
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {peers.IArgumentsResource} message ArgumentsResource message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsResource.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Resource);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsResource message, length delimited. Does not implicitly {@link peers.ArgumentsResource.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {peers.IArgumentsResource} message ArgumentsResource message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsResource.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsResource message from the specified reader or buffer.
	         * @function decode
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {peers.ArgumentsResource} ArgumentsResource
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsResource.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.peers.ArgumentsResource();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Resource = reader.string();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsResource message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {peers.ArgumentsResource} ArgumentsResource
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsResource.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsResource message.
	         * @function verify
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsResource.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                if (!$util.isString(message.Resource))
	                    return "Resource: string expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsResource message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {peers.ArgumentsResource} ArgumentsResource
	         */
	        ArgumentsResource.fromObject = function fromObject(object) {
	            if (object instanceof $root.peers.ArgumentsResource)
	                return object;
	            var message = new $root.peers.ArgumentsResource();
	            if (object.Resource != null)
	                message.Resource = String(object.Resource);
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsResource message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof peers.ArgumentsResource
	         * @static
	         * @param {peers.ArgumentsResource} message ArgumentsResource
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsResource.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Resource = "";
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                object.Resource = message.Resource;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsResource to JSON.
	         * @function toJSON
	         * @memberof peers.ArgumentsResource
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsResource.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsResource;
	    })();
	
	    peers.ArgumentsSatisfy = (function() {
	
	        /**
	         * Properties of an ArgumentsSatisfy.
	         * @memberof peers
	         * @interface IArgumentsSatisfy
	         * @property {string|null} [Resource] ArgumentsSatisfy Resource
	         * @property {number|null} [PartNumber] ArgumentsSatisfy PartNumber
	         * @property {number|null} [PartTotal] ArgumentsSatisfy PartTotal
	         * @property {Uint8Array|null} [Content] ArgumentsSatisfy Content
	         */
	
	        /**
	         * Constructs a new ArgumentsSatisfy.
	         * @memberof peers
	         * @classdesc Represents an ArgumentsSatisfy.
	         * @implements IArgumentsSatisfy
	         * @constructor
	         * @param {peers.IArgumentsSatisfy=} [properties] Properties to set
	         */
	        function ArgumentsSatisfy(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * ArgumentsSatisfy Resource.
	         * @member {string} Resource
	         * @memberof peers.ArgumentsSatisfy
	         * @instance
	         */
	        ArgumentsSatisfy.prototype.Resource = "";
	
	        /**
	         * ArgumentsSatisfy PartNumber.
	         * @member {number} PartNumber
	         * @memberof peers.ArgumentsSatisfy
	         * @instance
	         */
	        ArgumentsSatisfy.prototype.PartNumber = 0;
	
	        /**
	         * ArgumentsSatisfy PartTotal.
	         * @member {number} PartTotal
	         * @memberof peers.ArgumentsSatisfy
	         * @instance
	         */
	        ArgumentsSatisfy.prototype.PartTotal = 0;
	
	        /**
	         * ArgumentsSatisfy Content.
	         * @member {Uint8Array} Content
	         * @memberof peers.ArgumentsSatisfy
	         * @instance
	         */
	        ArgumentsSatisfy.prototype.Content = $util.newBuffer([]);
	
	        /**
	         * Creates a new ArgumentsSatisfy instance using the specified properties.
	         * @function create
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {peers.IArgumentsSatisfy=} [properties] Properties to set
	         * @returns {peers.ArgumentsSatisfy} ArgumentsSatisfy instance
	         */
	        ArgumentsSatisfy.create = function create(properties) {
	            return new ArgumentsSatisfy(properties);
	        };
	
	        /**
	         * Encodes the specified ArgumentsSatisfy message. Does not implicitly {@link peers.ArgumentsSatisfy.verify|verify} messages.
	         * @function encode
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {peers.IArgumentsSatisfy} message ArgumentsSatisfy message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSatisfy.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Resource);
	            if (message.PartNumber != null && message.hasOwnProperty("PartNumber"))
	                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.PartNumber);
	            if (message.PartTotal != null && message.hasOwnProperty("PartTotal"))
	                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.PartTotal);
	            if (message.Content != null && message.hasOwnProperty("Content"))
	                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.Content);
	            return writer;
	        };
	
	        /**
	         * Encodes the specified ArgumentsSatisfy message, length delimited. Does not implicitly {@link peers.ArgumentsSatisfy.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {peers.IArgumentsSatisfy} message ArgumentsSatisfy message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        ArgumentsSatisfy.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes an ArgumentsSatisfy message from the specified reader or buffer.
	         * @function decode
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {peers.ArgumentsSatisfy} ArgumentsSatisfy
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSatisfy.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.peers.ArgumentsSatisfy();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Resource = reader.string();
	                    break;
	                case 2:
	                    message.PartNumber = reader.uint32();
	                    break;
	                case 3:
	                    message.PartTotal = reader.uint32();
	                    break;
	                case 4:
	                    message.Content = reader.bytes();
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes an ArgumentsSatisfy message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {peers.ArgumentsSatisfy} ArgumentsSatisfy
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        ArgumentsSatisfy.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies an ArgumentsSatisfy message.
	         * @function verify
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        ArgumentsSatisfy.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                if (!$util.isString(message.Resource))
	                    return "Resource: string expected";
	            if (message.PartNumber != null && message.hasOwnProperty("PartNumber"))
	                if (!$util.isInteger(message.PartNumber))
	                    return "PartNumber: integer expected";
	            if (message.PartTotal != null && message.hasOwnProperty("PartTotal"))
	                if (!$util.isInteger(message.PartTotal))
	                    return "PartTotal: integer expected";
	            if (message.Content != null && message.hasOwnProperty("Content"))
	                if (!(message.Content && typeof message.Content.length === "number" || $util.isString(message.Content)))
	                    return "Content: buffer expected";
	            return null;
	        };
	
	        /**
	         * Creates an ArgumentsSatisfy message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {peers.ArgumentsSatisfy} ArgumentsSatisfy
	         */
	        ArgumentsSatisfy.fromObject = function fromObject(object) {
	            if (object instanceof $root.peers.ArgumentsSatisfy)
	                return object;
	            var message = new $root.peers.ArgumentsSatisfy();
	            if (object.Resource != null)
	                message.Resource = String(object.Resource);
	            if (object.PartNumber != null)
	                message.PartNumber = object.PartNumber >>> 0;
	            if (object.PartTotal != null)
	                message.PartTotal = object.PartTotal >>> 0;
	            if (object.Content != null)
	                if (typeof object.Content === "string")
	                    $util.base64.decode(object.Content, message.Content = $util.newBuffer($util.base64.length(object.Content)), 0);
	                else if (object.Content.length)
	                    message.Content = object.Content;
	            return message;
	        };
	
	        /**
	         * Creates a plain object from an ArgumentsSatisfy message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof peers.ArgumentsSatisfy
	         * @static
	         * @param {peers.ArgumentsSatisfy} message ArgumentsSatisfy
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        ArgumentsSatisfy.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults) {
	                object.Resource = "";
	                object.PartNumber = 0;
	                object.PartTotal = 0;
	                object.Content = options.bytes === String ? "" : [];
	            }
	            if (message.Resource != null && message.hasOwnProperty("Resource"))
	                object.Resource = message.Resource;
	            if (message.PartNumber != null && message.hasOwnProperty("PartNumber"))
	                object.PartNumber = message.PartNumber;
	            if (message.PartTotal != null && message.hasOwnProperty("PartTotal"))
	                object.PartTotal = message.PartTotal;
	            if (message.Content != null && message.hasOwnProperty("Content"))
	                object.Content = options.bytes === String ? $util.base64.encode(message.Content, 0, message.Content.length) : options.bytes === Array ? Array.prototype.slice.call(message.Content) : message.Content;
	            return object;
	        };
	
	        /**
	         * Converts this ArgumentsSatisfy to JSON.
	         * @function toJSON
	         * @memberof peers.ArgumentsSatisfy
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        ArgumentsSatisfy.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return ArgumentsSatisfy;
	    })();
	
	    /**
	     * MessageType enum.
	     * @name peers.MessageType
	     * @enum {string}
	     * @property {number} MessageTypeUnknown=0 MessageTypeUnknown value
	     * @property {number} MessageTypePing=256 MessageTypePing value
	     * @property {number} MessageTypePong=257 MessageTypePong value
	     * @property {number} MessageTypeHave=512 MessageTypeHave value
	     * @property {number} MessageTypeUpdate=513 MessageTypeUpdate value
	     * @property {number} MessageTypeDownloading=514 MessageTypeDownloading value
	     * @property {number} MessageTypeBusy=515 MessageTypeBusy value
	     * @property {number} MessageTypeRequestonHave=768 MessageTypeRequestonHave value
	     * @property {number} MessageTypeSatisfy=769 MessageTypeSatisfy value
	     */
	    peers.MessageType = (function() {
	        var valuesById = {}, values = Object.create(valuesById);
	        values[valuesById[0] = "MessageTypeUnknown"] = 0;
	        values[valuesById[256] = "MessageTypePing"] = 256;
	        values[valuesById[257] = "MessageTypePong"] = 257;
	        values[valuesById[512] = "MessageTypeHave"] = 512;
	        values[valuesById[513] = "MessageTypeUpdate"] = 513;
	        values[valuesById[514] = "MessageTypeDownloading"] = 514;
	        values[valuesById[515] = "MessageTypeBusy"] = 515;
	        values[valuesById[768] = "MessageTypeRequestonHave"] = 768;
	        values[valuesById[769] = "MessageTypeSatisfy"] = 769;
	        return values;
	    })();
	
	    peers.Message = (function() {
	
	        /**
	         * Properties of a Message.
	         * @memberof peers
	         * @interface IMessage
	         * @property {peers.MessageType|null} [Type] Message Type
	         * @property {peers.IArgumentsPingPong|null} [ArgumentsPingPong] Message ArgumentsPingPong
	         * @property {peers.IArgumentsHave|null} [ArgumentsHave] Message ArgumentsHave
	         * @property {peers.IArgumentsResource|null} [ArgumentsResource] Message ArgumentsResource
	         * @property {peers.IArgumentsSatisfy|null} [ArgumentsSatisfy] Message ArgumentsSatisfy
	         */
	
	        /**
	         * Constructs a new Message.
	         * @memberof peers
	         * @classdesc Represents a Message.
	         * @implements IMessage
	         * @constructor
	         * @param {peers.IMessage=} [properties] Properties to set
	         */
	        function Message(properties) {
	            if (properties)
	                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
	                    if (properties[keys[i]] != null)
	                        this[keys[i]] = properties[keys[i]];
	        }
	
	        /**
	         * Message Type.
	         * @member {peers.MessageType} Type
	         * @memberof peers.Message
	         * @instance
	         */
	        Message.prototype.Type = 0;
	
	        /**
	         * Message ArgumentsPingPong.
	         * @member {peers.IArgumentsPingPong|null|undefined} ArgumentsPingPong
	         * @memberof peers.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsPingPong = null;
	
	        /**
	         * Message ArgumentsHave.
	         * @member {peers.IArgumentsHave|null|undefined} ArgumentsHave
	         * @memberof peers.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsHave = null;
	
	        /**
	         * Message ArgumentsResource.
	         * @member {peers.IArgumentsResource|null|undefined} ArgumentsResource
	         * @memberof peers.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsResource = null;
	
	        /**
	         * Message ArgumentsSatisfy.
	         * @member {peers.IArgumentsSatisfy|null|undefined} ArgumentsSatisfy
	         * @memberof peers.Message
	         * @instance
	         */
	        Message.prototype.ArgumentsSatisfy = null;
	
	        // OneOf field names bound to virtual getters and setters
	        var $oneOfFields;
	
	        /**
	         * Message Arguments.
	         * @member {"ArgumentsPingPong"|"ArgumentsHave"|"ArgumentsResource"|"ArgumentsSatisfy"|undefined} Arguments
	         * @memberof peers.Message
	         * @instance
	         */
	        Object.defineProperty(Message.prototype, "Arguments", {
	            get: $util.oneOfGetter($oneOfFields = ["ArgumentsPingPong", "ArgumentsHave", "ArgumentsResource", "ArgumentsSatisfy"]),
	            set: $util.oneOfSetter($oneOfFields)
	        });
	
	        /**
	         * Creates a new Message instance using the specified properties.
	         * @function create
	         * @memberof peers.Message
	         * @static
	         * @param {peers.IMessage=} [properties] Properties to set
	         * @returns {peers.Message} Message instance
	         */
	        Message.create = function create(properties) {
	            return new Message(properties);
	        };
	
	        /**
	         * Encodes the specified Message message. Does not implicitly {@link peers.Message.verify|verify} messages.
	         * @function encode
	         * @memberof peers.Message
	         * @static
	         * @param {peers.IMessage} message Message message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        Message.encode = function encode(message, writer) {
	            if (!writer)
	                writer = $Writer.create();
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
	            if (message.ArgumentsPingPong != null && message.hasOwnProperty("ArgumentsPingPong"))
	                $root.peers.ArgumentsPingPong.encode(message.ArgumentsPingPong, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
	            if (message.ArgumentsHave != null && message.hasOwnProperty("ArgumentsHave"))
	                $root.peers.ArgumentsHave.encode(message.ArgumentsHave, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
	            if (message.ArgumentsResource != null && message.hasOwnProperty("ArgumentsResource"))
	                $root.peers.ArgumentsResource.encode(message.ArgumentsResource, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
	            if (message.ArgumentsSatisfy != null && message.hasOwnProperty("ArgumentsSatisfy"))
	                $root.peers.ArgumentsSatisfy.encode(message.ArgumentsSatisfy, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
	            return writer;
	        };
	
	        /**
	         * Encodes the specified Message message, length delimited. Does not implicitly {@link peers.Message.verify|verify} messages.
	         * @function encodeDelimited
	         * @memberof peers.Message
	         * @static
	         * @param {peers.IMessage} message Message message or plain object to encode
	         * @param {$protobuf.Writer} [writer] Writer to encode to
	         * @returns {$protobuf.Writer} Writer
	         */
	        Message.encodeDelimited = function encodeDelimited(message, writer) {
	            return this.encode(message, writer).ldelim();
	        };
	
	        /**
	         * Decodes a Message message from the specified reader or buffer.
	         * @function decode
	         * @memberof peers.Message
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @param {number} [length] Message length if known beforehand
	         * @returns {peers.Message} Message
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        Message.decode = function decode(reader, length) {
	            if (!(reader instanceof $Reader))
	                reader = $Reader.create(reader);
	            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.peers.Message();
	            while (reader.pos < end) {
	                var tag = reader.uint32();
	                switch (tag >>> 3) {
	                case 1:
	                    message.Type = reader.int32();
	                    break;
	                case 10:
	                    message.ArgumentsPingPong = $root.peers.ArgumentsPingPong.decode(reader, reader.uint32());
	                    break;
	                case 11:
	                    message.ArgumentsHave = $root.peers.ArgumentsHave.decode(reader, reader.uint32());
	                    break;
	                case 12:
	                    message.ArgumentsResource = $root.peers.ArgumentsResource.decode(reader, reader.uint32());
	                    break;
	                case 13:
	                    message.ArgumentsSatisfy = $root.peers.ArgumentsSatisfy.decode(reader, reader.uint32());
	                    break;
	                default:
	                    reader.skipType(tag & 7);
	                    break;
	                }
	            }
	            return message;
	        };
	
	        /**
	         * Decodes a Message message from the specified reader or buffer, length delimited.
	         * @function decodeDelimited
	         * @memberof peers.Message
	         * @static
	         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
	         * @returns {peers.Message} Message
	         * @throws {Error} If the payload is not a reader or valid buffer
	         * @throws {$protobuf.util.ProtocolError} If required fields are missing
	         */
	        Message.decodeDelimited = function decodeDelimited(reader) {
	            if (!(reader instanceof $Reader))
	                reader = new $Reader(reader);
	            return this.decode(reader, reader.uint32());
	        };
	
	        /**
	         * Verifies a Message message.
	         * @function verify
	         * @memberof peers.Message
	         * @static
	         * @param {Object.<string,*>} message Plain object to verify
	         * @returns {string|null} `null` if valid, otherwise the reason why it is not
	         */
	        Message.verify = function verify(message) {
	            if (typeof message !== "object" || message === null)
	                return "object expected";
	            var properties = {};
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                switch (message.Type) {
	                default:
	                    return "Type: enum value expected";
	                case 0:
	                case 256:
	                case 257:
	                case 512:
	                case 513:
	                case 514:
	                case 515:
	                case 768:
	                case 769:
	                    break;
	                }
	            if (message.ArgumentsPingPong != null && message.hasOwnProperty("ArgumentsPingPong")) {
	                properties.Arguments = 1;
	                {
	                    var error = $root.peers.ArgumentsPingPong.verify(message.ArgumentsPingPong);
	                    if (error)
	                        return "ArgumentsPingPong." + error;
	                }
	            }
	            if (message.ArgumentsHave != null && message.hasOwnProperty("ArgumentsHave")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.peers.ArgumentsHave.verify(message.ArgumentsHave);
	                    if (error)
	                        return "ArgumentsHave." + error;
	                }
	            }
	            if (message.ArgumentsResource != null && message.hasOwnProperty("ArgumentsResource")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.peers.ArgumentsResource.verify(message.ArgumentsResource);
	                    if (error)
	                        return "ArgumentsResource." + error;
	                }
	            }
	            if (message.ArgumentsSatisfy != null && message.hasOwnProperty("ArgumentsSatisfy")) {
	                if (properties.Arguments === 1)
	                    return "Arguments: multiple values";
	                properties.Arguments = 1;
	                {
	                    var error = $root.peers.ArgumentsSatisfy.verify(message.ArgumentsSatisfy);
	                    if (error)
	                        return "ArgumentsSatisfy." + error;
	                }
	            }
	            return null;
	        };
	
	        /**
	         * Creates a Message message from a plain object. Also converts values to their respective internal types.
	         * @function fromObject
	         * @memberof peers.Message
	         * @static
	         * @param {Object.<string,*>} object Plain object
	         * @returns {peers.Message} Message
	         */
	        Message.fromObject = function fromObject(object) {
	            if (object instanceof $root.peers.Message)
	                return object;
	            var message = new $root.peers.Message();
	            switch (object.Type) {
	            case "MessageTypeUnknown":
	            case 0:
	                message.Type = 0;
	                break;
	            case "MessageTypePing":
	            case 256:
	                message.Type = 256;
	                break;
	            case "MessageTypePong":
	            case 257:
	                message.Type = 257;
	                break;
	            case "MessageTypeHave":
	            case 512:
	                message.Type = 512;
	                break;
	            case "MessageTypeUpdate":
	            case 513:
	                message.Type = 513;
	                break;
	            case "MessageTypeDownloading":
	            case 514:
	                message.Type = 514;
	                break;
	            case "MessageTypeBusy":
	            case 515:
	                message.Type = 515;
	                break;
	            case "MessageTypeRequestonHave":
	            case 768:
	                message.Type = 768;
	                break;
	            case "MessageTypeSatisfy":
	            case 769:
	                message.Type = 769;
	                break;
	            }
	            if (object.ArgumentsPingPong != null) {
	                if (typeof object.ArgumentsPingPong !== "object")
	                    throw TypeError(".peers.Message.ArgumentsPingPong: object expected");
	                message.ArgumentsPingPong = $root.peers.ArgumentsPingPong.fromObject(object.ArgumentsPingPong);
	            }
	            if (object.ArgumentsHave != null) {
	                if (typeof object.ArgumentsHave !== "object")
	                    throw TypeError(".peers.Message.ArgumentsHave: object expected");
	                message.ArgumentsHave = $root.peers.ArgumentsHave.fromObject(object.ArgumentsHave);
	            }
	            if (object.ArgumentsResource != null) {
	                if (typeof object.ArgumentsResource !== "object")
	                    throw TypeError(".peers.Message.ArgumentsResource: object expected");
	                message.ArgumentsResource = $root.peers.ArgumentsResource.fromObject(object.ArgumentsResource);
	            }
	            if (object.ArgumentsSatisfy != null) {
	                if (typeof object.ArgumentsSatisfy !== "object")
	                    throw TypeError(".peers.Message.ArgumentsSatisfy: object expected");
	                message.ArgumentsSatisfy = $root.peers.ArgumentsSatisfy.fromObject(object.ArgumentsSatisfy);
	            }
	            return message;
	        };
	
	        /**
	         * Creates a plain object from a Message message. Also converts values to other types if specified.
	         * @function toObject
	         * @memberof peers.Message
	         * @static
	         * @param {peers.Message} message Message
	         * @param {$protobuf.IConversionOptions} [options] Conversion options
	         * @returns {Object.<string,*>} Plain object
	         */
	        Message.toObject = function toObject(message, options) {
	            if (!options)
	                options = {};
	            var object = {};
	            if (options.defaults)
	                object.Type = options.enums === String ? "MessageTypeUnknown" : 0;
	            if (message.Type != null && message.hasOwnProperty("Type"))
	                object.Type = options.enums === String ? $root.peers.MessageType[message.Type] : message.Type;
	            if (message.ArgumentsPingPong != null && message.hasOwnProperty("ArgumentsPingPong")) {
	                object.ArgumentsPingPong = $root.peers.ArgumentsPingPong.toObject(message.ArgumentsPingPong, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsPingPong";
	            }
	            if (message.ArgumentsHave != null && message.hasOwnProperty("ArgumentsHave")) {
	                object.ArgumentsHave = $root.peers.ArgumentsHave.toObject(message.ArgumentsHave, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsHave";
	            }
	            if (message.ArgumentsResource != null && message.hasOwnProperty("ArgumentsResource")) {
	                object.ArgumentsResource = $root.peers.ArgumentsResource.toObject(message.ArgumentsResource, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsResource";
	            }
	            if (message.ArgumentsSatisfy != null && message.hasOwnProperty("ArgumentsSatisfy")) {
	                object.ArgumentsSatisfy = $root.peers.ArgumentsSatisfy.toObject(message.ArgumentsSatisfy, options);
	                if (options.oneofs)
	                    object.Arguments = "ArgumentsSatisfy";
	            }
	            return object;
	        };
	
	        /**
	         * Converts this Message to JSON.
	         * @function toJSON
	         * @memberof peers.Message
	         * @instance
	         * @returns {Object.<string,*>} JSON object
	         */
	        Message.prototype.toJSON = function toJSON() {
	            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
	        };
	
	        return Message;
	    })();
	
	    return peers;
	})();
	
	module.exports = $root;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(75);
	var v4 = __webpack_require__(78);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(76);
	var bytesToUuid = __webpack_require__(77);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(76);
	var bytesToUuid = __webpack_require__(77);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var consts_1 = __webpack_require__(24);
	var log_1 = __webpack_require__(65);
	var platform = __webpack_require__(80);
	var QueryString = __webpack_require__(21);
	var uuid_1 = __webpack_require__(74);
	var StatsPlayerState;
	(function (StatsPlayerState) {
	    StatsPlayerState[StatsPlayerState["PLAYING"] = 1] = "PLAYING";
	    StatsPlayerState[StatsPlayerState["IDLE"] = 2] = "IDLE";
	    StatsPlayerState[StatsPlayerState["PLAY_BUFFERING"] = 3] = "PLAY_BUFFERING";
	    StatsPlayerState[StatsPlayerState["BUFFERING"] = 4] = "BUFFERING";
	    StatsPlayerState[StatsPlayerState["PAUSED"] = 5] = "PAUSED";
	})(StatsPlayerState = exports.StatsPlayerState || (exports.StatsPlayerState = {}));
	var Stats = (function () {
	    function Stats(manager) {
	        this.state = StatsPlayerState.IDLE;
	        this.rebuffers = 0;
	        this.rebufferingTime = 0;
	        this.playingTime = 0;
	        this.v2vEnabled = false;
	        this.swarmSize = 0;
	        this.fluctuation = 0;
	        this.fluctuationLastSend = 0;
	        this.registered_value = 0;
	        this.registered_value_lastsend = 0;
	        this.cdnCount = 0;
	        this.cdnCountLastSend = 0;
	        this.v2vCount = 0;
	        this.v2vCountLastSend = 0;
	        this.sentCount = 0;
	        this.occupiedSlots = 0;
	        this.isAudio = false;
	        this.isOnDemand = false;
	        this.chunksLength = 0;
	        this.playingQuality = 0;
	        this.id = uuid_1.v4();
	        this.manager = manager;
	        this.getOS();
	        this.getBrowser();
	        this.bindManagerEvents();
	    }
	    Stats.prototype.start = function () {
	        var _this = this;
	        this.stop();
	        this.sendTimer = window.setInterval(function () { _this.sendMetrics(); }, consts_1.STATS_INTERVAL);
	    };
	    Stats.prototype.getinittime = function () {
	        return Date.now();
	    };
	    Stats.prototype.stop = function () {
	        if (this.sendTimer) {
	            window.clearInterval(this.sendTimer);
	        }
	    };
	    Stats.prototype.reset = function () {
	        this.content =
	            this.protocol =
	                this.bufferLength =
	                    this.lastRebufferingTime =
	                        this.playingTimeTimer =
	                            this.startTime = undefined;
	        this.rebuffers =
	            this.rebufferingTime =
	                this.playingTime =
	                    this.swarmSize =
	                        this.fluctuation =
	                            this.fluctuationLastSend =
	                                this.registered_value =
	                                    this.registered_value_lastsend =
	                                        this.playingQuality =
	                                            this.cdnCount =
	                                                this.cdnCountLastSend =
	                                                    this.v2vCount =
	                                                        this.v2vCountLastSend =
	                                                            this.sentCount =
	                                                                this.occupiedSlots =
	                                                                    this.chunksLength = 0;
	        this.isAudio =
	            this.isOnDemand =
	                this.v2vEnabled = false;
	        this.state = StatsPlayerState.IDLE;
	        return;
	    };
	    Stats.prototype.setOrigin = function (origin) {
	        this.origin = origin;
	    };
	    Stats.prototype.setContent = function (content) {
	        this.content = content;
	    };
	    Stats.prototype.setProtocol = function (protocol) {
	        this.protocol = protocol;
	    };
	    Stats.prototype.setBufferLength = function (bufferLength) {
	        this.bufferLength = bufferLength;
	    };
	    Stats.prototype.setState = function (state) {
	        var _this = this;
	        if ((state === StatsPlayerState.BUFFERING) &&
	            (this.state !== StatsPlayerState.BUFFERING)) {
	            this.lastRebufferingTime = Date.now();
	        }
	        else if ((state !== StatsPlayerState.BUFFERING) &&
	            (this.state === StatsPlayerState.BUFFERING) &&
	            (typeof this.lastRebufferingTime === 'number')) {
	            this.rebufferingTime += ((Date.now() - this.lastRebufferingTime) / 1000);
	            this.lastRebufferingTime = undefined;
	        }
	        if ((state === StatsPlayerState.BUFFERING) ||
	            (state === StatsPlayerState.PLAYING)) {
	            if (this.playingTimeTimer !== undefined) {
	                window.clearInterval(this.playingTimeTimer);
	            }
	            this.playingTimeTimer = window.setInterval(function () { _this.playingTime = _this.playingTime + 1; }, 1000);
	        }
	        else {
	            if (this.playingTimeTimer !== undefined) {
	                window.clearInterval(this.playingTimeTimer);
	            }
	        }
	        this.state = state;
	    };
	    Stats.prototype.setStartTime = function (startTime) {
	        this.startTime = startTime;
	    };
	    Stats.prototype.incRebuffer = function () {
	        this.rebuffers = this.rebuffers + 1;
	    };
	    Stats.prototype.setAudio = function () {
	        this.isAudio = true;
	    };
	    Stats.prototype.setVideo = function () {
	        this.isAudio = false;
	    };
	    Stats.prototype.setOD = function () {
	        this.isOnDemand = true;
	    };
	    Stats.prototype.setLive = function () {
	        this.isOnDemand = false;
	    };
	    Stats.prototype.setISP = function (isp) {
	        this.isp = isp;
	    };
	    Stats.prototype.getOS = function () {
	        switch (platform.os.family) {
	            case 'Windows':
	            case 'Windows XP':
	                this.os = this.getOSWindows();
	                break;
	            case 'OS X':
	                this.os = this.getOSOSX();
	                break;
	            case 'Linux':
	            case 'Ubuntu':
	            case 'Debian':
	            case 'Fedora':
	            case 'Red Hat':
	            case 'SuSE':
	                this.os = this.getOSLinux();
	                break;
	            case 'Android':
	                this.os = this.getOSAndroid();
	                break;
	            case 'iOS':
	                this.os = this.getOSiOS();
	                break;
	            case 'Windows Phone':
	                this.os = this.getOSWp();
	                break;
	            default:
	                if ((/windows/i).test(platform.os.family)) {
	                    this.os = this.getOSWindows();
	                }
	                this.os = 'NA';
	        }
	    };
	    Stats.prototype.getOSWindows = function () {
	        switch (platform.os.version) {
	            case '10.0':
	            case '10':
	                return 'w_10';
	            default:
	        }
	        switch (platform.os.family) {
	            case 'Windows NT 10.0':
	            case 'Windows NT 10':
	            case 'Windows NT 6.3':
	                return 'w_10';
	            case 'Windows NT 6.2':
	                return 'w_8';
	            case 'Windows NT 6.1':
	                return 'w_7';
	            case 'Windows XP':
	                return 'w_xp';
	            default:
	                return 'w_old';
	        }
	    };
	    Stats.prototype.getOSOSX = function () {
	        if ((typeof platform.os.version === 'string') && platform.os.version.length) {
	            return "m_" + platform.os.version;
	        }
	        return 'm_old';
	    };
	    Stats.prototype.getOSLinux = function () {
	        var distro = platform.os.family;
	        if (distro === 'Linux') {
	            return 'l_other';
	        }
	        distro = distro.substr(0, 49).toLowerCase();
	        return "l_" + distro;
	    };
	    Stats.prototype.getOSAndroid = function () {
	        if ((typeof platform.os.version === 'string') && platform.os.version.length) {
	            return "and_" + platform.os.version;
	        }
	        return 'and_old';
	    };
	    Stats.prototype.getOSiOS = function () {
	        if ((typeof platform.os.version === 'string') && platform.os.version.length) {
	            return "ios_" + platform.os.version;
	        }
	        return 'ios_old';
	    };
	    Stats.prototype.getOSWp = function () {
	        if ((typeof platform.os.version === 'string') && platform.os.version.length) {
	            return "wp_" + platform.os.version;
	        }
	        return 'wp_old';
	    };
	    Stats.prototype.getBrowser = function () {
	        var short;
	        switch (platform.name) {
	            case 'Chrome':
	                short = 'chr';
	                break;
	            case 'Firefox':
	            case 'Firefox for iOS':
	                short = 'ff';
	                break;
	            case 'IE':
	                short = 'ie';
	                break;
	            case 'Microsoft Edge':
	                short = 'e';
	                break;
	            case 'Safari':
	                short = 's';
	                break;
	            case 'Opera Mini':
	            case 'Opera':
	                short = 'o';
	                break;
	            default:
	                this.browser = 'na';
	                return;
	        }
	        var res = /^(\d+).*/.exec(platform.version);
	        if (res === null) {
	            this.browser = short + "_na";
	        }
	        this.browser = short + "_" + res[1];
	    };
	    Stats.prototype.bindManagerEvents = function () {
	        var _this = this;
	        this.manager.on('registered', function () { _this.v2vEnabled = true; });
	        this.manager.on('disconnected', function () {
	            _this.v2vEnabled = false;
	            _this.registered_value = _this.registered_value + 1;
	        });
	        this.manager.on('unregistered', function () {
	            _this.v2vEnabled = false;
	        });
	        this.manager.on('swarmSize', function (size) { _this.swarmSize = size; });
	        this.manager.on('v2vSent', function () { _this.sentCount = _this.sentCount + 1; });
	        this.manager.on('cdnReceived', function (contentLength) {
	            _this.cdnCount = _this.cdnCount + 1;
	            _this.chunksLength = _this.chunksLength + contentLength;
	        });
	        this.manager.on('v2vReceived', function (contentLength) {
	            _this.v2vCount = _this.v2vCount + 1;
	            _this.chunksLength = _this.chunksLength + contentLength;
	        });
	        this.manager.on('fluctuation', function () { _this.fluctuation = _this.fluctuation + 1; });
	        this.manager.on('playingQuality', function (playingQuality) { _this.playingQuality = playingQuality; });
	    };
	    Stats.prototype.sendMetrics = function () {
	        var _this = this;
	        var params = {
	            id: this.id,
	            IDContenu: this.content,
	            metrics: this.getMetricsString(),
	            os: this.os,
	            b: this.browser,
	            r: (this.isAudio) ? 't' : 'f',
	            vod: (this.isOnDemand) ? 't' : 'f',
	        };
	        if (this.origin !== undefined) {
	            params.or = this.origin;
	        }
	        if (this.isp !== undefined) {
	            params.mnc = this.isp;
	        }
	        params.nf = this.getfluctuation();
	        params.rv = this.getregisterValue();
	        params.pq = this.getBandwidth();
	        fetch(consts_1.STATS_URL + "/?" + QueryString.stringify(params))
	            .catch(function (err) {
	            log_1.logger().warn("Could not send statistics: " + err);
	        })
	            .then(function () {
	            _this.cdnCountLastSend = _this.cdnCount;
	            _this.v2vCountLastSend = _this.v2vCount;
	            _this.fluctuation = 0;
	            _this.sentCount = 0;
	            _this.registered_value = 0;
	        });
	    };
	    Stats.prototype.getMetricsString = function () {
	        var parts = [
	            this.protocol,
	            (this.v2vEnabled) ? 'on' : 'off',
	            "" + this.sentCount,
	            "" + this.swarmSize,
	            this.getV2VRatio(),
	            "" + this.swarmSize,
	            this.roundValue(this.bufferLength),
	            this.getState(),
	            this.roundValue((this.chunksLength / (consts_1.STATS_INTERVAL / 1000)) / 1000),
	            this.roundValue(this.startTime),
	            "" + this.playingTime,
	            this.roundValue(this.rebufferingTime),
	            "" + this.rebuffers,
	            this.getAudioAverageLength(),
	            this.getVideoAverageLength(),
	            this.getChunkCountValue(),
	        ];
	        return parts.join('~');
	    };
	    Stats.prototype.getV2VRatio = function () {
	        if ((this.v2vCount === 0) && (this.cdnCount === 0)) {
	            return '0';
	        }
	        return Math.round(this.v2vCount / (this.v2vCount + this.cdnCount)).toString();
	    };
	    Stats.prototype.getState = function () {
	        switch (this.state) {
	            case StatsPlayerState.PLAYING:
	            case StatsPlayerState.IDLE:
	            case StatsPlayerState.PLAY_BUFFERING:
	            case StatsPlayerState.BUFFERING:
	            case StatsPlayerState.PAUSED:
	                return StatsPlayerState[this.state];
	            default:
	                return 'IDLE';
	        }
	    };
	    Stats.prototype.roundValue = function (value) {
	        return (Math.round(value * 1000) / 1000).toString();
	    };
	    Stats.prototype.getAudioAverageLength = function () {
	        if (!this.isAudio) {
	            return '0';
	        }
	        return Math.round(this.chunksLength / (this.v2vCount + this.cdnCount)).toString();
	    };
	    Stats.prototype.getVideoAverageLength = function () {
	        if (this.isAudio) {
	            return '0';
	        }
	        return Math.round(this.chunksLength / (this.v2vCount + this.cdnCount)).toString();
	    };
	    Stats.prototype.getChunkCountValue = function () {
	        var compose = new Uint8Array(4);
	        var v2v = this.v2vCount - this.v2vCountLastSend;
	        var cdn = this.cdnCount - this.cdnCountLastSend;
	        if (this.isAudio) {
	            compose[0] = Math.min(cdn, 256);
	            compose[1] = Math.min(v2v, 256);
	            compose[2] = 0;
	            compose[3] = 0;
	        }
	        else {
	            compose[0] = 0;
	            compose[1] = 0;
	            compose[2] = Math.min(cdn, 256);
	            compose[3] = Math.min(v2v, 256);
	        }
	        return (new DataView(compose.buffer)).getInt32(0, false).toString();
	    };
	    Stats.prototype.getfluctuation = function () {
	        return Math.round(this.fluctuation).toString();
	    };
	    Stats.prototype.getregisterValue = function () {
	        return Math.round(this.registered_value).toString();
	    };
	    Stats.prototype.getBandwidth = function () {
	        return Math.round(this.playingQuality).toString();
	    };
	    return Stats;
	}());
	exports.Stats = Stats;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js <https://mths.be/platform>
	 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
	 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
	 * Available under MIT license <https://mths.be/mit>
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  'Server 2008 R2 / 7',
	      '6.0':  'Server 2008 / Vista',
	      '5.2':  'Server 2003 / XP 64-bit',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Electron',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'Waterfox',
	      'WebPositive',
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chrome',
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
	      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
	      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
	      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
	      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation Vita',
	      'PlayStation',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Tizen',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Add Chrome version to description for Electron.
	    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
	      description.push('Chromium ' + data);
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$))',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11 identifying as other browsers.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
	          os || (os = data[0].os || null);
	          try {
	            data[1] = context.require('ringo/engine').version;
	            version = data[1].join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if (data[0].global.system == context.system) {
	              name = 'Narwhal';
	            }
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          if (typeof data.versions == 'object') {
	            if (typeof data.versions.electron == 'string') {
	              description.push('Node ' + data.versions.node);
	              name = 'Electron';
	              version = data.versions.electron;
	            } else if (typeof data.versions.nw == 'string') {
	              description.push('Chromium ' + version, 'Node ' + data.versions.node);
	              name = 'NW.js';
	              version = data.versions.nw;
	            }
	          } else {
	            name = 'Node.js';
	            arch = data.arch;
	            os = data.platform;
	            version = /[\d.]+/.exec(data.version)
	            version = version ? version[0] : 'unknown';
	          }
	        }
	        else if (rhino) {
	          name = 'Rhino';
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      // Detect IE 11 masking as other browsers.
	      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
	        description.push('masking as ' + name + ' ' + version);
	        name = 'IE';
	        version = '11.0';
	        layout = ['Trident'];
	        os = 'Windows';
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      if (product == 'Xbox 360') {
	        os = null;
	      }
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures) {
	      try {
	        if (context.external === null) {
	          description.unshift('platform preview');
	        }
	      } catch(e) {
	        description.unshift('embedded');
	      }
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * The list of common layout engines include:
	     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * The list of manufacturers include:
	     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
	     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
	     * "Nokia", "Samsung" and "Sony"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * The list of common browser names include:
	     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
	     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
	     * "Opera Mini" and "Opera"
	     *
	     * Mobile versions of some browsers have "Mobile" appended to their name:
	     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * The list of common products include:
	     *
	     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
	     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
	       * "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(81)(module), (function() { return this; }())))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = __webpack_require__(24);
	var Storage = (function () {
	    function Storage() {
	        this.storage = new Set();
	    }
	    Storage.prototype.addResource = function (url, content) {
	        url = url.split('?')[0].replace(/(hdn).*\//g, '');
	        if (this.hasResource(url)) {
	            return false;
	        }
	        if (this.storage.size >= Constants.STORAGE_SIZE) {
	            this.removeOldest();
	        }
	        this.storage.add([url, content]);
	        return true;
	    };
	    Storage.prototype.hasResource = function (url) {
	        return (this.getResource(url) !== null);
	    };
	    Storage.prototype.getResource = function (url) {
	        for (var _i = 0, _a = Array.from(this.storage); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            if (entry[0] === url) {
	                return entry[1];
	            }
	        }
	        return null;
	    };
	    Storage.prototype.getUpdatedResource = function () {
	        var a = '';
	        for (var _i = 0, _a = Array.from(this.storage.values()); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            a = (entry[0]);
	        }
	        return a;
	    };
	    Storage.prototype.removeOldest = function () {
	        if (this.storage.size === 0) {
	            return;
	        }
	        this.storage.delete(this.storage.values().next().value);
	    };
	    return Storage;
	}());
	exports.Storage = Storage;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9pc2hhbmkvdGhlc2lzL3NyYy9TdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsb0NBQXNDO0FBTXRDO0lBWUU7UUFDRSxJQUFJLENBQUMsT0FBTyxHQUFHLElBQUksR0FBRyxFQUFFLENBQUM7SUFDM0IsQ0FBQztJQU9NLDZCQUFXLEdBQWxCLFVBQW1CLEdBQVcsRUFBRSxPQUFtQjtRQUNqRCxHQUFHLEdBQUcsR0FBRyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsWUFBWSxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBRWxELElBQUksSUFBSSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsRUFBRTtZQUN6QixPQUFPLEtBQUssQ0FBQztTQUNkO1FBQ0QsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksSUFBSSxTQUFTLENBQUMsWUFBWSxFQUFFO1lBQy9DLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQztTQUNyQjtRQUNELElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUM7UUFDakMsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBS00sNkJBQVcsR0FBbEIsVUFBbUIsR0FBVztRQUM1QixPQUFPLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsS0FBSyxJQUFJLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBTU0sNkJBQVcsR0FBbEIsVUFBbUIsR0FBVztRQUM1QixLQUFvQixVQUF3QixFQUF4QixLQUFBLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxFQUF4QixjQUF3QixFQUF4QixJQUF3QixFQUFFO1lBQXpDLElBQU0sS0FBSyxTQUFBO1lBQ2QsSUFBSSxLQUFLLENBQUMsQ0FBQyxDQUFDLEtBQUssR0FBRyxFQUFFO2dCQUNwQixPQUFPLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQzthQUNqQjtTQUNGO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDO0lBQ00sb0NBQWtCLEdBQXpCO1FBQ0MsSUFBSSxDQUFDLEdBQVcsRUFBRSxDQUFDO1FBQ25CLEtBQW9CLFVBQWlDLEVBQWpDLEtBQUEsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQWpDLGNBQWlDLEVBQWpDLElBQWlDLEVBQUU7WUFBbEQsSUFBTSxLQUFLLFNBQUE7WUFDYixDQUFDLEdBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUNsQjtRQUNELE9BQU8sQ0FBQyxDQUFDO0lBQ1gsQ0FBQztJQUtRLDhCQUFZLEdBQXBCO1FBQ0UsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksS0FBSyxDQUFDLEVBQUU7WUFDM0IsT0FBTztTQUNSO1FBQ0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxRCxDQUFDO0lBQ0gsY0FBQztBQUFELENBdEVBLEFBc0VDLElBQUE7QUF0RVksMEJBQU8iLCJmaWxlIjoiU3RvcmFnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAqIGFzIENvbnN0YW50cyBmcm9tICcuL2NvbnN0cyc7XG5pbXBvcnQge2xvZ2dlcn0gZnJvbSAnLi9sb2cnO1xuXG4vKipcbiAqIFN0b3JhZ2UgZm9yIGNodW5rcy5cbiAqL1xuZXhwb3J0IGNsYXNzIFN0b3JhZ2Uge1xuXG4gIC8qKlxuICAgKiBTdG9yYWdlIG1hcCBvYmplY3QuXG4gICAqXG4gICAqIEBkZXNjcmlwdGlvbiBBIHNldCBvZiBbcmVzb3VyY2UgdXJsLCByZXNvdXJjZSBjb250ZW50XS5cbiAgICovXG4gIHByaXZhdGUgcmVhZG9ubHkgc3RvcmFnZTogU2V0PFtzdHJpbmcsIFVpbnQ4QXJyYXldPjtcblxuICAvKipcbiAgICogQ29uc3RydWN0b3IuXG4gICAqL1xuICBwdWJsaWMgY29uc3RydWN0b3IoKSB7XG4gICAgdGhpcy5zdG9yYWdlID0gbmV3IFNldCgpO1xuICB9XG5cbiAgLyoqXG4gICAqIEFkZCBhIHJlc291cmNlIHRvIHN0b3JhZ2UuXG4gICAqXG4gICAqIEByZXR1cm4gVHJ1ZSBpZiBpdCB3YXMgYWRkZWQsIGZhbHNlIGlmIGl0IHdhcyBhbHJlYWR5IHByZXNlbnQuXG4gICAqL1xuICBwdWJsaWMgYWRkUmVzb3VyY2UodXJsOiBzdHJpbmcsIGNvbnRlbnQ6IFVpbnQ4QXJyYXkpOiBib29sZWFuIHtcbiAgICB1cmwgPSB1cmwuc3BsaXQoJz8nKVswXS5yZXBsYWNlKC8oaGRuKS4qXFwvL2csICcnKTtcblxuICAgIGlmICh0aGlzLmhhc1Jlc291cmNlKHVybCkpIHtcbiAgICAgIHJldHVybiBmYWxzZTtcbiAgICB9XG4gICAgaWYgKHRoaXMuc3RvcmFnZS5zaXplID49IENvbnN0YW50cy5TVE9SQUdFX1NJWkUpIHtcbiAgICAgIHRoaXMucmVtb3ZlT2xkZXN0KCk7XG4gICAgfVxuICAgIHRoaXMuc3RvcmFnZS5hZGQoW3VybCwgY29udGVudF0pO1xuICAgIHJldHVybiB0cnVlO1xuICB9XG5cbiAgLyoqXG4gICAqIFRlbGxzIGlmIHN0b3JhZ2UgaGFzIGEgcmVzb3VyY2UgYnkgaXRzIHVybC5cbiAgICovXG4gIHB1YmxpYyBoYXNSZXNvdXJjZSh1cmw6IHN0cmluZyk6IGJvb2xlYW4ge1xuICAgIHJldHVybiAodGhpcy5nZXRSZXNvdXJjZSh1cmwpICE9PSBudWxsKTtcbiAgfVxuXG4gIC8qKlxuICAgKiBHZXQgYSByZXNvdXJjZSBieSBpdHMgdXJsLlxuICAgKi9cblxuICBwdWJsaWMgZ2V0UmVzb3VyY2UodXJsOiBzdHJpbmcpOiBVaW50OEFycmF5IHwgbnVsbCB7XG4gICAgZm9yIChjb25zdCBlbnRyeSBvZiBBcnJheS5mcm9tKHRoaXMuc3RvcmFnZSkpIHtcbiAgICAgIGlmIChlbnRyeVswXSA9PT0gdXJsKSB7XG4gICAgICAgIHJldHVybiBlbnRyeVsxXTtcbiAgICAgIH1cbiAgICB9XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cbiAgcHVibGljIGdldFVwZGF0ZWRSZXNvdXJjZSgpOiBzdHJpbmcge1xuICAgbGV0IGE6IHN0cmluZyA9ICcnO1xuICAgZm9yIChjb25zdCBlbnRyeSBvZiBBcnJheS5mcm9tKHRoaXMuc3RvcmFnZS52YWx1ZXMoKSkpIHtcbiAgICAgIGEgPSAgKGVudHJ5WzBdKTtcbiAgIH1cbiAgIHJldHVybiBhO1xuIH1cblxuICAvKipcbiAgICogUmVtb3ZlcyB0aGUgb2xkZXN0IHJlc291cmNlLlxuICAgKi9cbiAgcHJpdmF0ZSByZW1vdmVPbGRlc3QoKTogdm9pZCB7XG4gICAgaWYgKHRoaXMuc3RvcmFnZS5zaXplID09PSAwKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIHRoaXMuc3RvcmFnZS5kZWxldGUodGhpcy5zdG9yYWdlLnZhbHVlcygpLm5leHQoKS52YWx1ZSk7XG4gIH1cbn1cbiJdfQ==


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = __webpack_require__(24);
	var StorageDownloading = (function () {
	    function StorageDownloading() {
	        this.storageDownloading = new Set();
	    }
	    StorageDownloading.prototype.addDownloadingResources = function (id, have, peerQuality) {
	        have = have.split('?')[0].replace(/(hdn).*\//g, '');
	        if (this.storageDownloading.size >= Constants.HAVE_STORAGE_SIZE) {
	            this.removeOldest();
	        }
	        this.storageDownloading.add([id, have, peerQuality]);
	        return true;
	    };
	    StorageDownloading.prototype.hasDownloadingResource = function (have) {
	        return (this.getDownloadingResource(have) !== null);
	    };
	    StorageDownloading.prototype.getDownloadingResource = function (have) {
	        for (var _i = 0, _a = Array.from(this.storageDownloading); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            if (entry[1] === have) {
	                return entry[0];
	            }
	        }
	        return null;
	    };
	    StorageDownloading.prototype.removeRecord = function (peerid) {
	        for (var _i = 0, _a = Array.from(this.storageDownloading); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            if (entry[1] === peerid) {
	                this.storageDownloading.delete(entry);
	            }
	        }
	    };
	    StorageDownloading.prototype.removeOldest = function () {
	        if (this.storageDownloading.size === 0) {
	            return;
	        }
	        this.storageDownloading.delete(this.storageDownloading.values().next().value);
	    };
	    return StorageDownloading;
	}());
	exports.StorageDownloading = StorageDownloading;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9pc2hhbmkvdGhlc2lzL3NyYy9TdG9yYWdlRG93bmxvYWRpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvQ0FBc0M7QUFLdEM7SUFXRTtRQUNFLElBQUksQ0FBQyxrQkFBa0IsR0FBRyxJQUFJLEdBQUcsRUFBRSxDQUFDO0lBQ3RDLENBQUM7SUFNTyxvREFBdUIsR0FBOUIsVUFBK0IsRUFBVyxFQUFFLElBQVksRUFBRyxXQUFtQjtRQUM5RSxJQUFJLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsWUFBWSxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ3BELElBQUksSUFBSSxDQUFDLGtCQUFrQixDQUFDLElBQUksSUFBSSxTQUFTLENBQUMsaUJBQWlCLEVBQUU7WUFDL0QsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1NBQ3BCO1FBQ0YsSUFBSSxDQUFDLGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxDQUFDLEVBQUUsRUFBRSxJQUFJLEVBQUUsV0FBVyxDQUFDLENBQUMsQ0FBQztRQUNyRCxPQUFPLElBQUksQ0FBQztJQUNYLENBQUM7SUFJSSxtREFBc0IsR0FBN0IsVUFBOEIsSUFBWTtRQUN4QyxPQUFPLENBQUMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksQ0FBQyxDQUFDO0lBQ3RELENBQUM7SUFNTSxtREFBc0IsR0FBN0IsVUFBOEIsSUFBWTtRQUN4QyxLQUFvQixVQUFtQyxFQUFuQyxLQUFBLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLGtCQUFrQixDQUFDLEVBQW5DLGNBQW1DLEVBQW5DLElBQW1DLEVBQUU7WUFBcEQsSUFBTSxLQUFLLFNBQUE7WUFDZCxJQUFJLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxJQUFJLEVBQUU7Z0JBQ25CLE9BQU8sS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO2FBQ2pCO1NBQ0o7UUFDRCxPQUFPLElBQUksQ0FBQztJQUNkLENBQUM7SUFJTSx5Q0FBWSxHQUFuQixVQUFvQixNQUFjO1FBQ2hDLEtBQW9CLFVBQW1DLEVBQW5DLEtBQUEsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsa0JBQWtCLENBQUMsRUFBbkMsY0FBbUMsRUFBbkMsSUFBbUMsRUFBRTtZQUFwRCxJQUFNLEtBQUssU0FBQTtZQUNkLElBQUksS0FBSyxDQUFDLENBQUMsQ0FBQyxLQUFLLE1BQU0sRUFBRTtnQkFDckIsSUFBSSxDQUFDLGtCQUFrQixDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQzthQUN2QztTQUNKO0lBQ0gsQ0FBQztJQUNPLHlDQUFZLEdBQXBCO1FBQ0UsSUFBSSxJQUFJLENBQUMsa0JBQWtCLENBQUMsSUFBSSxLQUFLLENBQUMsRUFBRTtZQUN0QyxPQUFPO1NBQ1I7UUFDRCxJQUFJLENBQUMsa0JBQWtCLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNoRixDQUFDO0lBQ0gseUJBQUM7QUFBRCxDQTlEQSxBQThEQyxJQUFBO0FBOURZLGdEQUFrQiIsImZpbGUiOiJTdG9yYWdlRG93bmxvYWRpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBDb25zdGFudHMgZnJvbSAnLi9jb25zdHMnO1xuaW1wb3J0IHtsb2dnZXJ9IGZyb20gJy4vbG9nJztcbi8qKlxuICogU3RvcmFnZSBmb3IgY2h1bmtzLlxuICovXG5leHBvcnQgY2xhc3MgU3RvcmFnZURvd25sb2FkaW5nIHtcblxuICAvKipcbiAgICogU3RvcmFnZSBtYXAgb2JqZWN0LlxuICAgKlxuICAgKiBAZGVzY3JpcHRpb24gQSBzZXQgb2YgW3Jlc291cmNlIHVybCwgcmVzb3VyY2UgY29udGVudF0uXG4gICAqL1xuICBwcml2YXRlIHJlYWRvbmx5IHN0b3JhZ2VEb3dubG9hZGluZzogU2V0PFtzdHJpbmcsIHN0cmluZywgbnVtYmVyXT47XG4gIC8qKlxuICAgKiBDb25zdHJ1Y3Rvci5cbiAgICovXG4gIHB1YmxpYyBjb25zdHJ1Y3RvcigpIHtcbiAgICB0aGlzLnN0b3JhZ2VEb3dubG9hZGluZyA9IG5ldyBTZXQoKTtcbiAgfVxuICAvKipcbiAgICogQWRkIGEgcmVzb3VyY2UgdG8gc3RvcmFnZS5cbiAgICpcbiAgICogQHJldHVybiBUcnVlIGlmIGl0IHdhcyBhZGRlZCwgZmFsc2UgaWYgaXQgd2FzIGFscmVhZHkgcHJlc2VudC5cbiAgICovXG4gICBwdWJsaWMgYWRkRG93bmxvYWRpbmdSZXNvdXJjZXMoaWQgOiBzdHJpbmcsIGhhdmU6IHN0cmluZyAsIHBlZXJRdWFsaXR5OiBudW1iZXIpOiBib29sZWFuIHtcbiAgIGhhdmUgPSBoYXZlLnNwbGl0KCc/JylbMF0ucmVwbGFjZSgvKGhkbikuKlxcLy9nLCAnJyk7XG4gICBpZiAodGhpcy5zdG9yYWdlRG93bmxvYWRpbmcuc2l6ZSA+PSBDb25zdGFudHMuSEFWRV9TVE9SQUdFX1NJWkUpIHtcbiAgICAgdGhpcy5yZW1vdmVPbGRlc3QoKTtcbiAgICB9XG4gICB0aGlzLnN0b3JhZ2VEb3dubG9hZGluZy5hZGQoW2lkLCBoYXZlLCBwZWVyUXVhbGl0eV0pO1xuICAgcmV0dXJuIHRydWU7XG4gICAgfVxuICAvKipcbiAgICogVGVsbHMgaWYgc3RvcmFnZSBoYXMgYSByZXNvdXJjZSBieSBpdHMgdXJsLlxuICAgKi9cbiAgcHVibGljIGhhc0Rvd25sb2FkaW5nUmVzb3VyY2UoaGF2ZTogc3RyaW5nKTogYm9vbGVhbiB7XG4gICAgcmV0dXJuICh0aGlzLmdldERvd25sb2FkaW5nUmVzb3VyY2UoaGF2ZSkgIT09IG51bGwpO1xuICB9XG5cbiAgLyoqXG4gICAqIEdldCBhIHJlc291cmNlIGJ5IGl0cyB1cmwuXG4gICAqL1xuXG4gIHB1YmxpYyBnZXREb3dubG9hZGluZ1Jlc291cmNlKGhhdmU6IHN0cmluZyk6ICBzdHJpbmcgfCBudW1iZXIgICAge1xuICAgIGZvciAoY29uc3QgZW50cnkgb2YgQXJyYXkuZnJvbSh0aGlzLnN0b3JhZ2VEb3dubG9hZGluZykpIHtcbiAgICAgIGlmIChlbnRyeVsxXSA9PT0gaGF2ZSkge1xuICAgICAgICAgIHJldHVybiBlbnRyeVswXTtcbiAgICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuICAvKipcbiAgICogUmVtb3ZlcyB0aGUgb2xkZXN0IHJlc291cmNlLlxuICAgKi9cbiAgcHVibGljIHJlbW92ZVJlY29yZChwZWVyaWQ6IHN0cmluZyk6IHZvaWQge1xuICAgIGZvciAoY29uc3QgZW50cnkgb2YgQXJyYXkuZnJvbSh0aGlzLnN0b3JhZ2VEb3dubG9hZGluZykpIHtcbiAgICAgIGlmIChlbnRyeVsxXSA9PT0gcGVlcmlkKSB7XG4gICAgICAgICAgdGhpcy5zdG9yYWdlRG93bmxvYWRpbmcuZGVsZXRlKGVudHJ5KTtcbiAgICAgICAgfVxuICAgIH1cbiAgfVxuICBwcml2YXRlIHJlbW92ZU9sZGVzdCgpOiB2b2lkIHtcbiAgICBpZiAodGhpcy5zdG9yYWdlRG93bmxvYWRpbmcuc2l6ZSA9PT0gMCkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICB0aGlzLnN0b3JhZ2VEb3dubG9hZGluZy5kZWxldGUodGhpcy5zdG9yYWdlRG93bmxvYWRpbmcudmFsdWVzKCkubmV4dCgpLnZhbHVlKTtcbiAgfVxufVxuIl19


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = __webpack_require__(24);
	var StorageHave = (function () {
	    function StorageHave() {
	        this.storageHave = new Set();
	    }
	    StorageHave.prototype.addHaveResources = function (id, have, peerQuality) {
	        have = have.split('?')[0].replace(/(hdn).*\//g, '');
	        if (this.storageHave.size >= Constants.HAVE_STORAGE_SIZE) {
	            this.removeOldest();
	        }
	        this.storageHave.add([id, have, peerQuality]);
	        return true;
	    };
	    StorageHave.prototype.hasHaveResource = function (have) {
	        return (this.getHaveResource(have) !== null);
	    };
	    StorageHave.prototype.show_Memory = function () {
	        for (var _i = 0, _a = Array.from(this.storageHave); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            return (entry[0][1]);
	        }
	    };
	    StorageHave.prototype.removeRecord = function (peerid) {
	        for (var _i = 0, _a = Array.from(this.storageHave); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            if (entry[1] === peerid) {
	                this.storageHave.delete(entry);
	            }
	        }
	    };
	    StorageHave.prototype.getsortedResource = function (have) {
	        var result = new Array();
	        for (var _i = 0, _a = Array.from(this.storageHave); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            result.push(entry);
	        }
	        result = result.sort(function (a, b) {
	            return (b[2] - a[2]);
	        });
	        return result;
	    };
	    StorageHave.prototype.getHaveResource = function (have) {
	        var ans = this.getsortedResource(have);
	        for (var _i = 0, _a = Array.from(ans); _i < _a.length; _i++) {
	            var entry = _a[_i];
	            if (entry[1] === have) {
	                return entry[0];
	            }
	        }
	    };
	    StorageHave.prototype.removeOldest = function () {
	        if (this.storageHave.size === 0) {
	            return;
	        }
	        this.storageHave.delete(this.storageHave.values().next().value);
	    };
	    return StorageHave;
	}());
	exports.StorageHave = StorageHave;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Constants = __webpack_require__(24);
	var log_1 = __webpack_require__(65);
	var Peer_1 = __webpack_require__(72);
	var events_1 = __webpack_require__(68);
	var Swarm = (function (_super) {
	    __extends(Swarm, _super);
	    function Swarm(manager) {
	        var _this = _super.call(this) || this;
	        _this.manager = manager;
	        _this.peers = new Map();
	        _this.pairingInProgressList = new Map();
	        _this.busySlots = 0;
	        _this.manager.on('roomUpdated', function (peerInfo) {
	            _this.stopPopulate();
	            _this.empty();
	        });
	        return _this;
	    }
	    Swarm.prototype.isFull = function () {
	        return this.peers.size >= Constants.SWARM_SIZE;
	    };
	    Swarm.prototype.getSize = function () {
	        return this.peers.size;
	    };
	    Swarm.prototype.getParticipators = function () {
	        var ret = [];
	        this.peers.forEach(function (value, key) {
	            if (value.isParticipator()) {
	                ret.push(value);
	            }
	        });
	        return ret;
	    };
	    Swarm.prototype.getParticipatorsIds = function () {
	        return this.getParticipators().map(function (value) { return value.id; });
	    };
	    Swarm.prototype.hasPeer = function (peer) {
	        if (peer instanceof Peer_1.Peer) {
	            return this.peers.has(peer.id);
	        }
	        else if (typeof peer === 'string') {
	            return this.peers.has(peer);
	        }
	    };
	    Swarm.prototype.getPeer = function (peer) {
	        if (this.peers.has(peer)) {
	            return this.peers.get(peer);
	        }
	        return null;
	    };
	    Swarm.prototype.deletePeer = function (peer) {
	        if (this.peers.has(peer)) {
	            this.peers.delete(peer);
	            return null;
	        }
	    };
	    Swarm.prototype.add = function (peer, sendOffer) {
	        var _this = this;
	        if (sendOffer === void 0) { sendOffer = false; }
	        if (this.pairingInProgressList.has(peer.id)) {
	            window.clearTimeout(this.pairingInProgressList.get(peer.id));
	            this.pairingInProgressList.delete(peer.id);
	            this.peers.delete(peer.id);
	            this.manager.offerPeers = this.manager.offerPeers - 1;
	            log_1.logger().debug('Retrying sending offer', this.manager.offerPeers);
	        }
	        if (this.isFull()) {
	            peer.close();
	            return;
	        }
	        peer.setInitiator(!sendOffer);
	        peer.on('sentSatisfy', function (contentLength) {
	            _this.manager.emit('v2vSent', contentLength);
	        });
	        this.peers.set(peer.id, peer);
	        this.emit('sizeChanged', this.peers.size);
	        if (sendOffer) {
	            peer.sendOffer()
	                .catch(function (err) {
	                log_1.logger().warn("Could not send offer to " + peer.id + ": " + err);
	                _this.peers.delete(peer.id);
	                peer.close();
	                _this.emit('sizeChanged', _this.peers.size);
	            });
	        }
	        peer.on('disconnected', function () {
	            _this.peers.delete(peer.id);
	            _this.emit('sizeChanged', _this.peers.size);
	        });
	        peer.on('startSending', function () {
	            _this.busySlots = _this.busySlots + 1;
	            log_1.logger().debug("Using upload slot [" + _this.busySlots + "/" + Constants.UPLOAD_SLOTS + "]");
	        });
	        peer.on('finishedSending', function () {
	            _this.busySlots = _this.busySlots - 1;
	            log_1.logger().debug("Freeing upload slot [" + _this.busySlots + "/" + Constants.UPLOAD_SLOTS + "]");
	        });
	        return;
	    };
	    Swarm.prototype.empty = function () {
	        var _this = this;
	        var previousSize = this.peers.size;
	        this.peers.forEach(function (peer) {
	            peer.close();
	            if (_this.pairingInProgressList.has(peer.id)) {
	                window.clearTimeout(_this.pairingInProgressList.get(peer.id));
	            }
	        });
	        this.peers.clear();
	        this.pairingInProgressList.clear();
	        this.manager.offerPeers = 0;
	        this.manager.answerPeers = 0;
	    };
	    Swarm.prototype.startPopulate = function () {
	        var _this = this;
	        if (!this.populateTimer) {
	            this.manager.askPeers();
	        }
	        else {
	            this.stopPopulate();
	        }
	        this.populateTimer = window.setInterval(function () {
	            if (_this.getSize() >= Constants.SWARM_SIZE) {
	                return null;
	            }
	            else {
	                _this.manager.askPeers();
	            }
	        }, Constants.SWARM_POPULATE_INTERVAL);
	    };
	    Swarm.prototype.stopPopulate = function () {
	        if (this.populateTimer) {
	            window.clearInterval(this.populateTimer);
	            this.populateTimer = undefined;
	        }
	    };
	    Swarm.prototype.startedDownloading = function (id, url) {
	        this.peers.forEach(function (peer) {
	            return peer.sendDownloading(id, url);
	        });
	    };
	    Swarm.prototype.swarmUpdate = function (id, resource) {
	        this.peers.forEach(function (peer) {
	            return peer.sendHave(id, resource);
	        });
	    };
	    Swarm.prototype.pairingInProgress = function (peer) {
	        var _this = this;
	        if (!this.peers.has(peer)) {
	            return;
	        }
	        log_1.logger().debug("Pairing in progress with " + peer + ", retrying in a few or waiting for another request");
	        this.peers.get(peer);
	        this.peers.delete(peer);
	        this.pairingInProgressList.set(peer, window.setTimeout(function () {
	            var newPeer = new Peer_1.Peer(_this.manager, peer);
	            _this.add(newPeer, true);
	        }, 5000 + Math.ceil(Math.random() * 5000)));
	    };
	    Swarm.prototype.isPairingInProgress = function (peer) {
	        return this.pairingInProgressList.has(peer);
	    };
	    Swarm.prototype.hasFreeSlots = function () {
	        return this.busySlots < Constants.UPLOAD_SLOTS;
	    };
	    Swarm.prototype.checkPeerStatus = function () {
	        for (var _i = 0, _a = Array.from(this.peers.values()); _i < _a.length; _i++) {
	            var peer = _a[_i];
	            if (peer.status === Peer_1.PeerStatus.CONNECTING) {
	                this.peers.delete(peer.id);
	                peer.close();
	                this.manager.offerPeers = this.manager.offerPeers - 1;
	                return true;
	            }
	        }
	    };
	    return Swarm;
	}(events_1.EventEmitter));
	exports.Swarm = Swarm;
	
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function() {
		return __webpack_require__(87)("/******/ (function(modules) { // webpackBootstrap\n/******/ \t// The module cache\n/******/ \tvar installedModules = {};\n/******/\n/******/ \t// The require function\n/******/ \tfunction __webpack_require__(moduleId) {\n/******/\n/******/ \t\t// Check if module is in cache\n/******/ \t\tif(installedModules[moduleId])\n/******/ \t\t\treturn installedModules[moduleId].exports;\n/******/\n/******/ \t\t// Create a new module (and put it into the cache)\n/******/ \t\tvar module = installedModules[moduleId] = {\n/******/ \t\t\texports: {},\n/******/ \t\t\tid: moduleId,\n/******/ \t\t\tloaded: false\n/******/ \t\t};\n/******/\n/******/ \t\t// Execute the module function\n/******/ \t\tmodules[moduleId].call(module.exports, module, module.exports, __webpack_require__);\n/******/\n/******/ \t\t// Flag the module as loaded\n/******/ \t\tmodule.loaded = true;\n/******/\n/******/ \t\t// Return the exports of the module\n/******/ \t\treturn module.exports;\n/******/ \t}\n/******/\n/******/\n/******/ \t// expose the modules object (__webpack_modules__)\n/******/ \t__webpack_require__.m = modules;\n/******/\n/******/ \t// expose the module cache\n/******/ \t__webpack_require__.c = installedModules;\n/******/\n/******/ \t// __webpack_public_path__\n/******/ \t__webpack_require__.p = \"\";\n/******/\n/******/ \t// Load entry module and return exports\n/******/ \treturn __webpack_require__(0);\n/******/ })\n/************************************************************************/\n/******/ ([\n/* 0 */\n/***/ (function(module, exports) {\n\n\t(function () {\n\t    var error = function (reason) {\n\t        postMessage({ success: false, error: reason });\n\t    };\n\t    var success = function (data) {\n\t        postMessage({ success: true, buffer: data }, [data]);\n\t    };\n\t    var doFetch = function (url) {\n\t        fetch(url)\n\t            .then(function (r) { return r.arrayBuffer(); })\n\t            .then(function (b) { success(b); })\n\t            .catch(function (err) { error(err.message); });\n\t    };\n\t    var doXhr = function (url) {\n\t        var xhr = new XMLHttpRequest();\n\t        xhr.responseType = 'arraybuffer';\n\t        xhr.onload = function () {\n\t            if ((xhr.status >= 200) && (xhr.status <= 299)) {\n\t                success(xhr.response);\n\t                return;\n\t            }\n\t            error(\"Request returned a \" + xhr.status + \" status code\");\n\t        };\n\t        xhr.onerror = function (e) {\n\t            error(e.error.message);\n\t        };\n\t        xhr.open('GET', url, true);\n\t    };\n\t    addEventListener('message', function (event) {\n\t        if (typeof self.fetch === 'function') {\n\t            doFetch(event.data.url);\n\t        }\n\t        else {\n\t            doXhr(event.data.url);\n\t        }\n\t    });\n\t})();\n\t\n\t//# sourceMappingURL=data:application/json;charset=utf8;base64,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\n\n\n/***/ })\n/******/ ]);\n//# sourceMappingURL=2fa095bd1d5a8e131669.worker.js.map", null);
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// http://stackoverflow.com/questions/10343913/how-to-create-a-web-worker-from-a-string
	
	var URL = window.URL || window.webkitURL;
	module.exports = function(content, url) {
	  try {
	    try {
	      var blob;
	      try { // BlobBuilder = Deprecated, but widely implemented
	        var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	        blob = new BlobBuilder();
	        blob.append(content);
	        blob = blob.getBlob();
	      } catch(e) { // The proposed API
	        blob = new Blob([content]);
	      }
	      return new Worker(URL.createObjectURL(blob));
	    } catch(e) {
	      return new Worker('data:application/javascript,' + encodeURIComponent(content));
	    }
	  } catch(e) {
	    if (!url) {
	      throw Error('Inline worker is not supported');
	    }
	    return new Worker(url);
	  }
	}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./Register.js": 70
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 88;


/***/ })
/******/ ])
});
;
//# sourceMappingURL=eb.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/EBLib/built/js/eb.js
// module id = 174
// module chunks = 0